import * as i0 from '@angular/core';
import { numberAttribute, input, computed, Component, ChangeDetectionStrategy, ViewEncapsulation, booleanAttribute, effect, Attribute, forwardRef, inject, ChangeDetectorRef, model, viewChild, Directive, ElementRef, signal, NgModule, contentChild, output, Renderer2, contentChildren, NgZone, InjectionToken, RendererFactory2, Injectable } from '@angular/core';
import { NG_VALUE_ACCESSOR, NG_VALIDATORS } from '@angular/forms';
import { NgTemplateOutlet, NgIf, NgClass, DOCUMENT, NgComponentOutlet } from '@angular/common';
import { toSignal } from '@angular/core/rxjs-interop';
import { RouterLinkActive } from '@angular/router';
import { BreakpointObserver } from '@angular/cdk/layout';
import { Overlay } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import { trigger, transition, style, sequence, animate, group } from '@angular/animations';

/**
 * VARIANTS is an array of all possible variants. Used to define `Variant` union type. Useful for looping through all possible variants.
 */
const _c0 = ["tds-button", ""];
const _c1 = [[["tds-icon"]], "*"];
const _c2 = ["tds-icon", "*"];
const _c3 = ["tds-layer", ""];
const _c4 = ["*"];
const _c5 = ["tds-link", ""];
const _c6 = ["*", [["tds-icon"]]];
const _c7 = ["*", "tds-icon"];
function LinkComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "tds-icon", 0);
  }
}
function LinkComponent_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵprojection(0, 1);
  }
}
const _c8 = ["input"];
const _c9 = [[["", "tds-radio-input", ""]], [["", "tds-radio-label", ""]]];
const _c10 = ["[tds-radio-input]", "[tds-radio-label]"];
const _c11 = [[["tds-field-hint"]], [["tds-field-error"]]];
const _c12 = ["tds-field-hint", "tds-field-error"];
function FieldHelperComponent_Conditional_0_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function FieldHelperComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "tds-icon", 3);
    i0.ɵɵelementStart(1, "span", 2);
    i0.ɵɵtemplate(2, FieldHelperComponent_Conditional_0_ng_container_2_Template, 1, 0, "ng-container", 4);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵnextContext();
    const error_r1 = i0.ɵɵreference(5);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", error_r1);
  }
}
function FieldHelperComponent_Conditional_1_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function FieldHelperComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 2);
    i0.ɵɵtemplate(1, FieldHelperComponent_Conditional_1_ng_container_1_Template, 1, 0, "ng-container", 4);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵnextContext();
    const hint_r2 = i0.ɵɵreference(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", hint_r2);
  }
}
function FieldHelperComponent_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵprojection(0);
  }
}
function FieldHelperComponent_ng_template_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵprojection(0, 1);
  }
}
const _c13 = ["tds-sr-only", ""];
const _c14 = [[["tds-form-field-label"]], [["", "tds-form-field-item", ""]], [["tds-form-field-suffix"]], [["tds-form-field-hint"]], [["tds-form-field-error"]]];
const _c15 = ["tds-form-field-label", "[tds-form-field-item]", "tds-form-field-suffix", "tds-form-field-hint", "tds-form-field-error"];
const _c16 = ["tds-typography", ""];
const _c17 = ["tds-fieldset", ""];
const _c18 = [[["tds-fieldset-label"]], "*", [["tds-fieldset-hint"]], [["tds-fieldset-error"]]];
const _c19 = ["tds-fieldset-label", "*", "tds-fieldset-hint", "tds-fieldset-error"];
const _c20 = ["tds-icon-button", ""];
const _c21 = [[["input"]]];
function SearchComponent_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 2);
    i0.ɵɵlistener("click", function SearchComponent_Conditional_2_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.clearInput());
    });
    i0.ɵɵelement(1, "tds-icon", 3);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("label", ctx_r1.clearIconLabel());
  }
}
function TagComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 1);
    i0.ɵɵlistener("click", function TagComponent_Conditional_1_Template_button_click_0_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onClose($event));
    });
    i0.ɵɵelement(1, "tds-icon", 2);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("label", ctx_r1.closeIconButtonLabel());
  }
}
const _c22 = ["tds-header-navigation-link", ""];
const _c23 = ["tds-header-navigation", ""];
const _c24 = [[["", "tds-header-navigation-link", ""]]];
const _c25 = ["[tds-header-navigation-link]"];
const _c26 = ["tds-header-app-name", ""];
const _c27 = [[["", "tds-header-app-logo", ""]]];
const _c28 = ["[tds-header-app-logo]"];
const _c29 = [[["tds-header-mobile-menu-start"]], [["tds-header-mobile-menu-end"]]];
const _c30 = ["tds-header-mobile-menu-start", "tds-header-mobile-menu-end"];
const _c31 = ["tds-header", ""];
const _c32 = [[["", "tds-header-app-name", ""]], [["tds-header-center"]], [["tds-header-end"]], [["tds-header-mobile-menu"]]];
const _c33 = ["[tds-header-app-name]", "tds-header-center", "tds-header-end", "tds-header-mobile-menu"];
const _c34 = ["tds-header-mobile-menu-action", ""];
const _c35 = [[["", "tds-header", ""]], "*"];
const _c36 = ["[tds-header]", "*"];
const _c37 = ["tds-tile", ""];
const _c38 = [[["", "tds-tile-image", ""]], [["tds-tile-title"]], "*"];
const _c39 = ["[tds-tile-image]", "tds-tile-title", "*"];
const _c40 = [[["tds-notification-title"]], "*"];
const _c41 = ["tds-notification-title", "*"];
function NotificationComponent_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 4);
    i0.ɵɵlistener("click", function NotificationComponent_Conditional_5_Template_button_click_0_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onClose($event));
    });
    i0.ɵɵelement(1, "tds-icon", 5);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("label", ctx_r1.closeIconButtonLabel());
  }
}
const _c42 = a0 => ({
  $implicit: a0
});
const _forTrack0 = ($index, $item) => $item.id;
const _c43 = a0 => ({
  value: a0
});
const _c44 = (a0, a1) => ({
  $implicit: a0,
  projected: a1
});
const _c45 = (a0, a1) => ({
  $implicit: a0,
  extra: a1
});
function NotificationContainerComponent_For_2_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "tds-notification-title");
    i0.ɵɵelementContainer(1, 3);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const notification_r2 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵnextContext();
    const content_r4 = i0.ɵɵreference(4);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", content_r4)("ngTemplateOutletContext", i0.ɵɵpureFunction2(2, _c44, notification_r2.title, notification_r2.title));
  }
}
function NotificationContainerComponent_For_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "tds-notification", 2);
    i0.ɵɵlistener("close", function NotificationContainerComponent_For_2_Template_tds_notification_close_0_listener() {
      const notification_r2 = i0.ɵɵrestoreView(_r1).$implicit;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.closeNotification(notification_r2));
    });
    i0.ɵɵtemplate(1, NotificationContainerComponent_For_2_Conditional_1_Template, 2, 5, "tds-notification-title");
    i0.ɵɵelementContainer(2, 3);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    let tmp_17_0;
    const notification_r2 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext();
    const content_r4 = i0.ɵɵreference(4);
    i0.ɵɵproperty("closeIconButtonLabel", notification_r2.closeIconButtonLabel)("isInline", false)("shouldAutoDestroyOnClose", false)("status", notification_r2 == null ? null : notification_r2.status)("@notification", i0.ɵɵpureFunction1(8, _c43, ctx_r2.animationName()));
    i0.ɵɵadvance();
    i0.ɵɵconditional((tmp_17_0 = notification_r2 == null ? null : notification_r2.title) ? 1 : -1, tmp_17_0);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", content_r4)("ngTemplateOutletContext", i0.ɵɵpureFunction2(10, _c44, notification_r2, notification_r2.content));
  }
}
function NotificationContainerComponent_ng_template_3_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0, 3);
  }
  if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    const notification_r6 = ctx_r4.$implicit;
    const projected_r7 = ctx_r4.projected;
    i0.ɵɵproperty("ngTemplateOutlet", projected_r7 == null ? null : projected_r7.template)("ngTemplateOutletContext", i0.ɵɵpureFunction2(2, _c45, notification_r6, projected_r7 == null ? null : projected_r7.extra));
  }
}
function NotificationContainerComponent_ng_template_3_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0, 4);
  }
  if (rf & 2) {
    const projected_r7 = i0.ɵɵnextContext().projected;
    i0.ɵɵproperty("ngComponentOutlet", projected_r7 == null ? null : projected_r7.component)("ngComponentOutletInputs", projected_r7 == null ? null : projected_r7.inputs);
  }
}
function NotificationContainerComponent_ng_template_3_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
  }
  if (rf & 2) {
    const projected_r7 = i0.ɵɵnextContext().projected;
    i0.ɵɵtextInterpolate1(" ", projected_r7, " ");
  }
}
function NotificationContainerComponent_ng_template_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, NotificationContainerComponent_ng_template_3_Conditional_0_Template, 1, 5, "ng-container", 3)(1, NotificationContainerComponent_ng_template_3_Conditional_1_Template, 1, 2, "ng-container", 4)(2, NotificationContainerComponent_ng_template_3_Conditional_2_Template, 1, 1);
  }
  if (rf & 2) {
    const projected_r7 = ctx.projected;
    i0.ɵɵconditional(projected_r7.template ? 0 : projected_r7.component ? 1 : 2);
  }
}
const _c46 = ["tds-segmented-control-option", ""];
const VARIANTS = ['primary', 'secondary', 'tertiary'];
/**
 * STATUS_VARIANTS is an array of all possible status variants. Used to define `StatusVariant` union type. Useful for looping through all possible status variants.
 */
const STATUS_VARIANTS = ['info', 'success', 'danger', 'warning'];
/**
 * ACCENT_VARIANTS is an array of all possible accent variants. Used to define `AccentVariant` union type. Useful for looping through all possible accent variants.
 */
const ACCENT_VARIANTS = ['red', 'green', 'blue', 'yellow', 'grey', 'orange', 'teal', 'purple', 'pink'];

/**
 * SIZES is an array of all the sizes available. Used to define `Size` union type. Useful for looping through all possible sizes.
 */
const SIZES = ['sm', 'md', 'lg'];

/**
 * orientation array. Used to define `Orientation` union type. Useful for looping through all possible orientations.
 */
const ORIENTATIONS = ['horizontal', 'vertical'];

/**
 * THEMES is an array of available themes. Used to define `Theme` union type. Useful for looping through all possible themes.
 */
const THEMES = ['light', 'dark', 'system'];

/**
 * Aspect ratio array. Used to define `AspectRatio` union type. Useful for looping through all possible aspect ratios.
 */
const ASPECT_RATIOS = ['auto', '1/1', '1/2', '2/1', '2/3', '3/1', '3/2', '3/4', '4/1', '4/3', '4/5', '5/2', '5/4', '6/7', '8/3', '8/5', '9/8', '9/16', '9/21', '10/16', '14/3', '16/5', '16/9', '16/10', '21/9', 'golden-ratio-landscape', 'golden-ratio-portrait', 'A4-landscape', 'A4-portrait'];

/**
 * Design system breakpoints
 */
const TDS_BREAKPOINTS = {
  mobile: '576px'
};
/**
 * Custom `@angular/cdk` breakpoints with `TDS_BREAKPOINTS` values
 */
const CUSTOM_CDK_BREAKPOINTS = {
  mobile: `(max-width: ${TDS_BREAKPOINTS.mobile})`
};

/**
 * BUTTON_VARIANTS is an array of all possible button variants. Used to define `ButtonVariant` union type. Useful for looping through all possible button variants.
 */
const BUTTON_VARIANTS = [...VARIANTS];
/**
 * BUTTON_SIZES is an array of all possible button sizes. Used to define `ButtonSize` union type. Useful for looping through all possible button sizes.
 */
const BUTTON_SIZES = ['md', 'lg'];

/**
 * Default variant in most cases.
 */
const DEFAULT_VARIANT_VALUE = 'primary';
/**
 * Default size in most cases.
 */
const DEFAULT_SIZE_VALUE = 'md';
/**
 * Inherit value sometimes used for components properties that can be inherited like color or size.
 */
const INHERIT_VALUE = 'inherit';
const tabIndexTransform = value => {
  return value == null ? undefined : numberAttribute(value);
};
const genRandomId = prefix => `${prefix}-${Math.random().toString(16).substring(7)}`;
const BUTTON_HOST = {
  // Add a default class to the button and classes based on the inputs values
  '[class]': 'classes()'
};
class ButtonComponent {
  defaultClass = 'tds-button';
  /**
   * Button variant
   * @default 'primary'
   */
  variant = input();
  /**
   * Button size
   * @default 'md'
   */
  size = input();
  variantClass = computed(() => {
    return this.variant() && this.variant() !== DEFAULT_VARIANT_VALUE ? `tds-button--${this.variant()}` : '';
  });
  sizeClass = computed(() => {
    return this.size() && this.size() !== DEFAULT_SIZE_VALUE ? `tds-button--${this.size()}` : '';
  });
  classes = computed(() => {
    return `${this.defaultClass} ${this.variantClass()} ${this.sizeClass()}`;
  });
  static ɵfac = function ButtonComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || ButtonComponent)();
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: ButtonComponent,
    selectors: [["button", "tds-button", ""]],
    hostVars: 2,
    hostBindings: function ButtonComponent_HostBindings(rf, ctx) {
      if (rf & 2) {
        i0.ɵɵclassMap(ctx.classes());
      }
    },
    inputs: {
      variant: [1, "variant"],
      size: [1, "size"]
    },
    standalone: true,
    features: [i0.ɵɵStandaloneFeature],
    attrs: _c0,
    ngContentSelectors: _c2,
    decls: 2,
    vars: 0,
    template: function ButtonComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵprojectionDef(_c1);
        i0.ɵɵprojection(0);
        i0.ɵɵprojection(1, 1);
      }
    },
    styles: [".tds-button{--tds-local-button-border-width:var(--tds-size-border-medium);--tds-local-button-size-height-md:32px;--tds-local-button-size-height-lg:40px;all:unset;align-items:center;background:var(--tds-local-button-color-bg);border:var(--tds-local-button-border-width) solid var(--tds-local-button-color-border);border-radius:var(--tds-size-radius-rounded);color:var(--tds-local-button-color-text);display:inline-flex;font:var(--tds-font-body-2);font-weight:var(--tds-font-weight-600);justify-content:center;min-height:var(--tds-local-button-size-height);padding:var(--tds-size-spacing-000) calc(var(--tds-size-spacing-200) - var(--tds-local-button-border-width));-webkit-font-smoothing:antialiased;cursor:pointer}.tds-button,.tds-button *,.tds-button :after,.tds-button :before{box-sizing:border-box}.tds-button:focus-visible{outline:solid var(--tds-size-border-medium) var(--tds-color-border-focus);outline-offset:var(--tds-size-spacing-025)}.tds-button:hover:not(:disabled):not(:active){background:var(--tds-local-button-color-bg-hover)}.tds-button:active:not(:disabled){background:var(--tds-local-button-color-bg-active)}.tds-button:disabled{cursor:not-allowed;opacity:var(--tds-opacity-disabled)}.tds-button:has(.tds-icon){gap:var(--tds-size-spacing-100)}.tds-button,.tds-button--primary{--tds-local-button-color-text:var(--tds-component-button-color-foreground-primary);--tds-local-button-color-bg:var(--tds-component-button-color-background-primary-default);--tds-local-button-color-bg-hover:var(--tds-component-button-color-background-primary-hover);--tds-local-button-color-bg-active:var(--tds-component-button-color-background-primary-active);--tds-local-button-color-border:var(--tds-component-button-color-border-primary)}.tds-button--secondary{--tds-local-button-color-text:var(--tds-component-button-color-foreground-secondary);--tds-local-button-color-bg:var(--tds-component-button-color-background-secondary-default);--tds-local-button-color-bg-hover:var(--tds-component-button-color-background-secondary-hover);--tds-local-button-color-bg-active:var(--tds-component-button-color-background-secondary-active);--tds-local-button-color-border:var(--tds-component-button-color-border-secondary)}.tds-button--tertiary{--tds-local-button-color-text:var(--tds-component-button-color-foreground-tertiary);--tds-local-button-color-bg:var(--tds-component-button-color-background-tertiary-default);--tds-local-button-color-bg-hover:var(--tds-component-button-color-background-tertiary-hover);--tds-local-button-color-bg-active:var(--tds-component-button-color-background-tertiary-active);--tds-local-button-color-border:var(--tds-component-button-color-border-tertiary)}.tds-button,.tds-button--md{--tds-local-button-size-height:var(--tds-local-button-size-height-md)}.tds-button--lg{--tds-local-button-size-height:var(--tds-local-button-size-height-lg)}.tds-button .tds-icon{--tds-local-icon-size:var(--tds-component-icon-size-sm);--tds-local-icon-color-text:inherit}\n"],
    encapsulation: 2,
    changeDetection: 0
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ButtonComponent, [{
    type: Component,
    args: [{
      selector: 'button[tds-button]',
      standalone: true,
      imports: [],
      host: BUTTON_HOST,
      changeDetection: ChangeDetectionStrategy.OnPush,
      encapsulation: ViewEncapsulation.None,
      template: "<ng-content select=\"tds-icon\"></ng-content>\n<ng-content></ng-content>\n",
      styles: [".tds-button{--tds-local-button-border-width:var(--tds-size-border-medium);--tds-local-button-size-height-md:32px;--tds-local-button-size-height-lg:40px;all:unset;align-items:center;background:var(--tds-local-button-color-bg);border:var(--tds-local-button-border-width) solid var(--tds-local-button-color-border);border-radius:var(--tds-size-radius-rounded);color:var(--tds-local-button-color-text);display:inline-flex;font:var(--tds-font-body-2);font-weight:var(--tds-font-weight-600);justify-content:center;min-height:var(--tds-local-button-size-height);padding:var(--tds-size-spacing-000) calc(var(--tds-size-spacing-200) - var(--tds-local-button-border-width));-webkit-font-smoothing:antialiased;cursor:pointer}.tds-button,.tds-button *,.tds-button :after,.tds-button :before{box-sizing:border-box}.tds-button:focus-visible{outline:solid var(--tds-size-border-medium) var(--tds-color-border-focus);outline-offset:var(--tds-size-spacing-025)}.tds-button:hover:not(:disabled):not(:active){background:var(--tds-local-button-color-bg-hover)}.tds-button:active:not(:disabled){background:var(--tds-local-button-color-bg-active)}.tds-button:disabled{cursor:not-allowed;opacity:var(--tds-opacity-disabled)}.tds-button:has(.tds-icon){gap:var(--tds-size-spacing-100)}.tds-button,.tds-button--primary{--tds-local-button-color-text:var(--tds-component-button-color-foreground-primary);--tds-local-button-color-bg:var(--tds-component-button-color-background-primary-default);--tds-local-button-color-bg-hover:var(--tds-component-button-color-background-primary-hover);--tds-local-button-color-bg-active:var(--tds-component-button-color-background-primary-active);--tds-local-button-color-border:var(--tds-component-button-color-border-primary)}.tds-button--secondary{--tds-local-button-color-text:var(--tds-component-button-color-foreground-secondary);--tds-local-button-color-bg:var(--tds-component-button-color-background-secondary-default);--tds-local-button-color-bg-hover:var(--tds-component-button-color-background-secondary-hover);--tds-local-button-color-bg-active:var(--tds-component-button-color-background-secondary-active);--tds-local-button-color-border:var(--tds-component-button-color-border-secondary)}.tds-button--tertiary{--tds-local-button-color-text:var(--tds-component-button-color-foreground-tertiary);--tds-local-button-color-bg:var(--tds-component-button-color-background-tertiary-default);--tds-local-button-color-bg-hover:var(--tds-component-button-color-background-tertiary-hover);--tds-local-button-color-bg-active:var(--tds-component-button-color-background-tertiary-active);--tds-local-button-color-border:var(--tds-component-button-color-border-tertiary)}.tds-button,.tds-button--md{--tds-local-button-size-height:var(--tds-local-button-size-height-md)}.tds-button--lg{--tds-local-button-size-height:var(--tds-local-button-size-height-lg)}.tds-button .tds-icon{--tds-local-icon-size:var(--tds-component-icon-size-sm);--tds-local-icon-color-text:inherit}\n"]
    }]
  }], null, null);
})();
class IconComponent {
  defaultClass = 'tds-icon';
  defaultVariant = INHERIT_VALUE;
  /**
   * Icon name, material symbols name
   * @required
   */
  name = input.required();
  /**
   * Icon size
   * @default 'md'
   */
  size = input(DEFAULT_SIZE_VALUE);
  /**
   * Icon variant
   * @default 'inherit'
   */
  variant = input(INHERIT_VALUE);
  /**
   * Whether the icon should be filled or not
   * @default false
   */
  isFilled = input(false, {
    transform: booleanAttribute
  });
  classes = computed(() => {
    const isFilledClass = this.isFilled() ? `${this.defaultClass}--filled` : '';
    const sizeClass = this.size() && this.size() !== DEFAULT_SIZE_VALUE ? `${this.defaultClass}--${this.size()}` : '';
    const variantClass = this.variant() && this.variant() !== this.defaultVariant ? `${this.defaultClass}--${this.variant()}` : '';
    return `material-symbols-rounded
      ${this.defaultClass}
      ${isFilledClass}
      ${sizeClass}
      ${variantClass}`;
  });
  static ɵfac = function IconComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || IconComponent)();
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: IconComponent,
    selectors: [["tds-icon"]],
    hostVars: 3,
    hostBindings: function IconComponent_HostBindings(rf, ctx) {
      if (rf & 2) {
        i0.ɵɵattribute("aria-hidden", true);
        i0.ɵɵclassMap(ctx.classes());
      }
    },
    inputs: {
      name: [1, "name"],
      size: [1, "size"],
      variant: [1, "variant"],
      isFilled: [1, "isFilled"]
    },
    standalone: true,
    features: [i0.ɵɵStandaloneFeature],
    decls: 1,
    vars: 1,
    template: function IconComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵtext(0);
      }
      if (rf & 2) {
        i0.ɵɵtextInterpolate1("", ctx.name(), "\n");
      }
    },
    styles: [".tds-icon{--tds-local-icon-color-text:inherit;color:var(--tds-local-icon-color-text);font-size:var(--tds-local-icon-size);font-weight:inherit;-webkit-user-select:none;user-select:none}.tds-icon--filled{font-variation-settings:\"FILL\" 1}.tds-icon,.tds-icon--md{--tds-local-icon-size:var(--tds-component-icon-size-md)}.tds-icon--xs{--tds-local-icon-size:var(--tds-component-icon-size-xs)}.tds-icon--sm{--tds-local-icon-size:var(--tds-component-icon-size-sm)}.tds-icon--lg{--tds-local-icon-size:var(--tds-component-icon-size-lg)}.tds-icon--xl{--tds-local-icon-size:var(--tds-component-icon-size-xl)}.tds-icon--primary{--tds-local-icon-color-text:var(--tds-color-foreground-primary)}.tds-icon--secondary{--tds-local-icon-color-text:var(--tds-color-foreground-secondary)}.tds-icon--info{--tds-local-icon-color-text:var(--tds-color-foreground-status-info)}.tds-icon--success{--tds-local-icon-color-text:var(--tds-color-foreground-status-success)}.tds-icon--danger{--tds-local-icon-color-text:var(--tds-color-foreground-status-danger)}.tds-icon--warning{--tds-local-icon-color-text:var(--tds-color-foreground-status-warning)}.tds-icon--red{--tds-local-icon-color-text:var(--tds-color-foreground-accent-red)}.tds-icon--green{--tds-local-icon-color-text:var(--tds-color-foreground-accent-green)}.tds-icon--blue{--tds-local-icon-color-text:var(--tds-color-foreground-accent-blue)}.tds-icon--yellow{--tds-local-icon-color-text:var(--tds-color-foreground-accent-yellow)}.tds-icon--grey{--tds-local-icon-color-text:var(--tds-color-foreground-accent-grey)}.tds-icon--orange{--tds-local-icon-color-text:var(--tds-color-foreground-accent-orange)}.tds-icon--teal{--tds-local-icon-color-text:var(--tds-color-foreground-accent-teal)}.tds-icon--purple{--tds-local-icon-color-text:var(--tds-color-foreground-accent-purple)}.tds-icon--pink{--tds-local-icon-color-text:var(--tds-color-foreground-accent-pink)}\n"],
    encapsulation: 2,
    changeDetection: 0
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(IconComponent, [{
    type: Component,
    args: [{
      selector: 'tds-icon',
      standalone: true,
      imports: [],
      host: {
        '[class]': 'classes()',
        // Add aria-hidden attribute to the icon
        // Most icons are decorative and should not be announced by screen readers
        // TODO: Add a way to override this behavior
        '[attr.aria-hidden]': 'true'
      },
      changeDetection: ChangeDetectionStrategy.OnPush,
      encapsulation: ViewEncapsulation.None,
      template: "{{ name() }}\n",
      styles: [".tds-icon{--tds-local-icon-color-text:inherit;color:var(--tds-local-icon-color-text);font-size:var(--tds-local-icon-size);font-weight:inherit;-webkit-user-select:none;user-select:none}.tds-icon--filled{font-variation-settings:\"FILL\" 1}.tds-icon,.tds-icon--md{--tds-local-icon-size:var(--tds-component-icon-size-md)}.tds-icon--xs{--tds-local-icon-size:var(--tds-component-icon-size-xs)}.tds-icon--sm{--tds-local-icon-size:var(--tds-component-icon-size-sm)}.tds-icon--lg{--tds-local-icon-size:var(--tds-component-icon-size-lg)}.tds-icon--xl{--tds-local-icon-size:var(--tds-component-icon-size-xl)}.tds-icon--primary{--tds-local-icon-color-text:var(--tds-color-foreground-primary)}.tds-icon--secondary{--tds-local-icon-color-text:var(--tds-color-foreground-secondary)}.tds-icon--info{--tds-local-icon-color-text:var(--tds-color-foreground-status-info)}.tds-icon--success{--tds-local-icon-color-text:var(--tds-color-foreground-status-success)}.tds-icon--danger{--tds-local-icon-color-text:var(--tds-color-foreground-status-danger)}.tds-icon--warning{--tds-local-icon-color-text:var(--tds-color-foreground-status-warning)}.tds-icon--red{--tds-local-icon-color-text:var(--tds-color-foreground-accent-red)}.tds-icon--green{--tds-local-icon-color-text:var(--tds-color-foreground-accent-green)}.tds-icon--blue{--tds-local-icon-color-text:var(--tds-color-foreground-accent-blue)}.tds-icon--yellow{--tds-local-icon-color-text:var(--tds-color-foreground-accent-yellow)}.tds-icon--grey{--tds-local-icon-color-text:var(--tds-color-foreground-accent-grey)}.tds-icon--orange{--tds-local-icon-color-text:var(--tds-color-foreground-accent-orange)}.tds-icon--teal{--tds-local-icon-color-text:var(--tds-color-foreground-accent-teal)}.tds-icon--purple{--tds-local-icon-color-text:var(--tds-color-foreground-accent-purple)}.tds-icon--pink{--tds-local-icon-color-text:var(--tds-color-foreground-accent-pink)}\n"]
    }]
  }], null, null);
})();
const FOREGROUND_VARIANTS = ['primary', 'secondary'];
/**
 * ICON_VARIANTS is an array of all possible icon variants. Used to define `IconVariant` union type. Useful for looping through all possible icon variants.
 */
const ICON_VARIANTS = [INHERIT_VALUE, ...FOREGROUND_VARIANTS, ...STATUS_VARIANTS, ...ACCENT_VARIANTS];
/**
 * ICON_SIZES is an array of all possible icon sizes. Used to define `IconSize` union type. Useful for looping through all possible icon sizes.
 */
const ICON_SIZES = ['xs', 'sm', 'md', 'lg', 'xl'];
const LAYER_HOST = {
  '[class]': 'classes()',
  '[attr.tabindex]': 'isClickable() ? tabIndexAttr() : undefined',
  '[attr.role]': 'isClickable() ? "button" : null'
};
class LayerComponent {
  defaultClass = 'tds-layer';
  defaultVariant = 'auto';
  /**
   * Layer variant.
   * Setting it to `auto` will automatically detect if layer is variant `100` or `100` based from the ancestor elements.
   * You can also set it to another value to force the variant.
   * @default 'auto'
   */
  variant = input('auto');
  /**
   * Layer is clickable
   * Setting it to `true` will add a pointer cursor to the layer and hover, active states.
   * @default false
   */
  isClickable = input(false, {
    transform: booleanAttribute
  });
  /**
   * tabindex of the clickable layer
   * Set as host attribute if `isClickable` is `true`
   * Attribute will be set to undefined if `isClickable` is `false`
   * @default undefined
   */
  tabIndex = input(undefined, {
    transform: tabIndexTransform
  });
  tabIndexAttr = computed(() => this.tabIndex() !== undefined ? this.tabIndex() : 0);
  classes = computed(() => {
    const variantClass = this.variant() && this.variant() !== this.defaultVariant ? `${this.defaultClass}--${this.variant()}` : '';
    const clickableClass = this.isClickable() ? `${this.defaultClass}--clickable` : '';
    return `${this.defaultClass} ${variantClass} ${clickableClass}`;
  });
  static ɵfac = function LayerComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || LayerComponent)();
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: LayerComponent,
    selectors: [["", "tds-layer", ""]],
    hostVars: 4,
    hostBindings: function LayerComponent_HostBindings(rf, ctx) {
      if (rf & 2) {
        i0.ɵɵattribute("tabindex", ctx.isClickable() ? ctx.tabIndexAttr() : undefined)("role", ctx.isClickable() ? "button" : null);
        i0.ɵɵclassMap(ctx.classes());
      }
    },
    inputs: {
      variant: [1, "variant"],
      isClickable: [1, "isClickable"],
      tabIndex: [1, "tabIndex"]
    },
    standalone: true,
    features: [i0.ɵɵStandaloneFeature],
    attrs: _c3,
    ngContentSelectors: _c4,
    decls: 1,
    vars: 0,
    template: function LayerComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵprojection(0);
      }
    },
    styles: [".tds-layer{background:var(--tds-component-layer-color-background-default);color:var(--tds-color-foreground-primary);font-family:var(--tds-font-family-sans)}.tds-layer .tds-layer:not(.tds-layer--100):not(.tds-layer--200){--tds-color-background-field:var(--tds-private-color-field-300);--tds-component-segmented-control-color-background:var(--tds-private-color-segmented-control-300);--tds-component-layer-color-background-default:var(--tds-private-color-layer-200-default);--tds-component-layer-color-background-hover:var(--tds-private-color-layer-200-hover);--tds-component-layer-color-background-active:var(--tds-private-color-layer-200-active)}.tds-layer--clickable{cursor:pointer}.tds-layer--clickable:focus-visible{outline:solid var(--tds-size-border-medium) var(--tds-color-border-focus);outline-offset:0}.tds-layer--clickable:hover{background:var(--tds-component-layer-color-background-hover)}.tds-layer--clickable:active{background:var(--tds-component-layer-color-background-active)}.tds-layer,.tds-layer--100,.tds-layer--auto{--tds-color-background-field:var(--tds-private-color-field-200);--tds-component-segmented-control-color-background:var(--tds-private-color-segmented-control-200);--tds-component-layer-color-background-default:var(--tds-private-color-layer-100-default);--tds-component-layer-color-background-hover:var(--tds-private-color-layer-100-hover);--tds-component-layer-color-background-active:var(--tds-private-color-layer-100-active)}.tds-layer--200{--tds-color-background-field:var(--tds-private-color-field-300);--tds-component-segmented-control-color-background:var(--tds-private-color-segmented-control-300);--tds-component-layer-color-background-default:var(--tds-private-color-layer-200-default);--tds-component-layer-color-background-hover:var(--tds-private-color-layer-200-hover);--tds-component-layer-color-background-active:var(--tds-private-color-layer-200-active)}\n"],
    encapsulation: 2,
    changeDetection: 0
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LayerComponent, [{
    type: Component,
    args: [{
      selector: '[tds-layer]',
      standalone: true,
      imports: [],
      host: LAYER_HOST,
      changeDetection: ChangeDetectionStrategy.OnPush,
      encapsulation: ViewEncapsulation.None,
      template: "<ng-content></ng-content>\n",
      styles: [".tds-layer{background:var(--tds-component-layer-color-background-default);color:var(--tds-color-foreground-primary);font-family:var(--tds-font-family-sans)}.tds-layer .tds-layer:not(.tds-layer--100):not(.tds-layer--200){--tds-color-background-field:var(--tds-private-color-field-300);--tds-component-segmented-control-color-background:var(--tds-private-color-segmented-control-300);--tds-component-layer-color-background-default:var(--tds-private-color-layer-200-default);--tds-component-layer-color-background-hover:var(--tds-private-color-layer-200-hover);--tds-component-layer-color-background-active:var(--tds-private-color-layer-200-active)}.tds-layer--clickable{cursor:pointer}.tds-layer--clickable:focus-visible{outline:solid var(--tds-size-border-medium) var(--tds-color-border-focus);outline-offset:0}.tds-layer--clickable:hover{background:var(--tds-component-layer-color-background-hover)}.tds-layer--clickable:active{background:var(--tds-component-layer-color-background-active)}.tds-layer,.tds-layer--100,.tds-layer--auto{--tds-color-background-field:var(--tds-private-color-field-200);--tds-component-segmented-control-color-background:var(--tds-private-color-segmented-control-200);--tds-component-layer-color-background-default:var(--tds-private-color-layer-100-default);--tds-component-layer-color-background-hover:var(--tds-private-color-layer-100-hover);--tds-component-layer-color-background-active:var(--tds-private-color-layer-100-active)}.tds-layer--200{--tds-color-background-field:var(--tds-private-color-field-300);--tds-component-segmented-control-color-background:var(--tds-private-color-segmented-control-300);--tds-component-layer-color-background-default:var(--tds-private-color-layer-200-default);--tds-component-layer-color-background-hover:var(--tds-private-color-layer-200-hover);--tds-component-layer-color-background-active:var(--tds-private-color-layer-200-active)}\n"]
    }]
  }], null, null);
})();

/**
 * LAYER_VARIANTS is an array of all the possible layer variants. Used to define `LayerVariant` union type. Useful for looping through all possible layer variants.
 */
const LAYER_VARIANTS = ['auto', '100', '200'];
const LINK_HOST = {
  // Add a default class to the button and classes based on the inputs values
  '[class]': 'classes()',
  role: 'link',
  '[attr.aria-disabled]': 'isDisabled()',
  '[attr.tabindex]': 'isDisabled() ? -1 : tabindex'
};
class LinkComponent {
  target;
  tabindex;
  elementRef;
  defaultClass = 'tds-link';
  defaultSize = 'sm';
  href;
  constructor(target, tabindex, elementRef) {
    this.target = target;
    this.tabindex = tabindex;
    this.elementRef = elementRef;
    effect(() => {
      const hrefAttr = this.elementRef.nativeElement.getAttribute('href');
      if (!!hrefAttr) {
        this.href = hrefAttr;
      }
      if (this.isDisabled()) {
        this.elementRef.nativeElement.removeAttribute('href');
      } else if (this.href) {
        this.elementRef.nativeElement.setAttribute('href', this.href);
      }
    });
  }
  /**
   * Link size
   */
  size = input();
  /**
   * Whether the link should be disabled or not
   * Disabled links don't trigger any action and don't have a `href` attribute
   * Then it's not possible to modify href when the link is disabled
   * @default false
   */
  isDisabled = input(false, {
    transform: booleanAttribute
  });
  /**
   * Whether the link should redirect to an external page
   * When set to `true`, it adds an icon to the link
   * @default false
   */
  isExternal = input(false, {
    transform: booleanAttribute
  });
  /**
   * Whether the link should display a different style when :visited
   * By default `:visited` style is not shown
   * @default false
   */
  showVisitedStyle = input(false, {
    transform: booleanAttribute
  });
  /**
   * @ignore
   */
  _hasExternalIcon = computed(() => this.isExternal() || this.target === '_blank');
  classes = computed(() => {
    const disabledClass = this.isDisabled() ? `${this.defaultClass}--disabled` : '';
    const withVisitedClass = this.showVisitedStyle() ? `${this.defaultClass}--with-visited` : '';
    const sizeClass = this.size() && this.size() !== this.defaultSize ? `${this.defaultClass}--${this.size()}` : '';
    return `${this.defaultClass} 
        ${sizeClass}
        ${disabledClass}
        ${withVisitedClass}`;
  });
  static ɵfac = function LinkComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || LinkComponent)(i0.ɵɵinjectAttribute('target'), i0.ɵɵinjectAttribute('tabindex'), i0.ɵɵdirectiveInject(i0.ElementRef));
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: LinkComponent,
    selectors: [["a", "tds-link", ""]],
    hostAttrs: ["role", "link"],
    hostVars: 4,
    hostBindings: function LinkComponent_HostBindings(rf, ctx) {
      if (rf & 2) {
        i0.ɵɵattribute("aria-disabled", ctx.isDisabled())("tabindex", ctx.isDisabled() ? -1 : ctx.tabindex);
        i0.ɵɵclassMap(ctx.classes());
      }
    },
    inputs: {
      size: [1, "size"],
      isDisabled: [1, "isDisabled"],
      isExternal: [1, "isExternal"],
      showVisitedStyle: [1, "showVisitedStyle"]
    },
    standalone: true,
    features: [i0.ɵɵStandaloneFeature],
    attrs: _c5,
    ngContentSelectors: _c7,
    decls: 3,
    vars: 1,
    consts: [["name", "open_in_new", "variant", "inherit"]],
    template: function LinkComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵprojectionDef(_c6);
        i0.ɵɵprojection(0);
        i0.ɵɵtemplate(1, LinkComponent_Conditional_1_Template, 1, 0, "tds-icon", 0)(2, LinkComponent_Conditional_2_Template, 1, 0);
      }
      if (rf & 2) {
        i0.ɵɵadvance();
        i0.ɵɵconditional(ctx._hasExternalIcon() ? 1 : 2);
      }
    },
    dependencies: [IconComponent],
    styles: [".tds-link{--tds-local-link-border-height:var(--tds-size-border-thin);--tds-local-link-color:var(--tds-component-link-color-default);all:unset;border-radius:var(--tds-size-radius-025);color:var(--tds-local-link-color);cursor:pointer;display:inline;font:var(--tds-local-link-font);max-width:-moz-fit-content;max-width:fit-content;-webkit-text-decoration:underline solid currentColor var(--tds-local-link-border-height);text-decoration:underline solid currentColor var(--tds-local-link-border-height);text-underline-offset:.2lh;-webkit-font-smoothing:antialiased}.tds-link,.tds-link *,.tds-link :after,.tds-link :before{box-sizing:border-box}.tds-link:focus-visible{outline:solid var(--tds-size-border-medium) var(--tds-color-border-focus);outline-offset:var(--tds-size-spacing-025)}.tds-link--disabled{cursor:not-allowed;opacity:var(--tds-opacity-disabled)}.tds-link:hover:not(.tds-link--disabled){--tds-local-link-border-height:var(--tds-size-border-medium)}.tds-link:hover:not(.tds-link--disabled):not(.tds-link--with-visited:visited){--tds-local-link-color:var(--tds-component-link-color-hover)}.tds-link:active:not(.tds-link--disabled):not(.tds-link--with-visited:visited){--tds-local-link-color:var(--tds-component-link-color-active)}.tds-link--with-visited:not(.tds-link--disabled):visited{--tds-local-link-color:var(--tds-component-link-color-visited);color:var(--tds-component-link-color-visited)}.tds-link--with-visited:not(.tds-link--disabled):visited .tds-icon{color:var(--tds-component-link-color-visited)}.tds-link,.tds-link--sm{--tds-local-link-font:var(--tds-font-body-2)}.tds-link--md{--tds-local-link-font:var(--tds-font-body-1)}.tds-link .tds-icon{color:inherit;font-size:var(--tds-component-icon-size-xs);margin-left:var(--tds-size-spacing-050);-webkit-user-select:none;user-select:none;vertical-align:sub}\n"],
    encapsulation: 2,
    changeDetection: 0
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LinkComponent, [{
    type: Component,
    args: [{
      selector: 'a[tds-link]',
      standalone: true,
      imports: [IconComponent],
      host: LINK_HOST,
      changeDetection: ChangeDetectionStrategy.OnPush,
      encapsulation: ViewEncapsulation.None,
      template: "<ng-content></ng-content>\n@if (_hasExternalIcon()) {\n  <tds-icon\n    name=\"open_in_new\"\n    variant=\"inherit\" />\n} @else {\n  <ng-content select=\"tds-icon\"></ng-content>\n}\n",
      styles: [".tds-link{--tds-local-link-border-height:var(--tds-size-border-thin);--tds-local-link-color:var(--tds-component-link-color-default);all:unset;border-radius:var(--tds-size-radius-025);color:var(--tds-local-link-color);cursor:pointer;display:inline;font:var(--tds-local-link-font);max-width:-moz-fit-content;max-width:fit-content;-webkit-text-decoration:underline solid currentColor var(--tds-local-link-border-height);text-decoration:underline solid currentColor var(--tds-local-link-border-height);text-underline-offset:.2lh;-webkit-font-smoothing:antialiased}.tds-link,.tds-link *,.tds-link :after,.tds-link :before{box-sizing:border-box}.tds-link:focus-visible{outline:solid var(--tds-size-border-medium) var(--tds-color-border-focus);outline-offset:var(--tds-size-spacing-025)}.tds-link--disabled{cursor:not-allowed;opacity:var(--tds-opacity-disabled)}.tds-link:hover:not(.tds-link--disabled){--tds-local-link-border-height:var(--tds-size-border-medium)}.tds-link:hover:not(.tds-link--disabled):not(.tds-link--with-visited:visited){--tds-local-link-color:var(--tds-component-link-color-hover)}.tds-link:active:not(.tds-link--disabled):not(.tds-link--with-visited:visited){--tds-local-link-color:var(--tds-component-link-color-active)}.tds-link--with-visited:not(.tds-link--disabled):visited{--tds-local-link-color:var(--tds-component-link-color-visited);color:var(--tds-component-link-color-visited)}.tds-link--with-visited:not(.tds-link--disabled):visited .tds-icon{color:var(--tds-component-link-color-visited)}.tds-link,.tds-link--sm{--tds-local-link-font:var(--tds-font-body-2)}.tds-link--md{--tds-local-link-font:var(--tds-font-body-1)}.tds-link .tds-icon{color:inherit;font-size:var(--tds-component-icon-size-xs);margin-left:var(--tds-size-spacing-050);-webkit-user-select:none;user-select:none;vertical-align:sub}\n"]
    }]
  }], () => [{
    type: undefined,
    decorators: [{
      type: Attribute,
      args: ['target']
    }]
  }, {
    type: undefined,
    decorators: [{
      type: Attribute,
      args: ['tabindex']
    }]
  }, {
    type: i0.ElementRef
  }], null);
})();

/**
 * LINK_SIZES is an array of all possible sizes for the link component. Used to define `LinkSize` union type. Useful for looping through all possible sizes.
 */
const LINK_SIZES = ['sm', 'md'];
const CHECKBOX_VALUE_ACCESSOR = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => CheckboxComponent),
  multi: true
};
class CheckboxComponent {
  defaultClass = 'tds-checkbox';
  defaultHostClass = `${this.defaultClass}-host`;
  cdr = inject(ChangeDetectorRef);
  _controlValueAccessorChangeFn = () => {};
  _onTouched = () => {};
  _validatorChangeFn = () => {};
  /**
   * Checkbox id, this is required for accessibility.
   * If not set a random id constructed like this `tds-checkbox-{RANDOM}` will be generated
   */
  inputId = input();
  /**
   * Whether the checkbox is checked
   * @default false
   */
  checked = model(false);
  /**
   * Whether the checkbox is indeterminate
   * @default false
   */
  indeterminate = model(false);
  /**
   * Whether the checkbox is disabled
   * @default false
   */
  disabled = model(false);
  /**
   * Checkbox name
   */
  name = input();
  /**
   * Checkbox value
   */
  value = input();
  /**
   * Whether the checkbox is required
   */
  required = input(false, {
    transform: booleanAttribute
  });
  /**
   * Checkbox `tabindex`, is set to `-1` if checkbox is disabled
   */
  tabIndex = input(undefined, {
    transform: tabIndexTransform
  });
  /**
   * If you want to display a checkbox without a label,
   * it is mandatory to set an aria-label, aria-labelledby or aria-describedby
   */
  a11YAriaLabel = input();
  /**
   * If you want to display a checkbox without a label,
   * it is mandatory to set an aria-label, aria-labelledby or aria-describedby
   */
  a11YAriaLabelledBy = input();
  /**
   * If you want to display a checkbox without a label,
   * it is mandatory to set an aria-label, aria-labelledby or aria-describedby
   */
  a11YAriaDescribedBy = input();
  inputEl = viewChild('input');
  _id = computed(() => {
    return this.inputId() ?? genRandomId(this.defaultClass);
  });
  _tabIndex = computed(() => {
    return this.disabled() ? -1 : this.tabIndex();
  });
  _ariaChecked = computed(() => {
    return this.indeterminate() ? 'mixed' : null;
  });
  _checked = computed(() => {
    return !this.indeterminate() && this.checked();
  });
  _onInputClick(event) {
    event.stopPropagation();
    if (this.indeterminate()) {
      this.indeterminate.set(false);
      this.checked.set(true);
    } else {
      this.indeterminate.set(false);
      this.checked.update(value => !value);
    }
    this._syncNativeInput();
    this.cdr.markForCheck();
    this._controlValueAccessorChangeFn(this.checked());
  }
  _onChangeEvent(event) {
    event.stopPropagation();
  }
  _syncNativeInput() {
    const nativeEl = this.inputEl()?.nativeElement;
    if (!nativeEl) {
      return;
    }
    // Sync the native input element
    nativeEl.checked = this._checked();
    nativeEl.indeterminate = this.indeterminate();
  }
  _onBlur() {
    this._onTouched();
  }
  /**
   * Implemented as part of ControlValueAccessor.
   * @ignore
   */
  registerOnChange(fn) {
    this._controlValueAccessorChangeFn = fn;
  }
  /**
   * Implemented as part of ControlValueAccessor.
   * @ignore
   */
  registerOnTouched(fn) {
    this._onTouched = fn;
  }
  /**
   * Implemented as part of ControlValueAccessor.
   * @ignore
   */
  registerOnValidatorChange(fn) {
    this._validatorChangeFn = fn;
  }
  /**
   * Implemented as part of ControlValueAccessor.
   * @ignore
   */
  setDisabledState(disabled) {
    this.disabled.set(disabled);
  }
  /**
   * Implemented as part of ControlValueAccessor.
   * @ignore
   */
  writeValue(val) {
    this.checked.set(booleanAttribute(val));
    this._syncNativeInput();
    this.cdr.markForCheck();
  }
  /**
   * Implemented as part of ControlValueAccessor.
   * @ignore
   */
  validate(control) {
    return this.required() && !control.value ? {
      required: true
    } : null;
  }
  static ɵfac = function CheckboxComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || CheckboxComponent)();
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: CheckboxComponent,
    selectors: [["tds-checkbox"]],
    viewQuery: function CheckboxComponent_Query(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵviewQuerySignal(ctx.inputEl, _c8, 5);
      }
      if (rf & 2) {
        i0.ɵɵqueryAdvance();
      }
    },
    hostVars: 2,
    hostBindings: function CheckboxComponent_HostBindings(rf, ctx) {
      if (rf & 2) {
        i0.ɵɵclassMap(ctx.defaultHostClass);
      }
    },
    inputs: {
      inputId: [1, "inputId"],
      checked: [1, "checked"],
      indeterminate: [1, "indeterminate"],
      disabled: [1, "disabled"],
      name: [1, "name"],
      value: [1, "value"],
      required: [1, "required"],
      tabIndex: [1, "tabIndex"],
      a11YAriaLabel: [1, "a11YAriaLabel"],
      a11YAriaLabelledBy: [1, "a11YAriaLabelledBy"],
      a11YAriaDescribedBy: [1, "a11YAriaDescribedBy"]
    },
    outputs: {
      checked: "checkedChange",
      indeterminate: "indeterminateChange",
      disabled: "disabledChange"
    },
    standalone: true,
    features: [i0.ɵɵProvidersFeature([CHECKBOX_VALUE_ACCESSOR, {
      provide: NG_VALIDATORS,
      useExisting: CheckboxComponent,
      multi: true
    }]), i0.ɵɵStandaloneFeature],
    ngContentSelectors: _c4,
    decls: 6,
    vars: 13,
    consts: [["input", ""], [1, "tds-checkbox"], [1, "tds-checkbox__decorator"], ["type", "checkbox", 1, "tds-checkbox__input", 3, "blur", "change", "click", "checked", "disabled", "indeterminate", "required", "tabIndex"], [1, "tds-checkbox__label"]],
    template: function CheckboxComponent_Template(rf, ctx) {
      if (rf & 1) {
        const _r1 = i0.ɵɵgetCurrentView();
        i0.ɵɵprojectionDef();
        i0.ɵɵelementStart(0, "label", 1);
        i0.ɵɵelement(1, "div", 2);
        i0.ɵɵelementStart(2, "input", 3, 0);
        i0.ɵɵlistener("blur", function CheckboxComponent_Template_input_blur_2_listener() {
          i0.ɵɵrestoreView(_r1);
          return i0.ɵɵresetView(ctx._onBlur());
        })("change", function CheckboxComponent_Template_input_change_2_listener($event) {
          i0.ɵɵrestoreView(_r1);
          return i0.ɵɵresetView(ctx._onChangeEvent($event));
        })("click", function CheckboxComponent_Template_input_click_2_listener($event) {
          i0.ɵɵrestoreView(_r1);
          return i0.ɵɵresetView(ctx._onInputClick($event));
        });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(4, "div", 4);
        i0.ɵɵprojection(5);
        i0.ɵɵelementEnd()();
      }
      if (rf & 2) {
        i0.ɵɵattribute("for", ctx._id());
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("checked", ctx._checked())("disabled", ctx.disabled())("indeterminate", ctx.indeterminate())("required", ctx.required())("tabIndex", ctx._tabIndex());
        i0.ɵɵattribute("aria-checked", ctx._ariaChecked())("aria-describedby", ctx.a11YAriaDescribedBy())("aria-label", ctx.a11YAriaLabel())("aria-labelledby", ctx.a11YAriaLabelledBy())("id", ctx._id())("name", ctx.name())("value", ctx.value());
      }
    },
    styles: [".tds-checkbox{--tds-local-checkbox-decorator-bg:var(--tds-color-background-transparent-default);--tds-local-checkbox-decorator-border-color:var(--tds-color-border-strong);--tds-local-checkbox-cursor:pointer;--tds-local-checkbox-size:14px;all:unset;align-items:flex-start;color:var(--tds-color-foreground-primary);cursor:var(--tds-local-checkbox-cursor);display:inline-flex;gap:var(--tds-size-spacing-100);position:relative}.tds-checkbox,.tds-checkbox *,.tds-checkbox :after,.tds-checkbox :before{box-sizing:border-box}.tds-checkbox__label{-webkit-font-smoothing:antialiased;cursor:var(--tds-local-checkbox-cursor);font:var(--tds-font-body-2);white-space:pre-line}.tds-checkbox__label:empty{display:none}.tds-checkbox__input{height:0;left:0;margin:0;opacity:0;overflow:hidden;pointer-events:none;position:absolute;width:0;z-index:-1}.tds-checkbox__decorator{align-items:center;border-radius:var(--tds-size-radius-025);cursor:var(--tds-local-checkbox-cursor);display:inline-flex;flex-grow:0;flex-shrink:0;font:var(--tds-font-body-2);height:14px;justify-content:center;margin:calc((1lh - var(--tds-local-checkbox-size)) / 2);width:14px}.tds-checkbox__decorator:after{background-color:var(--tds-local-checkbox-decorator-bg);border:solid var(--tds-size-border-medium) var(--tds-local-checkbox-decorator-border-color);border-radius:var(--tds-size-radius-025);content:\"\";height:100%;width:100%}.tds-checkbox:hover:not(:has(input[type=checkbox]:disabled)){--tds-local-checkbox-decorator-bg:var(--tds-color-background-transparent-hover)}.tds-checkbox:active:not(:has(input[type=checkbox]:disabled)){--tds-local-checkbox-decorator-bg:var(--tds-color-background-transparent-active)}.tds-checkbox:has(input[type=checkbox]:checked),.tds-checkbox:has(input[type=checkbox]:indeterminate){--tds-local-checkbox-decorator-bg:var(--tds-color-background-brand-default);--tds-local-checkbox-decorator-border-color:var(--tds-color-border-transparent)}.tds-checkbox:has(input[type=checkbox]:checked):hover:not(:has(input[type=checkbox]:disabled)),.tds-checkbox:has(input[type=checkbox]:indeterminate):hover:not(:has(input[type=checkbox]:disabled)){--tds-local-checkbox-decorator-bg:var(--tds-color-background-brand-hover)}.tds-checkbox:has(input[type=checkbox]:checked):active:not(:has(input[type=checkbox]:disabled)),.tds-checkbox:has(input[type=checkbox]:indeterminate):active:not(:has(input[type=checkbox]:disabled)){--tds-local-checkbox-decorator-bg:var(--tds-color-background-brand-active)}.tds-checkbox:has(input[type=checkbox]:checked) .tds-checkbox__check,.tds-checkbox:has(input[type=checkbox]:indeterminate) .tds-checkbox__check{display:inline-block}.tds-checkbox:has(input[type=checkbox]:checked) .tds-checkbox__decorator:after,.tds-checkbox:has(input[type=checkbox]:indeterminate) .tds-checkbox__decorator:after{-webkit-mask-composite:xor;mask-composite:exclude;-webkit-mask-position:center;mask-position:center;-webkit-mask-repeat:no-repeat;mask-repeat:no-repeat;-webkit-mask-size:100%;mask-size:100%}.tds-checkbox:has(input[type=checkbox]:focus-visible) .tds-checkbox__decorator{outline:solid var(--tds-size-border-medium) var(--tds-color-border-focus);outline-offset:var(--tds-size-spacing-025)}.tds-checkbox:has(input[type=checkbox]:checked) .tds-checkbox__decorator:after{-webkit-mask-image:linear-gradient(to right,var(--tds-local-checkbox-decorator-bg),var(--tds-local-checkbox-decorator-bg)),url('data:image/svg+xml;charset=US-ASCII,<svg xmlns=\"http://www.w3.org/2000/svg\" height=\"14\" viewBox=\"0 -960 960 960\" width=\"14\"><path d=\"m382-373.22 328.83-328.82Q726.78-718 748.43-718q21.66 0 37.61 15.96Q802-686.09 802-664.22t-15.96 37.83L419.61-259.52q-15.96 15.96-37.61 15.96t-37.61-15.96L173.52-430.39q-15.96-15.96-15.74-37.83.22-21.87 16.18-37.82Q189.91-522 211.78-522t37.83 15.96L382-373.22Z\"/></svg>');mask-image:linear-gradient(to right,var(--tds-local-checkbox-decorator-bg),var(--tds-local-checkbox-decorator-bg)),url('data:image/svg+xml;charset=US-ASCII,<svg xmlns=\"http://www.w3.org/2000/svg\" height=\"14\" viewBox=\"0 -960 960 960\" width=\"14\"><path d=\"m382-373.22 328.83-328.82Q726.78-718 748.43-718q21.66 0 37.61 15.96Q802-686.09 802-664.22t-15.96 37.83L419.61-259.52q-15.96 15.96-37.61 15.96t-37.61-15.96L173.52-430.39q-15.96-15.96-15.74-37.83.22-21.87 16.18-37.82Q189.91-522 211.78-522t37.83 15.96L382-373.22Z\"/></svg>')}.tds-checkbox:has(input[type=checkbox]:indeterminate) .tds-checkbox__decorator:after{-webkit-mask-image:linear-gradient(to right,var(--tds-local-checkbox-decorator-bg),var(--tds-local-checkbox-decorator-bg)),url('data:image/svg+xml;charset=US-ASCII,<svg xmlns=\"http://www.w3.org/2000/svg\" height=\"14\" viewBox=\"0 -960 960 960\" width=\"14\"><path d=\"M233.78-427q-22.08 0-37.54-15.46-15.46-15.45-15.46-37.54t15.46-37.54Q211.7-533 233.78-533h492.44q22.08 0 37.54 15.46 15.46 15.45 15.46 37.54t-15.46 37.54Q748.3-427 726.22-427H233.78Z\"/></svg>');mask-image:linear-gradient(to right,var(--tds-local-checkbox-decorator-bg),var(--tds-local-checkbox-decorator-bg)),url('data:image/svg+xml;charset=US-ASCII,<svg xmlns=\"http://www.w3.org/2000/svg\" height=\"14\" viewBox=\"0 -960 960 960\" width=\"14\"><path d=\"M233.78-427q-22.08 0-37.54-15.46-15.46-15.45-15.46-37.54t15.46-37.54Q211.7-533 233.78-533h492.44q22.08 0 37.54 15.46 15.46 15.45 15.46 37.54t-15.46 37.54Q748.3-427 726.22-427H233.78Z\"/></svg>')}.tds-checkbox:has(input[type=checkbox]:disabled){--tds-local-checkbox-cursor:not-allowed;opacity:var(--tds-opacity-disabled)}.tds-checkbox-host{display:inline-flex}\n"],
    encapsulation: 2,
    changeDetection: 0
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CheckboxComponent, [{
    type: Component,
    args: [{
      selector: 'tds-checkbox',
      standalone: true,
      imports: [IconComponent],
      providers: [CHECKBOX_VALUE_ACCESSOR, {
        provide: NG_VALIDATORS,
        useExisting: CheckboxComponent,
        multi: true
      }],
      host: {
        '[class]': 'defaultHostClass'
      },
      changeDetection: ChangeDetectionStrategy.OnPush,
      encapsulation: ViewEncapsulation.None,
      template: "<label\n  class=\"tds-checkbox\"\n  [attr.for]=\"_id()\">\n  <div class=\"tds-checkbox__decorator\"></div>\n  <input\n    #input\n    class=\"tds-checkbox__input\"\n    type=\"checkbox\"\n    [attr.aria-checked]=\"_ariaChecked()\"\n    [attr.aria-describedby]=\"a11YAriaDescribedBy()\"\n    [attr.aria-label]=\"a11YAriaLabel()\"\n    [attr.aria-labelledby]=\"a11YAriaLabelledBy()\"\n    [attr.id]=\"_id()\"\n    [attr.name]=\"name()\"\n    [attr.value]=\"value()\"\n    [checked]=\"_checked()\"\n    [disabled]=\"disabled()\"\n    [indeterminate]=\"indeterminate()\"\n    [required]=\"required()\"\n    [tabIndex]=\"_tabIndex()\"\n    (blur)=\"_onBlur()\"\n    (change)=\"_onChangeEvent($event)\"\n    (click)=\"_onInputClick($event)\" />\n  <div class=\"tds-checkbox__label\">\n    <ng-content></ng-content>\n  </div>\n</label>\n",
      styles: [".tds-checkbox{--tds-local-checkbox-decorator-bg:var(--tds-color-background-transparent-default);--tds-local-checkbox-decorator-border-color:var(--tds-color-border-strong);--tds-local-checkbox-cursor:pointer;--tds-local-checkbox-size:14px;all:unset;align-items:flex-start;color:var(--tds-color-foreground-primary);cursor:var(--tds-local-checkbox-cursor);display:inline-flex;gap:var(--tds-size-spacing-100);position:relative}.tds-checkbox,.tds-checkbox *,.tds-checkbox :after,.tds-checkbox :before{box-sizing:border-box}.tds-checkbox__label{-webkit-font-smoothing:antialiased;cursor:var(--tds-local-checkbox-cursor);font:var(--tds-font-body-2);white-space:pre-line}.tds-checkbox__label:empty{display:none}.tds-checkbox__input{height:0;left:0;margin:0;opacity:0;overflow:hidden;pointer-events:none;position:absolute;width:0;z-index:-1}.tds-checkbox__decorator{align-items:center;border-radius:var(--tds-size-radius-025);cursor:var(--tds-local-checkbox-cursor);display:inline-flex;flex-grow:0;flex-shrink:0;font:var(--tds-font-body-2);height:14px;justify-content:center;margin:calc((1lh - var(--tds-local-checkbox-size)) / 2);width:14px}.tds-checkbox__decorator:after{background-color:var(--tds-local-checkbox-decorator-bg);border:solid var(--tds-size-border-medium) var(--tds-local-checkbox-decorator-border-color);border-radius:var(--tds-size-radius-025);content:\"\";height:100%;width:100%}.tds-checkbox:hover:not(:has(input[type=checkbox]:disabled)){--tds-local-checkbox-decorator-bg:var(--tds-color-background-transparent-hover)}.tds-checkbox:active:not(:has(input[type=checkbox]:disabled)){--tds-local-checkbox-decorator-bg:var(--tds-color-background-transparent-active)}.tds-checkbox:has(input[type=checkbox]:checked),.tds-checkbox:has(input[type=checkbox]:indeterminate){--tds-local-checkbox-decorator-bg:var(--tds-color-background-brand-default);--tds-local-checkbox-decorator-border-color:var(--tds-color-border-transparent)}.tds-checkbox:has(input[type=checkbox]:checked):hover:not(:has(input[type=checkbox]:disabled)),.tds-checkbox:has(input[type=checkbox]:indeterminate):hover:not(:has(input[type=checkbox]:disabled)){--tds-local-checkbox-decorator-bg:var(--tds-color-background-brand-hover)}.tds-checkbox:has(input[type=checkbox]:checked):active:not(:has(input[type=checkbox]:disabled)),.tds-checkbox:has(input[type=checkbox]:indeterminate):active:not(:has(input[type=checkbox]:disabled)){--tds-local-checkbox-decorator-bg:var(--tds-color-background-brand-active)}.tds-checkbox:has(input[type=checkbox]:checked) .tds-checkbox__check,.tds-checkbox:has(input[type=checkbox]:indeterminate) .tds-checkbox__check{display:inline-block}.tds-checkbox:has(input[type=checkbox]:checked) .tds-checkbox__decorator:after,.tds-checkbox:has(input[type=checkbox]:indeterminate) .tds-checkbox__decorator:after{-webkit-mask-composite:xor;mask-composite:exclude;-webkit-mask-position:center;mask-position:center;-webkit-mask-repeat:no-repeat;mask-repeat:no-repeat;-webkit-mask-size:100%;mask-size:100%}.tds-checkbox:has(input[type=checkbox]:focus-visible) .tds-checkbox__decorator{outline:solid var(--tds-size-border-medium) var(--tds-color-border-focus);outline-offset:var(--tds-size-spacing-025)}.tds-checkbox:has(input[type=checkbox]:checked) .tds-checkbox__decorator:after{-webkit-mask-image:linear-gradient(to right,var(--tds-local-checkbox-decorator-bg),var(--tds-local-checkbox-decorator-bg)),url('data:image/svg+xml;charset=US-ASCII,<svg xmlns=\"http://www.w3.org/2000/svg\" height=\"14\" viewBox=\"0 -960 960 960\" width=\"14\"><path d=\"m382-373.22 328.83-328.82Q726.78-718 748.43-718q21.66 0 37.61 15.96Q802-686.09 802-664.22t-15.96 37.83L419.61-259.52q-15.96 15.96-37.61 15.96t-37.61-15.96L173.52-430.39q-15.96-15.96-15.74-37.83.22-21.87 16.18-37.82Q189.91-522 211.78-522t37.83 15.96L382-373.22Z\"/></svg>');mask-image:linear-gradient(to right,var(--tds-local-checkbox-decorator-bg),var(--tds-local-checkbox-decorator-bg)),url('data:image/svg+xml;charset=US-ASCII,<svg xmlns=\"http://www.w3.org/2000/svg\" height=\"14\" viewBox=\"0 -960 960 960\" width=\"14\"><path d=\"m382-373.22 328.83-328.82Q726.78-718 748.43-718q21.66 0 37.61 15.96Q802-686.09 802-664.22t-15.96 37.83L419.61-259.52q-15.96 15.96-37.61 15.96t-37.61-15.96L173.52-430.39q-15.96-15.96-15.74-37.83.22-21.87 16.18-37.82Q189.91-522 211.78-522t37.83 15.96L382-373.22Z\"/></svg>')}.tds-checkbox:has(input[type=checkbox]:indeterminate) .tds-checkbox__decorator:after{-webkit-mask-image:linear-gradient(to right,var(--tds-local-checkbox-decorator-bg),var(--tds-local-checkbox-decorator-bg)),url('data:image/svg+xml;charset=US-ASCII,<svg xmlns=\"http://www.w3.org/2000/svg\" height=\"14\" viewBox=\"0 -960 960 960\" width=\"14\"><path d=\"M233.78-427q-22.08 0-37.54-15.46-15.46-15.45-15.46-37.54t15.46-37.54Q211.7-533 233.78-533h492.44q22.08 0 37.54 15.46 15.46 15.45 15.46 37.54t-15.46 37.54Q748.3-427 726.22-427H233.78Z\"/></svg>');mask-image:linear-gradient(to right,var(--tds-local-checkbox-decorator-bg),var(--tds-local-checkbox-decorator-bg)),url('data:image/svg+xml;charset=US-ASCII,<svg xmlns=\"http://www.w3.org/2000/svg\" height=\"14\" viewBox=\"0 -960 960 960\" width=\"14\"><path d=\"M233.78-427q-22.08 0-37.54-15.46-15.46-15.45-15.46-37.54t15.46-37.54Q211.7-533 233.78-533h492.44q22.08 0 37.54 15.46 15.46 15.45 15.46 37.54t-15.46 37.54Q748.3-427 726.22-427H233.78Z\"/></svg>')}.tds-checkbox:has(input[type=checkbox]:disabled){--tds-local-checkbox-cursor:not-allowed;opacity:var(--tds-opacity-disabled)}.tds-checkbox-host{display:inline-flex}\n"]
    }]
  }], null, null);
})();
class RadioComponent {
  defaultClass = 'tds-radio';
  defaultHostClass = `${this.defaultClass}-host`;
  static ɵfac = function RadioComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || RadioComponent)();
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: RadioComponent,
    selectors: [["tds-radio"]],
    hostVars: 2,
    hostBindings: function RadioComponent_HostBindings(rf, ctx) {
      if (rf & 2) {
        i0.ɵɵclassMap(ctx.defaultHostClass);
      }
    },
    standalone: true,
    features: [i0.ɵɵStandaloneFeature],
    ngContentSelectors: _c10,
    decls: 3,
    vars: 0,
    consts: [[1, "tds-radio"]],
    template: function RadioComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵprojectionDef(_c9);
        i0.ɵɵelementStart(0, "label", 0);
        i0.ɵɵprojection(1);
        i0.ɵɵprojection(2, 1);
        i0.ɵɵelementEnd();
      }
    },
    styles: [".tds-radio{--tds-local-radio-decorator-bg:var(--tds-color-background-transparent-default);--tds-local-radio-decorator-border-color:var(--tds-color-border-strong);--tds-local-radio-decorator-border-width:var(--tds-size-border-medium);--tds-local-radio-cursor:pointer;--tds-local-radio-size:16px;all:unset;align-items:flex-start;color:var(--tds-color-foreground-primary);cursor:var(--tds-local-radio-cursor);display:inline-flex;gap:var(--tds-size-spacing-100)}.tds-radio,.tds-radio *,.tds-radio :after,.tds-radio :before{box-sizing:border-box}.tds-radio__label{-webkit-font-smoothing:antialiased;cursor:var(--tds-local-radio-cursor);font:var(--tds-font-body-2);white-space:pre-line}.tds-radio__label:empty{display:none}.tds-radio input[type=radio]{align-items:center;-webkit-appearance:none;appearance:none;background-color:var(--tds-local-radio-decorator-bg);border:solid var(--tds-local-radio-decorator-border-width) var(--tds-local-radio-decorator-border-color);border-radius:var(--tds-size-radius-rounded);cursor:var(--tds-local-radio-cursor);display:inline-flex;flex-grow:0;flex-shrink:0;font:var(--tds-font-body-2);height:var(--tds-local-radio-size);justify-content:center;margin:calc((1lh - var(--tds-local-radio-size)) / 2);width:var(--tds-local-radio-size)}.tds-radio:hover:not(:has(input[type=radio]:disabled)):not(:has(input[type=radio]:checked)){--tds-local-radio-decorator-bg:var(--tds-color-background-transparent-hover)}.tds-radio:active:not(:has(input[type=radio]:disabled)):not(:has(input[type=radio]:checked)){--tds-local-radio-decorator-bg:var(--tds-color-background-transparent-active)}.tds-radio:has(input[type=radio]:checked){--tds-local-radio-decorator-bg:var(--tds-color-background-transparent-default);--tds-local-radio-decorator-border-color:var(--tds-color-border-brand);--tds-local-radio-decorator-border-width:5px}.tds-radio:has(input[type=radio]:focus-visible) input[type=radio]{outline:solid var(--tds-size-border-medium) var(--tds-color-border-focus);outline-offset:var(--tds-size-spacing-025)}.tds-radio:has(input[type=radio]:disabled){--tds-local-radio-cursor:not-allowed;opacity:var(--tds-opacity-disabled)}.tds-radio-host{display:inline-flex}\n"],
    encapsulation: 2,
    changeDetection: 0
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(RadioComponent, [{
    type: Component,
    args: [{
      selector: 'tds-radio',
      standalone: true,
      host: {
        '[class]': 'defaultHostClass'
      },
      encapsulation: ViewEncapsulation.None,
      changeDetection: ChangeDetectionStrategy.OnPush,
      template: "<label class=\"tds-radio\">\n  <ng-content select=\"[tds-radio-input]\"></ng-content>\n  <ng-content select=\"[tds-radio-label]\"></ng-content>\n</label>\n",
      styles: [".tds-radio{--tds-local-radio-decorator-bg:var(--tds-color-background-transparent-default);--tds-local-radio-decorator-border-color:var(--tds-color-border-strong);--tds-local-radio-decorator-border-width:var(--tds-size-border-medium);--tds-local-radio-cursor:pointer;--tds-local-radio-size:16px;all:unset;align-items:flex-start;color:var(--tds-color-foreground-primary);cursor:var(--tds-local-radio-cursor);display:inline-flex;gap:var(--tds-size-spacing-100)}.tds-radio,.tds-radio *,.tds-radio :after,.tds-radio :before{box-sizing:border-box}.tds-radio__label{-webkit-font-smoothing:antialiased;cursor:var(--tds-local-radio-cursor);font:var(--tds-font-body-2);white-space:pre-line}.tds-radio__label:empty{display:none}.tds-radio input[type=radio]{align-items:center;-webkit-appearance:none;appearance:none;background-color:var(--tds-local-radio-decorator-bg);border:solid var(--tds-local-radio-decorator-border-width) var(--tds-local-radio-decorator-border-color);border-radius:var(--tds-size-radius-rounded);cursor:var(--tds-local-radio-cursor);display:inline-flex;flex-grow:0;flex-shrink:0;font:var(--tds-font-body-2);height:var(--tds-local-radio-size);justify-content:center;margin:calc((1lh - var(--tds-local-radio-size)) / 2);width:var(--tds-local-radio-size)}.tds-radio:hover:not(:has(input[type=radio]:disabled)):not(:has(input[type=radio]:checked)){--tds-local-radio-decorator-bg:var(--tds-color-background-transparent-hover)}.tds-radio:active:not(:has(input[type=radio]:disabled)):not(:has(input[type=radio]:checked)){--tds-local-radio-decorator-bg:var(--tds-color-background-transparent-active)}.tds-radio:has(input[type=radio]:checked){--tds-local-radio-decorator-bg:var(--tds-color-background-transparent-default);--tds-local-radio-decorator-border-color:var(--tds-color-border-brand);--tds-local-radio-decorator-border-width:5px}.tds-radio:has(input[type=radio]:focus-visible) input[type=radio]{outline:solid var(--tds-size-border-medium) var(--tds-color-border-focus);outline-offset:var(--tds-size-spacing-025)}.tds-radio:has(input[type=radio]:disabled){--tds-local-radio-cursor:not-allowed;opacity:var(--tds-opacity-disabled)}.tds-radio-host{display:inline-flex}\n"]
    }]
  }], null, null);
})();
class RadioInputDirective {
  static ɵfac = function RadioInputDirective_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || RadioInputDirective)();
  };
  static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: RadioInputDirective,
    selectors: [["", "tds-radio-input", ""]],
    hostAttrs: ["type", "radio"],
    standalone: true
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(RadioInputDirective, [{
    type: Directive,
    args: [{
      selector: '[tds-radio-input]',
      host: {
        type: 'radio'
      },
      standalone: true
    }]
  }], null, null);
})();
class RadioLabelDirective {
  static ɵfac = function RadioLabelDirective_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || RadioLabelDirective)();
  };
  static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: RadioLabelDirective,
    selectors: [["", "tds-radio-label", ""]],
    hostAttrs: [1, "tds-radio__label"],
    standalone: true
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(RadioLabelDirective, [{
    type: Directive,
    args: [{
      selector: '[tds-radio-label]',
      host: {
        class: 'tds-radio__label'
      },
      standalone: true
    }]
  }], null, null);
})();
class FieldsetLabelDirective {
  static ɵfac = function FieldsetLabelDirective_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || FieldsetLabelDirective)();
  };
  static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: FieldsetLabelDirective,
    selectors: [["tds-fieldset-label"]],
    standalone: true
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FieldsetLabelDirective, [{
    type: Directive,
    args: [{
      selector: 'tds-fieldset-label',
      standalone: true
    }]
  }], null, null);
})();
const AUTHORIZED_CHILDREN_TAGS = ['input', 'textarea', 'select'];
class FormFieldItemDirective {
  idAttr;
  typeAttr;
  _nativeHostElement = inject(ElementRef).nativeElement;
  staticId = genRandomId(`tds-form-field-item`);
  id = signal(undefined);
  constructor(idAttr, typeAttr) {
    this.idAttr = idAttr;
    this.typeAttr = typeAttr;
    this.id.set(this.idAttr);
    effect(() => {
      if (!this.computedType()) {
        return;
      }
      this.field?.setAttribute('type', this.computedType());
    });
    effect(() => {
      this.field?.setAttribute('id', this.inputId());
    });
  }
  inputId = computed(() => this.id() ?? this.staticId);
  computedType = computed(() => {
    return this._nativeHostElement?.tagName !== 'INPUT' ? null : this.typeAttr ?? 'text';
  });
  focus() {
    this.field?.focus();
  }
  get field() {
    return AUTHORIZED_CHILDREN_TAGS.includes(this._nativeHostElement?.tagName?.toLowerCase()) ? this._nativeHostElement : this._nativeHostElement.querySelector(AUTHORIZED_CHILDREN_TAGS.join(', '));
  }
  static ɵfac = function FormFieldItemDirective_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || FormFieldItemDirective)(i0.ɵɵinjectAttribute('id'), i0.ɵɵinjectAttribute('type'));
  };
  static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: FormFieldItemDirective,
    selectors: [["", "tds-form-field-item", ""]],
    standalone: true
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FormFieldItemDirective, [{
    type: Directive,
    args: [{
      selector: '[tds-form-field-item]',
      standalone: true
    }]
  }], () => [{
    type: undefined,
    decorators: [{
      type: Attribute,
      args: ['id']
    }]
  }, {
    type: undefined,
    decorators: [{
      type: Attribute,
      args: ['type']
    }]
  }], null);
})();
class FormFieldLabelDirective {
  static ɵfac = function FormFieldLabelDirective_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || FormFieldLabelDirective)();
  };
  static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: FormFieldLabelDirective,
    selectors: [["tds-form-field-label"]],
    standalone: true
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FormFieldLabelDirective, [{
    type: Directive,
    args: [{
      selector: 'tds-form-field-label',
      standalone: true
    }]
  }], null, null);
})();
class FormFieldSuffixDirective {
  static ɵfac = function FormFieldSuffixDirective_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || FormFieldSuffixDirective)();
  };
  static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: FormFieldSuffixDirective,
    selectors: [["tds-form-field-suffix"]],
    hostAttrs: [1, "tds-form-field__item-suffix"],
    standalone: true
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FormFieldSuffixDirective, [{
    type: Directive,
    args: [{
      selector: 'tds-form-field-suffix',
      standalone: true,
      host: {
        class: 'tds-form-field__item-suffix'
      }
    }]
  }], null, null);
})();
class FieldHintDirective {
  static ɵfac = function FieldHintDirective_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || FieldHintDirective)();
  };
  static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: FieldHintDirective,
    selectors: [["tds-field-hint"], ["tds-fieldset-hint"], ["tds-form-field-hint"]],
    standalone: true
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FieldHintDirective, [{
    type: Directive,
    args: [{
      selector: 'tds-field-hint, tds-fieldset-hint, tds-form-field-hint',
      standalone: true
    }]
  }], null, null);
})();
class FieldErrorDirective {
  static ɵfac = function FieldErrorDirective_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || FieldErrorDirective)();
  };
  static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: FieldErrorDirective,
    selectors: [["tds-field-error"], ["tds-fieldset-error"], ["tds-form-field-error"]],
    standalone: true
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FieldErrorDirective, [{
    type: Directive,
    args: [{
      selector: 'tds-field-error, tds-fieldset-error, tds-form-field-error',
      standalone: true
    }]
  }], null, null);
})();
class SearchInputDirective {
  onChange = () => {};
  onTouched = () => {};
  /**
   * @ignore
   */
  value = model();
  /**
   * @ignore
   */
  disabled = input(false, {
    transform: booleanAttribute
  });
  /**
   * @ignore
   */
  _disabledInternal = signal(false);
  el = inject(ElementRef);
  cdr = inject(ChangeDetectorRef);
  constructor() {
    effect(() => {
      this._disabledInternal.set(this.disabled());
    }, {
      allowSignalWrites: true
    });
    effect(() => {
      this.onChange(this.computedVal());
    });
  }
  computedVal = computed(() => {
    return this.value() ?? null;
  });
  updateValue(event) {
    const searchInput = event?.target;
    this.value.set(searchInput.value);
    this.cdr.markForCheck();
  }
  clear() {
    this.value.set(null);
  }
  focus() {
    this.input?.focus();
  }
  get input() {
    return this.el?.nativeElement;
  }
  writeValue(value) {
    this.value.set(value);
  }
  registerOnChange(fn) {
    this.onChange = fn;
  }
  registerOnTouched(fn) {
    this.onTouched = fn;
  }
  setDisabledState(isDisabled) {
    this._disabledInternal.set(isDisabled);
  }
  blur() {
    this.onTouched();
  }
  static ɵfac = function SearchInputDirective_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || SearchInputDirective)();
  };
  static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: SearchInputDirective,
    selectors: [["", "tds-search-input", ""]],
    hostAttrs: ["type", "search"],
    hostVars: 2,
    hostBindings: function SearchInputDirective_HostBindings(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵlistener("input", function SearchInputDirective_input_HostBindingHandler($event) {
          return ctx.updateValue($event);
        })("blur", function SearchInputDirective_blur_HostBindingHandler() {
          return ctx.blur();
        });
      }
      if (rf & 2) {
        i0.ɵɵhostProperty("value", ctx.computedVal())("disabled", ctx._disabledInternal() || null);
      }
    },
    inputs: {
      value: [1, "value"],
      disabled: [1, "disabled"]
    },
    outputs: {
      value: "valueChange"
    },
    standalone: true,
    features: [i0.ɵɵProvidersFeature([{
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SearchInputDirective),
      multi: true
    }])]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SearchInputDirective, [{
    type: Directive,
    args: [{
      selector: '[tds-search-input]',
      standalone: true,
      host: {
        '(input)': 'updateValue($event)',
        '[value]': 'computedVal()',
        '(blur)': 'blur()',
        '[disabled]': '_disabledInternal() || null',
        type: 'search'
      },
      providers: [{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => SearchInputDirective),
        multi: true
      }]
    }]
  }], () => [], null);
})();
class HeaderAppLogoDirective {
  static ɵfac = function HeaderAppLogoDirective_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || HeaderAppLogoDirective)();
  };
  static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: HeaderAppLogoDirective,
    selectors: [["", "tds-header-app-logo", ""]],
    hostAttrs: [1, "tds-header-app-logo"],
    standalone: true
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HeaderAppLogoDirective, [{
    type: Directive,
    args: [{
      selector: '[tds-header-app-logo]',
      standalone: true,
      host: {
        class: 'tds-header-app-logo'
      }
    }]
  }], null, null);
})();
class HeaderCenterDirective {
  static ɵfac = function HeaderCenterDirective_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || HeaderCenterDirective)();
  };
  static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: HeaderCenterDirective,
    selectors: [["tds-header-center"]],
    hostAttrs: [1, "tds-header__center"],
    standalone: true
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HeaderCenterDirective, [{
    type: Directive,
    args: [{
      selector: 'tds-header-center',
      standalone: true,
      host: {
        class: 'tds-header__center'
      }
    }]
  }], null, null);
})();
class HeaderEndDirective {
  static ɵfac = function HeaderEndDirective_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || HeaderEndDirective)();
  };
  static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: HeaderEndDirective,
    selectors: [["tds-header-end"]],
    hostAttrs: [1, "tds-header__end"],
    standalone: true
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HeaderEndDirective, [{
    type: Directive,
    args: [{
      selector: 'tds-header-end',
      standalone: true,
      host: {
        class: 'tds-header__end'
      }
    }]
  }], null, null);
})();
class HeaderMobileMenuStartDirective {
  static ɵfac = function HeaderMobileMenuStartDirective_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || HeaderMobileMenuStartDirective)();
  };
  static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: HeaderMobileMenuStartDirective,
    selectors: [["tds-header-mobile-menu-start"]],
    hostAttrs: [1, "tds-header-mobile-menu__start"],
    standalone: true
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HeaderMobileMenuStartDirective, [{
    type: Directive,
    args: [{
      selector: 'tds-header-mobile-menu-start',
      standalone: true,
      host: {
        class: 'tds-header-mobile-menu__start'
      }
    }]
  }], null, null);
})();
class HeaderMobileMenuEndDirective {
  static ɵfac = function HeaderMobileMenuEndDirective_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || HeaderMobileMenuEndDirective)();
  };
  static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: HeaderMobileMenuEndDirective,
    selectors: [["tds-header-mobile-menu-end"]],
    hostAttrs: [1, "tds-header-mobile-menu__end"],
    standalone: true
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HeaderMobileMenuEndDirective, [{
    type: Directive,
    args: [{
      selector: 'tds-header-mobile-menu-end',
      standalone: true,
      host: {
        class: 'tds-header-mobile-menu__end'
      }
    }]
  }], null, null);
})();
class TileTitleDirective {
  static ɵfac = function TileTitleDirective_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || TileTitleDirective)();
  };
  static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: TileTitleDirective,
    selectors: [["tds-tile-title"]],
    hostAttrs: [1, "tds-tile__title"],
    standalone: true
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TileTitleDirective, [{
    type: Directive,
    args: [{
      selector: 'tds-tile-title',
      standalone: true,
      host: {
        class: 'tds-tile__title'
      }
    }]
  }], null, null);
})();
class TileImageDirective {
  defaultClass = 'tds-tile__image';
  defaultAspectRatio = 'auto';
  /**
   * Aspect ratio of the image.
   * @default 'auto'
   */
  aspectRatio = input(this.defaultAspectRatio);
  classes = computed(() => {
    const aspectRatioClass = this.aspectRatio() && this.aspectRatio() !== this.defaultAspectRatio ? `${this.defaultClass}--aspect-ratio-${this.aspectRatio().replace('/', '-')}` : '';
    return `${this.defaultClass} ${aspectRatioClass}`;
  });
  static ɵfac = function TileImageDirective_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || TileImageDirective)();
  };
  static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: TileImageDirective,
    selectors: [["", "tds-tile-image", ""]],
    hostAttrs: ["role", "img"],
    hostVars: 2,
    hostBindings: function TileImageDirective_HostBindings(rf, ctx) {
      if (rf & 2) {
        i0.ɵɵclassMap(ctx.classes());
      }
    },
    inputs: {
      aspectRatio: [1, "aspectRatio"]
    },
    standalone: true
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TileImageDirective, [{
    type: Directive,
    args: [{
      selector: '[tds-tile-image]',
      standalone: true,
      host: {
        '[class]': 'classes()',
        role: 'img'
      }
    }]
  }], null, null);
})();
class NotificationTitleDirective {
  static ɵfac = function NotificationTitleDirective_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || NotificationTitleDirective)();
  };
  static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: NotificationTitleDirective,
    selectors: [["tds-notification-title"]],
    hostAttrs: [1, "tds-notification__title"],
    standalone: true
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NotificationTitleDirective, [{
    type: Directive,
    args: [{
      selector: 'tds-notification-title',
      standalone: true,
      host: {
        class: 'tds-notification__title'
      }
    }]
  }], null, null);
})();
class DatatableThemeDirective {
  defaultClass = 'ag-theme-tds';
  /**
   * @ignore
   * Display zebra style on databtable rows
   * @default false
   */
  tdsDatatableThemeHasZebraRows = input(false);
  /**
   * @ignore
   * Remove the hover effect on rows, useful on basic datatables without action on row
   * @default false
   */
  tdsDatatableThemeShouldRemoveHoverOnRows = input(false);
  /**
   * @ignore
   * Display specific style on header cell when a filter is applied
   * @default false
   */
  tdsDatatableThemeHasFilteredHeaderStyle = input(false);
  classes = computed(() => {
    const hasZebraRowsClass = this.tdsDatatableThemeHasZebraRows() ? `${this.defaultClass}--zebra-rows` : '';
    const withoutHoverableRowClass = this.tdsDatatableThemeShouldRemoveHoverOnRows() ? `${this.defaultClass}--without-hover` : '';
    const withFilter = this.tdsDatatableThemeHasFilteredHeaderStyle() ? `${this.defaultClass}--filtered-header-cell` : '';
    return `${this.defaultClass} ${hasZebraRowsClass} ${withoutHoverableRowClass} ${withFilter}`;
  });
  static ɵfac = function DatatableThemeDirective_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || DatatableThemeDirective)();
  };
  static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: DatatableThemeDirective,
    selectors: [["", "tds-datatable-theme", ""]],
    hostVars: 2,
    hostBindings: function DatatableThemeDirective_HostBindings(rf, ctx) {
      if (rf & 2) {
        i0.ɵɵclassMap(ctx.classes());
      }
    },
    inputs: {
      tdsDatatableThemeHasZebraRows: [1, "tdsDatatableThemeHasZebraRows"],
      tdsDatatableThemeShouldRemoveHoverOnRows: [1, "tdsDatatableThemeShouldRemoveHoverOnRows"],
      tdsDatatableThemeHasFilteredHeaderStyle: [1, "tdsDatatableThemeHasFilteredHeaderStyle"]
    },
    standalone: true
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DatatableThemeDirective, [{
    type: Directive,
    args: [{
      selector: '[tds-datatable-theme]',
      host: {
        '[class]': 'classes()'
      },
      standalone: true
    }]
  }], null, null);
})();
const EXPORTS$4 = [RadioComponent, RadioLabelDirective, RadioInputDirective];
class RadioModule {
  static ɵfac = function RadioModule_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || RadioModule)();
  };
  static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: RadioModule
  });
  static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(RadioModule, [{
    type: NgModule,
    args: [{
      imports: [...EXPORTS$4],
      exports: EXPORTS$4
    }]
  }], null, null);
})();

/**
 * Field helper component is a CDK component that is used to display helper text or error message
 * It is used in combination with form field component
 */
class FieldHelperComponent {
  defaultClass = 'tds-field-helper';
  staticHelperId = genRandomId(`${this.defaultClass}`);
  /**
   * Has error state of the form group.
   * @default false
   */
  hasError = input(false, {
    transform: booleanAttribute
  });
  classes = computed(() => {
    const hasErrorClass = this.hasError() ? `${this.defaultClass}--error` : '';
    return `${this.defaultClass} ${hasErrorClass}`;
  });
  static ɵfac = function FieldHelperComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || FieldHelperComponent)();
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: FieldHelperComponent,
    selectors: [["tds-field-helper"]],
    hostVars: 3,
    hostBindings: function FieldHelperComponent_HostBindings(rf, ctx) {
      if (rf & 2) {
        i0.ɵɵattribute("id", ctx.staticHelperId);
        i0.ɵɵclassMap(ctx.classes());
      }
    },
    inputs: {
      hasError: [1, "hasError"]
    },
    standalone: true,
    features: [i0.ɵɵStandaloneFeature],
    ngContentSelectors: _c12,
    decls: 6,
    vars: 1,
    consts: [["hint", ""], ["error", ""], [1, "tds-field-helper__text"], ["name", "error", "isFilled", "", "size", "xs", "variant", "danger", 1, "tds-field-helper-icon"], [4, "ngTemplateOutlet"]],
    template: function FieldHelperComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵprojectionDef(_c11);
        i0.ɵɵtemplate(0, FieldHelperComponent_Conditional_0_Template, 3, 1)(1, FieldHelperComponent_Conditional_1_Template, 2, 1, "span", 2)(2, FieldHelperComponent_ng_template_2_Template, 1, 0, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor)(4, FieldHelperComponent_ng_template_4_Template, 1, 0, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
      }
      if (rf & 2) {
        i0.ɵɵconditional(ctx.hasError() ? 0 : 1);
      }
    },
    dependencies: [IconComponent, NgTemplateOutlet],
    styles: [".tds-field-helper{align-items:center;color:var(--tds-color-foreground-secondary);display:inline-flex;font:var(--tds-font-helper-text);gap:var(--tds-size-spacing-050)}.tds-field-helper:has(.tds-field-helper__text:empty){display:none}.tds-field-helper--error{color:var(--tds-color-foreground-status-danger)}\n"],
    encapsulation: 2,
    changeDetection: 0
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FieldHelperComponent, [{
    type: Component,
    args: [{
      selector: 'tds-field-helper',
      standalone: true,
      host: {
        '[class]': 'classes()',
        '[attr.id]': 'staticHelperId'
      },
      imports: [IconComponent, NgTemplateOutlet],
      changeDetection: ChangeDetectionStrategy.OnPush,
      encapsulation: ViewEncapsulation.None,
      template: "@if (hasError()) {\n  <tds-icon\n    class=\"tds-field-helper-icon\"\n    name=\"error\"\n    isFilled\n    size=\"xs\"\n    variant=\"danger\" />\n  <span class=\"tds-field-helper__text\">\n    <ng-container *ngTemplateOutlet=\"error\" />\n  </span>\n} @else {\n  <span class=\"tds-field-helper__text\">\n    <ng-container *ngTemplateOutlet=\"hint\" />\n  </span>\n}\n\n<ng-template #hint>\n  <ng-content select=\"tds-field-hint\" />\n</ng-template>\n\n<ng-template #error>\n  <ng-content select=\"tds-field-error\" />\n</ng-template>\n",
      styles: [".tds-field-helper{align-items:center;color:var(--tds-color-foreground-secondary);display:inline-flex;font:var(--tds-font-helper-text);gap:var(--tds-size-spacing-050)}.tds-field-helper:has(.tds-field-helper__text:empty){display:none}.tds-field-helper--error{color:var(--tds-color-foreground-status-danger)}\n"]
    }]
  }], null, null);
})();
class SrOnlyComponent {
  defaultClass = 'tds-sr-only';
  static ɵfac = function SrOnlyComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || SrOnlyComponent)();
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: SrOnlyComponent,
    selectors: [["", "tds-sr-only", ""]],
    hostVars: 2,
    hostBindings: function SrOnlyComponent_HostBindings(rf, ctx) {
      if (rf & 2) {
        i0.ɵɵclassMap(ctx.defaultClass);
      }
    },
    standalone: true,
    features: [i0.ɵɵStandaloneFeature],
    attrs: _c13,
    ngContentSelectors: _c4,
    decls: 1,
    vars: 0,
    template: function SrOnlyComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵprojection(0);
      }
    },
    styles: [".tds-sr-only{border-width:0;clip-path:rect(0 0 0 0);height:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;white-space:nowrap;width:1px}\n"],
    encapsulation: 2,
    changeDetection: 0
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SrOnlyComponent, [{
    type: Component,
    args: [{
      selector: '[tds-sr-only]',
      standalone: true,
      imports: [],
      host: {
        '[class]': 'defaultClass'
      },
      changeDetection: ChangeDetectionStrategy.OnPush,
      encapsulation: ViewEncapsulation.None,
      template: "<ng-content></ng-content>\n",
      styles: [".tds-sr-only{border-width:0;clip-path:rect(0 0 0 0);height:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;white-space:nowrap;width:1px}\n"]
    }]
  }], null, null);
})();
class CompanyLogoComponent {
  defaultClass = 'tds-company-logo';
  static ɵfac = function CompanyLogoComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || CompanyLogoComponent)();
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: CompanyLogoComponent,
    selectors: [["tds-company-logo"]],
    hostVars: 2,
    hostBindings: function CompanyLogoComponent_HostBindings(rf, ctx) {
      if (rf & 2) {
        i0.ɵɵclassMap(ctx.defaultClass);
      }
    },
    standalone: true,
    features: [i0.ɵɵStandaloneFeature],
    decls: 0,
    vars: 0,
    template: function CompanyLogoComponent_Template(rf, ctx) {},
    styles: [".tds-company-logo{background-image:url(data:image/png;base64,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);background-repeat:no-repeat;background-size:contain;display:block;height:100%;width:100%}.dark .tds-company-logo{background-image:url(data:image/png;base64,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)}\n"],
    encapsulation: 2,
    changeDetection: 0
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CompanyLogoComponent, [{
    type: Component,
    args: [{
      selector: 'tds-company-logo',
      standalone: true,
      imports: [],
      host: {
        '[class]': 'defaultClass'
      },
      changeDetection: ChangeDetectionStrategy.OnPush,
      encapsulation: ViewEncapsulation.None,
      template: "",
      styles: [".tds-company-logo{background-image:url(data:image/png;base64,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);background-repeat:no-repeat;background-size:contain;display:block;height:100%;width:100%}.dark .tds-company-logo{background-image:url(data:image/png;base64,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)}\n"]
    }]
  }], null, null);
})();
class FormFieldComponent {
  defaultClass = 'tds-form-field';
  inputChildDirective = contentChild(FormFieldItemDirective);
  /**
   * Has error state of the form group.
   * @default false
   */
  hasError = input(false, {
    transform: booleanAttribute
  });
  helper = viewChild(FieldHelperComponent);
  hint = contentChild(FieldHintDirective, {
    descendants: true
  });
  error = contentChild(FieldErrorDirective, {
    descendants: true
  });
  _helperId = computed(() => {
    return this.hint() || this.error() ? this.helper()?.staticHelperId : undefined;
  });
  _inputId = computed(() => {
    return this.inputChildDirective()?.inputId();
  });
  /**
   * @ignore
   */
  _focusInputChild(event) {
    event.preventDefault();
    event.stopPropagation();
    this.inputChildDirective()?.focus();
  }
  static ɵfac = function FormFieldComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || FormFieldComponent)();
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: FormFieldComponent,
    selectors: [["tds-form-field"]],
    contentQueries: function FormFieldComponent_ContentQueries(rf, ctx, dirIndex) {
      if (rf & 1) {
        i0.ɵɵcontentQuerySignal(dirIndex, ctx.inputChildDirective, FormFieldItemDirective, 5);
        i0.ɵɵcontentQuerySignal(dirIndex, ctx.hint, FieldHintDirective, 5);
        i0.ɵɵcontentQuerySignal(dirIndex, ctx.error, FieldErrorDirective, 5);
      }
      if (rf & 2) {
        i0.ɵɵqueryAdvance(3);
      }
    },
    viewQuery: function FormFieldComponent_Query(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵviewQuerySignal(ctx.helper, FieldHelperComponent, 5);
      }
      if (rf & 2) {
        i0.ɵɵqueryAdvance();
      }
    },
    hostVars: 3,
    hostBindings: function FormFieldComponent_HostBindings(rf, ctx) {
      if (rf & 2) {
        i0.ɵɵattribute("aria-describedby", ctx._helperId());
        i0.ɵɵclassMap(ctx.defaultClass);
      }
    },
    inputs: {
      hasError: [1, "hasError"]
    },
    standalone: true,
    features: [i0.ɵɵStandaloneFeature],
    ngContentSelectors: _c15,
    decls: 10,
    vars: 4,
    consts: [[1, "tds-form-field__label", 3, "for"], [1, "tds-form-field__label-required-mark"], [1, "tds-form-field__item", 3, "click"], [3, "hasError"]],
    template: function FormFieldComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵprojectionDef(_c14);
        i0.ɵɵelementStart(0, "label", 0);
        i0.ɵɵprojection(1);
        i0.ɵɵelementStart(2, "span", 1);
        i0.ɵɵtext(3, "*");
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(4, "div", 2);
        i0.ɵɵlistener("click", function FormFieldComponent_Template_div_click_4_listener($event) {
          return ctx._focusInputChild($event);
        });
        i0.ɵɵprojection(5, 1);
        i0.ɵɵprojection(6, 2);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(7, "tds-field-helper", 3);
        i0.ɵɵprojection(8, 3, ["ngProjectAs", "tds-field-hint", 5, ["tds-field-hint"]]);
        i0.ɵɵprojection(9, 4, ["ngProjectAs", "tds-field-error", 5, ["tds-field-error"]]);
        i0.ɵɵelementEnd();
      }
      if (rf & 2) {
        i0.ɵɵproperty("for", ctx._inputId());
        i0.ɵɵadvance(4);
        i0.ɵɵclassProp("tds-form-field__item--error", ctx.hasError());
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("hasError", ctx.hasError());
      }
    },
    dependencies: [FieldHelperComponent],
    styles: [".tds-form-field__item:has(input):hover:not(:has(input:disabled)):not(.tds-form-field__item--error),.tds-form-field__item:has(select):hover:not(:has(select:disabled)):not(.tds-form-field__item--error),.tds-form-field__item:has(textarea):hover:not(:has(textarea:disabled)):not(.tds-form-field__item--error){--tds-local-form-field-border-color:var(--tds-color-border-hover)}.tds-form-field__item:has(input):has(input:active:not(:disabled)):not(.tds-form-field__item--error),.tds-form-field__item:has(input):has(input:focus-visible:not(:disabled)):not(.tds-form-field__item--error),.tds-form-field__item:has(input):has(input:focus:not(:disabled)):not(.tds-form-field__item--error),.tds-form-field__item:has(select):has(select:active:not(:disabled)):not(.tds-form-field__item--error),.tds-form-field__item:has(select):has(select:focus-visible:not(:disabled)):not(.tds-form-field__item--error),.tds-form-field__item:has(select):has(select:focus:not(:disabled)):not(.tds-form-field__item--error),.tds-form-field__item:has(textarea):has(textarea:active:not(:disabled)):not(.tds-form-field__item--error),.tds-form-field__item:has(textarea):has(textarea:focus-visible:not(:disabled)):not(.tds-form-field__item--error),.tds-form-field__item:has(textarea):has(textarea:focus:not(:disabled)):not(.tds-form-field__item--error){--tds-local-form-field-border-color:var(--tds-color-border-selected)}.tds-form-field__item--error{--tds-local-form-field-border-color:var(--tds-color-border-status-danger)}.tds-form-field{--tds-local-container-vertical-gap:var(--tds-size-spacing-050);--tds-local-form-field-border-color:var(--tds-color-border-subtle);all:unset;-webkit-font-smoothing:antialiased;align-items:flex-start;display:flex;flex-direction:column;gap:var(--tds-local-container-vertical-gap)}.tds-form-field,.tds-form-field *,.tds-form-field :after,.tds-form-field :before{box-sizing:border-box}.tds-form-field:has(input:disabled),.tds-form-field:has(select:disabled),.tds-form-field:has(textarea:disabled){cursor:not-allowed;opacity:var(--tds-opacity-disabled)}.tds-form-field:has(tds-form-field-label):has(input:required) .tds-form-field__label-required-mark,.tds-form-field:has(tds-form-field-label):has(select:required) .tds-form-field__label-required-mark,.tds-form-field:has(tds-form-field-label):has(textarea:required) .tds-form-field__label-required-mark{display:inline-block}.tds-form-field__label{color:var(--tds-color-foreground-secondary);display:flex;font:var(--tds-font-label);gap:var(--tds-size-spacing-025)}.tds-form-field__label:not(:has(tds-form-field-label)){display:none}.tds-form-field__label-required-mark{color:var(--tds-color-foreground-status-danger);display:none}.tds-form-field__item{--tds-local-form-field-padding:9px var(--tds-size-spacing-150);align-items:center;background:var(--tds-color-background-field);border:solid var(--tds-size-border-thin) var(--tds-local-form-field-border-color);border-radius:var(--tds-size-radius-050);box-sizing:border-box;color:var(--tds-color-foreground-primary);display:flex;font:var(--tds-font-body-2);gap:var(--tds-size-spacing-100);min-height:40px;outline:none;position:relative}.tds-form-field__item *,.tds-form-field__item :after,.tds-form-field__item :before{box-sizing:border-box}.tds-form-field__item:has(>input){padding:var(--tds-local-form-field-padding)}.tds-form-field__item:has(input:not(:disabled)),.tds-form-field__item:has(textarea:not(:disabled)){cursor:text}.tds-form-field__item:has(input:not(:disabled)) .tds-form-field__item-suffix,.tds-form-field__item:has(textarea:not(:disabled)) .tds-form-field__item-suffix{cursor:default}.tds-form-field__item:has(select):after{background:currentColor;content:\"\";height:var(--tds-component-icon-size-sm);-webkit-mask-image:url('data:image/svg+xml;charset=US-ASCII,<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 -960 960 960\"><path d=\"M480-361q-8 0-15-2.5t-13-8.5L268-556q-11-11-11-28t11-28q11-11 28-11t28 11l156 156 156-156q11-11 28-11t28 11q11 11 11 28t-11 28L508-372q-6 6-13 8.5t-15 2.5Z\"/></svg>');mask-image:url('data:image/svg+xml;charset=US-ASCII,<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 -960 960 960\"><path d=\"M480-361q-8 0-15-2.5t-13-8.5L268-556q-11-11-11-28t11-28q11-11 28-11t28 11l156 156 156-156q11-11 28-11t28 11q11 11 11 28t-11 28L508-372q-6 6-13 8.5t-15 2.5Z\"/></svg>');pointer-events:none;position:absolute;right:var(--tds-size-spacing-150);top:50%;transform:translateY(-50%);width:var(--tds-component-icon-size-sm)}.tds-form-field__item:has(select) .tds-form-field__item-suffix{display:none}.tds-form-field__item:has(select:not(:disabled)){cursor:pointer}.tds-form-field__item:has(.tds-search){gap:0}.tds-form-field__item:has(.tds-search) .tds-form-field__item-suffix{padding-right:var(--tds-size-spacing-150)}.tds-form-field__item>input{all:unset;flex-grow:1;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.tds-form-field__item>textarea{all:unset;-webkit-appearance:none;appearance:none;background:inherit;border:none;border-radius:inherit;color:inherit;flex-grow:1;font:inherit;outline:none;padding:var(--tds-local-form-field-padding);resize:vertical}.tds-form-field__item>select{all:unset;-webkit-appearance:none;appearance:none;background:inherit;border:none;border-radius:inherit;color:inherit;flex-grow:1;font:inherit;outline:none;padding:var(--tds-local-form-field-padding);padding-right:calc(var(--tds-size-spacing-150) + var(--tds-component-icon-size-sm) + var(--tds-size-spacing-100))}.tds-form-field__item input::placeholder,.tds-form-field__item textarea::placeholder{color:var(--tds-color-foreground-secondary);font:inherit}.tds-form-field__item:has(input):not(:has(input[size])){align-self:stretch}.tds-form-field__item:has(textarea):not(:has(textarea[cols])){align-self:stretch}.tds-form-field__item:has(select){align-self:stretch}.tds-form-field__item-suffix{color:var(--tds-color-foreground-secondary);font:var(--tds-font-helper-text)}\n"],
    encapsulation: 2,
    changeDetection: 0
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FormFieldComponent, [{
    type: Component,
    args: [{
      selector: 'tds-form-field',
      standalone: true,
      imports: [FieldHelperComponent, NgIf],
      host: {
        '[class]': 'defaultClass',
        '[attr.aria-describedby]': '_helperId()'
      },
      changeDetection: ChangeDetectionStrategy.OnPush,
      encapsulation: ViewEncapsulation.None,
      template: "<label\n  class=\"tds-form-field__label\"\n  [for]=\"_inputId()\">\n  <ng-content select=\"tds-form-field-label\"></ng-content>\n  <span class=\"tds-form-field__label-required-mark\">*</span>\n</label>\n<div\n  class=\"tds-form-field__item\"\n  [class.tds-form-field__item--error]=\"hasError()\"\n  (click)=\"_focusInputChild($event)\">\n  <ng-content select=\"[tds-form-field-item]\"></ng-content>\n  <ng-content select=\"tds-form-field-suffix\"></ng-content>\n</div>\n<tds-field-helper [hasError]=\"hasError()\">\n  <ng-content\n    ngProjectAs=\"tds-field-hint\"\n    select=\"tds-form-field-hint\"></ng-content>\n  <ng-content\n    ngProjectAs=\"tds-field-error\"\n    select=\"tds-form-field-error\"></ng-content>\n</tds-field-helper>\n",
      styles: [".tds-form-field__item:has(input):hover:not(:has(input:disabled)):not(.tds-form-field__item--error),.tds-form-field__item:has(select):hover:not(:has(select:disabled)):not(.tds-form-field__item--error),.tds-form-field__item:has(textarea):hover:not(:has(textarea:disabled)):not(.tds-form-field__item--error){--tds-local-form-field-border-color:var(--tds-color-border-hover)}.tds-form-field__item:has(input):has(input:active:not(:disabled)):not(.tds-form-field__item--error),.tds-form-field__item:has(input):has(input:focus-visible:not(:disabled)):not(.tds-form-field__item--error),.tds-form-field__item:has(input):has(input:focus:not(:disabled)):not(.tds-form-field__item--error),.tds-form-field__item:has(select):has(select:active:not(:disabled)):not(.tds-form-field__item--error),.tds-form-field__item:has(select):has(select:focus-visible:not(:disabled)):not(.tds-form-field__item--error),.tds-form-field__item:has(select):has(select:focus:not(:disabled)):not(.tds-form-field__item--error),.tds-form-field__item:has(textarea):has(textarea:active:not(:disabled)):not(.tds-form-field__item--error),.tds-form-field__item:has(textarea):has(textarea:focus-visible:not(:disabled)):not(.tds-form-field__item--error),.tds-form-field__item:has(textarea):has(textarea:focus:not(:disabled)):not(.tds-form-field__item--error){--tds-local-form-field-border-color:var(--tds-color-border-selected)}.tds-form-field__item--error{--tds-local-form-field-border-color:var(--tds-color-border-status-danger)}.tds-form-field{--tds-local-container-vertical-gap:var(--tds-size-spacing-050);--tds-local-form-field-border-color:var(--tds-color-border-subtle);all:unset;-webkit-font-smoothing:antialiased;align-items:flex-start;display:flex;flex-direction:column;gap:var(--tds-local-container-vertical-gap)}.tds-form-field,.tds-form-field *,.tds-form-field :after,.tds-form-field :before{box-sizing:border-box}.tds-form-field:has(input:disabled),.tds-form-field:has(select:disabled),.tds-form-field:has(textarea:disabled){cursor:not-allowed;opacity:var(--tds-opacity-disabled)}.tds-form-field:has(tds-form-field-label):has(input:required) .tds-form-field__label-required-mark,.tds-form-field:has(tds-form-field-label):has(select:required) .tds-form-field__label-required-mark,.tds-form-field:has(tds-form-field-label):has(textarea:required) .tds-form-field__label-required-mark{display:inline-block}.tds-form-field__label{color:var(--tds-color-foreground-secondary);display:flex;font:var(--tds-font-label);gap:var(--tds-size-spacing-025)}.tds-form-field__label:not(:has(tds-form-field-label)){display:none}.tds-form-field__label-required-mark{color:var(--tds-color-foreground-status-danger);display:none}.tds-form-field__item{--tds-local-form-field-padding:9px var(--tds-size-spacing-150);align-items:center;background:var(--tds-color-background-field);border:solid var(--tds-size-border-thin) var(--tds-local-form-field-border-color);border-radius:var(--tds-size-radius-050);box-sizing:border-box;color:var(--tds-color-foreground-primary);display:flex;font:var(--tds-font-body-2);gap:var(--tds-size-spacing-100);min-height:40px;outline:none;position:relative}.tds-form-field__item *,.tds-form-field__item :after,.tds-form-field__item :before{box-sizing:border-box}.tds-form-field__item:has(>input){padding:var(--tds-local-form-field-padding)}.tds-form-field__item:has(input:not(:disabled)),.tds-form-field__item:has(textarea:not(:disabled)){cursor:text}.tds-form-field__item:has(input:not(:disabled)) .tds-form-field__item-suffix,.tds-form-field__item:has(textarea:not(:disabled)) .tds-form-field__item-suffix{cursor:default}.tds-form-field__item:has(select):after{background:currentColor;content:\"\";height:var(--tds-component-icon-size-sm);-webkit-mask-image:url('data:image/svg+xml;charset=US-ASCII,<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 -960 960 960\"><path d=\"M480-361q-8 0-15-2.5t-13-8.5L268-556q-11-11-11-28t11-28q11-11 28-11t28 11l156 156 156-156q11-11 28-11t28 11q11 11 11 28t-11 28L508-372q-6 6-13 8.5t-15 2.5Z\"/></svg>');mask-image:url('data:image/svg+xml;charset=US-ASCII,<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 -960 960 960\"><path d=\"M480-361q-8 0-15-2.5t-13-8.5L268-556q-11-11-11-28t11-28q11-11 28-11t28 11l156 156 156-156q11-11 28-11t28 11q11 11 11 28t-11 28L508-372q-6 6-13 8.5t-15 2.5Z\"/></svg>');pointer-events:none;position:absolute;right:var(--tds-size-spacing-150);top:50%;transform:translateY(-50%);width:var(--tds-component-icon-size-sm)}.tds-form-field__item:has(select) .tds-form-field__item-suffix{display:none}.tds-form-field__item:has(select:not(:disabled)){cursor:pointer}.tds-form-field__item:has(.tds-search){gap:0}.tds-form-field__item:has(.tds-search) .tds-form-field__item-suffix{padding-right:var(--tds-size-spacing-150)}.tds-form-field__item>input{all:unset;flex-grow:1;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.tds-form-field__item>textarea{all:unset;-webkit-appearance:none;appearance:none;background:inherit;border:none;border-radius:inherit;color:inherit;flex-grow:1;font:inherit;outline:none;padding:var(--tds-local-form-field-padding);resize:vertical}.tds-form-field__item>select{all:unset;-webkit-appearance:none;appearance:none;background:inherit;border:none;border-radius:inherit;color:inherit;flex-grow:1;font:inherit;outline:none;padding:var(--tds-local-form-field-padding);padding-right:calc(var(--tds-size-spacing-150) + var(--tds-component-icon-size-sm) + var(--tds-size-spacing-100))}.tds-form-field__item input::placeholder,.tds-form-field__item textarea::placeholder{color:var(--tds-color-foreground-secondary);font:inherit}.tds-form-field__item:has(input):not(:has(input[size])){align-self:stretch}.tds-form-field__item:has(textarea):not(:has(textarea[cols])){align-self:stretch}.tds-form-field__item:has(select){align-self:stretch}.tds-form-field__item-suffix{color:var(--tds-color-foreground-secondary);font:var(--tds-font-helper-text)}\n"]
    }]
  }], null, null);
})();
const EXPORTS$3 = [FormFieldComponent, FormFieldLabelDirective, FormFieldItemDirective, FormFieldSuffixDirective, FieldErrorDirective, FieldHintDirective];
class FormFieldModule {
  static ɵfac = function FormFieldModule_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || FormFieldModule)();
  };
  static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: FormFieldModule
  });
  static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FormFieldModule, [{
    type: NgModule,
    args: [{
      declarations: [],
      imports: [...EXPORTS$3],
      exports: EXPORTS$3
    }]
  }], null, null);
})();
const TYPO_HOST = {
  '[class]': 'classes()'
};
class TypographyComponent {
  defaultClass = 'tds-typography';
  defaultVariant = 'body-2';
  /**
   * Typography variant
   */
  variant = input(this.defaultVariant);
  classes = computed(() => `${this.defaultClass} ${this.defaultClass}--${this.variant()}`);
  static ɵfac = function TypographyComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || TypographyComponent)();
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: TypographyComponent,
    selectors: [["", "tds-typography", ""]],
    hostVars: 2,
    hostBindings: function TypographyComponent_HostBindings(rf, ctx) {
      if (rf & 2) {
        i0.ɵɵclassMap(ctx.classes());
      }
    },
    inputs: {
      variant: [1, "variant"]
    },
    standalone: true,
    features: [i0.ɵɵStandaloneFeature],
    attrs: _c16,
    ngContentSelectors: _c4,
    decls: 1,
    vars: 0,
    template: function TypographyComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵprojection(0);
      }
    },
    styles: [".tds-typography{color:var(--tds-color-foreground-primary)}.tds-typography--display-1{font:var(--tds-font-display-1)}.tds-typography--display-2{font:var(--tds-font-display-2)}.tds-typography--heading-1{font:var(--tds-font-heading-1)}.tds-typography--heading-2{font:var(--tds-font-heading-2)}.tds-typography--heading-3{font:var(--tds-font-heading-3)}.tds-typography--heading-4{font:var(--tds-font-heading-4)}.tds-typography--heading-5{font:var(--tds-font-heading-5)}.tds-typography--heading-6{font:var(--tds-font-heading-6)}.tds-typography--body-1{font:var(--tds-font-body-1)}.tds-typography--body-2{font:var(--tds-font-body-2)}.tds-typography--helper-text{font:var(--tds-font-helper-text)}.tds-typography--caption{font:var(--tds-font-caption);letter-spacing:.2px}.tds-typography--code-1{font:var(--tds-font-code-1)}.tds-typography--code-2{font:var(--tds-font-code-2)}.tds-typography--numeric-1{font:var(--tds-font-body-1);font-variant-numeric:lining-nums tabular-nums}.tds-typography--numeric-2{font:var(--tds-font-body-2);font-variant-numeric:lining-nums tabular-nums}\n"],
    encapsulation: 2,
    changeDetection: 0
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TypographyComponent, [{
    type: Component,
    args: [{
      selector: '[tds-typography]',
      standalone: true,
      imports: [],
      host: TYPO_HOST,
      changeDetection: ChangeDetectionStrategy.OnPush,
      encapsulation: ViewEncapsulation.None,
      template: "<ng-content></ng-content>\n",
      styles: [".tds-typography{color:var(--tds-color-foreground-primary)}.tds-typography--display-1{font:var(--tds-font-display-1)}.tds-typography--display-2{font:var(--tds-font-display-2)}.tds-typography--heading-1{font:var(--tds-font-heading-1)}.tds-typography--heading-2{font:var(--tds-font-heading-2)}.tds-typography--heading-3{font:var(--tds-font-heading-3)}.tds-typography--heading-4{font:var(--tds-font-heading-4)}.tds-typography--heading-5{font:var(--tds-font-heading-5)}.tds-typography--heading-6{font:var(--tds-font-heading-6)}.tds-typography--body-1{font:var(--tds-font-body-1)}.tds-typography--body-2{font:var(--tds-font-body-2)}.tds-typography--helper-text{font:var(--tds-font-helper-text)}.tds-typography--caption{font:var(--tds-font-caption);letter-spacing:.2px}.tds-typography--code-1{font:var(--tds-font-code-1)}.tds-typography--code-2{font:var(--tds-font-code-2)}.tds-typography--numeric-1{font:var(--tds-font-body-1);font-variant-numeric:lining-nums tabular-nums}.tds-typography--numeric-2{font:var(--tds-font-body-2);font-variant-numeric:lining-nums tabular-nums}\n"]
    }]
  }], null, null);
})();

/**
 * TYPOGRAPHY_VARIANTS is an array of all the possible typography variants. Used to define `TypographyVariant` union type. Useful for looping through all possible typography variants.
 */
const TYPOGRAPHY_VARIANTS = ['display-1', 'display-2', 'heading-1', 'heading-2', 'heading-3', 'heading-4', 'heading-5', 'heading-6', 'body-1', 'body-2', 'numeric-1', 'numeric-2', 'code-1', 'code-2', 'helper-text', 'caption'];
class FieldsetComponent {
  defaultClass = 'tds-fieldset';
  defaultOrientation = 'vertical';
  /**
   * Orientation of the form group.
   * If set to `horizontal`, the form inputs will be displayed horizontally and will wrap to next line if needed.
   * @default 'vertical'
   */
  orientation = input(this.defaultOrientation);
  /**
   * Has error state of the form group.
   * @default false
   */
  hasError = input(false, {
    transform: booleanAttribute
  });
  helperEl = viewChild(FieldHelperComponent);
  errorEl = contentChild(FieldErrorDirective, {
    descendants: true
  });
  hintEl = contentChild(FieldHintDirective, {
    descendants: true
  });
  _helperId = computed(() => {
    return this.hintEl() || this.errorEl() ? this.helperEl()?.staticHelperId : undefined;
  });
  classes = computed(() => {
    const orientationClass = this.orientation() && this.orientation() !== this.defaultOrientation ? `${this.defaultClass}--${this.orientation()}` : '';
    const hasErrorClass = this.hasError() ? `${this.defaultClass}--error` : '';
    return `${this.defaultClass} ${orientationClass} ${hasErrorClass}`;
  });
  static ɵfac = function FieldsetComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || FieldsetComponent)();
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: FieldsetComponent,
    selectors: [["fieldset", "tds-fieldset", ""]],
    contentQueries: function FieldsetComponent_ContentQueries(rf, ctx, dirIndex) {
      if (rf & 1) {
        i0.ɵɵcontentQuerySignal(dirIndex, ctx.errorEl, FieldErrorDirective, 5);
        i0.ɵɵcontentQuerySignal(dirIndex, ctx.hintEl, FieldHintDirective, 5);
      }
      if (rf & 2) {
        i0.ɵɵqueryAdvance(2);
      }
    },
    viewQuery: function FieldsetComponent_Query(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵviewQuerySignal(ctx.helperEl, FieldHelperComponent, 5);
      }
      if (rf & 2) {
        i0.ɵɵqueryAdvance();
      }
    },
    hostVars: 3,
    hostBindings: function FieldsetComponent_HostBindings(rf, ctx) {
      if (rf & 2) {
        i0.ɵɵattribute("aria-describedby", ctx._helperId());
        i0.ɵɵclassMap(ctx.classes());
      }
    },
    inputs: {
      orientation: [1, "orientation"],
      hasError: [1, "hasError"]
    },
    standalone: true,
    features: [i0.ɵɵStandaloneFeature],
    attrs: _c17,
    ngContentSelectors: _c19,
    decls: 7,
    vars: 1,
    consts: [[1, "tds-fieldset__label"], [1, "tds-fieldset__inputs"], [3, "hasError"]],
    template: function FieldsetComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵprojectionDef(_c18);
        i0.ɵɵelementStart(0, "legend", 0);
        i0.ɵɵprojection(1);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(2, "div", 1);
        i0.ɵɵprojection(3, 1);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(4, "tds-field-helper", 2);
        i0.ɵɵprojection(5, 2, ["ngProjectAs", "tds-field-hint", 5, ["tds-field-hint"]]);
        i0.ɵɵprojection(6, 3, ["ngProjectAs", "tds-field-error", 5, ["tds-field-error"]]);
        i0.ɵɵelementEnd();
      }
      if (rf & 2) {
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("hasError", ctx.hasError());
      }
    },
    dependencies: [FieldHelperComponent],
    styles: [".tds-fieldset{--tds-local-helper-text-color:var(--tds-color-foreground-secondary);--tds-local-fieldset-spacing:var(--tds-size-spacing-100);all:unset;-webkit-font-smoothing:antialiased;align-items:flex-start;display:flex;flex-direction:column;gap:var(--tds-local-fieldset-spacing)}.tds-fieldset,.tds-fieldset *,.tds-fieldset :after,.tds-fieldset :before{box-sizing:border-box}.tds-fieldset__label{all:unset;-webkit-font-smoothing:antialiased;color:var(--tds-color-foreground-secondary);font:var(--tds-font-label);padding-bottom:var(--tds-local-fieldset-spacing)}.tds-fieldset__label:empty{display:none}.tds-fieldset__label:after{color:var(--tds-color-foreground-status-danger);content:\"*\";display:none;margin-left:var(--tds-size-spacing-050)}.tds-fieldset__inputs{display:flex;flex-direction:column;gap:var(--tds-size-spacing-100)}.tds-fieldset--horizontal .tds-fieldset__inputs{flex-direction:row;flex-wrap:wrap;gap:var(--tds-size-spacing-100) var(--tds-size-spacing-200)}.tds-fieldset:has(input:required) .tds-fieldset__label:after{display:inline-block}\n"],
    encapsulation: 2,
    changeDetection: 0
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FieldsetComponent, [{
    type: Component,
    args: [{
      selector: 'fieldset[tds-fieldset]',
      standalone: true,
      imports: [FieldHelperComponent, NgClass, NgTemplateOutlet],
      host: {
        '[class]': 'classes()',
        '[attr.aria-describedby]': '_helperId()'
      },
      changeDetection: ChangeDetectionStrategy.OnPush,
      encapsulation: ViewEncapsulation.None,
      template: "<legend class=\"tds-fieldset__label\">\n  <ng-content select=\"tds-fieldset-label\" />\n</legend>\n<div class=\"tds-fieldset__inputs\">\n  <ng-content />\n</div>\n\n<tds-field-helper [hasError]=\"hasError()\">\n  <ng-content\n    ngProjectAs=\"tds-field-hint\"\n    select=\"tds-fieldset-hint\"></ng-content>\n  <ng-content\n    ngProjectAs=\"tds-field-error\"\n    select=\"tds-fieldset-error\"></ng-content>\n</tds-field-helper>\n",
      styles: [".tds-fieldset{--tds-local-helper-text-color:var(--tds-color-foreground-secondary);--tds-local-fieldset-spacing:var(--tds-size-spacing-100);all:unset;-webkit-font-smoothing:antialiased;align-items:flex-start;display:flex;flex-direction:column;gap:var(--tds-local-fieldset-spacing)}.tds-fieldset,.tds-fieldset *,.tds-fieldset :after,.tds-fieldset :before{box-sizing:border-box}.tds-fieldset__label{all:unset;-webkit-font-smoothing:antialiased;color:var(--tds-color-foreground-secondary);font:var(--tds-font-label);padding-bottom:var(--tds-local-fieldset-spacing)}.tds-fieldset__label:empty{display:none}.tds-fieldset__label:after{color:var(--tds-color-foreground-status-danger);content:\"*\";display:none;margin-left:var(--tds-size-spacing-050)}.tds-fieldset__inputs{display:flex;flex-direction:column;gap:var(--tds-size-spacing-100)}.tds-fieldset--horizontal .tds-fieldset__inputs{flex-direction:row;flex-wrap:wrap;gap:var(--tds-size-spacing-100) var(--tds-size-spacing-200)}.tds-fieldset:has(input:required) .tds-fieldset__label:after{display:inline-block}\n"]
    }]
  }], null, null);
})();
const EXPORTS$2 = [FieldsetComponent, FieldsetLabelDirective, FieldHintDirective, FieldErrorDirective];
class FieldsetModule {
  static ɵfac = function FieldsetModule_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || FieldsetModule)();
  };
  static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: FieldsetModule
  });
  static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FieldsetModule, [{
    type: NgModule,
    args: [{
      imports: [...EXPORTS$2],
      exports: EXPORTS$2
    }]
  }], null, null);
})();
class IconButtonComponent {
  defaultClass = 'tds-icon-button';
  /**
   * Icon button label, this is required for accessibility and is used to display a tooltip when the button is hovered.
   * Make sure to provide a meaningful label describing the action that the button performs.
   */
  label = input.required();
  /**
   * Icon button size
   * @default 'md'
   */
  size = input(DEFAULT_SIZE_VALUE);
  classes = computed(() => {
    const sizeClass = this.size() && this.size() !== DEFAULT_SIZE_VALUE ? `${this.defaultClass}--${this.size()}` : '';
    return `${this.defaultClass} ${sizeClass}`;
  });
  static ɵfac = function IconButtonComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || IconButtonComponent)();
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: IconButtonComponent,
    selectors: [["button", "tds-icon-button", ""]],
    hostVars: 3,
    hostBindings: function IconButtonComponent_HostBindings(rf, ctx) {
      if (rf & 2) {
        i0.ɵɵhostProperty("title", ctx.label());
        i0.ɵɵclassMap(ctx.classes());
      }
    },
    inputs: {
      label: [1, "label"],
      size: [1, "size"]
    },
    standalone: true,
    features: [i0.ɵɵStandaloneFeature],
    attrs: _c20,
    ngContentSelectors: _c4,
    decls: 3,
    vars: 1,
    consts: [["tds-sr-only", ""]],
    template: function IconButtonComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵelementStart(0, "span", 0);
        i0.ɵɵtext(1);
        i0.ɵɵelementEnd();
        i0.ɵɵprojection(2);
      }
      if (rf & 2) {
        i0.ɵɵadvance();
        i0.ɵɵtextInterpolate(ctx.label());
      }
    },
    dependencies: [SrOnlyComponent],
    styles: [".tds-icon-button{all:unset;align-items:center;background:var(--tds-component-icon-button-color-background-default);border-radius:var(--tds-component-icon-button-size-radius);color:var(--tds-component-icon-button-color-foreground);cursor:pointer;display:inline-flex;justify-content:center;min-height:var(--tds-local-icon-button-size);min-width:var(--tds-local-icon-button-size);padding:var(--tds-local-icon-button-padding);--tds-local-icon-button-size:var(--tds-component-icon-button-size-md);--tds-local-icon-button-padding:var(--tds-component-icon-button-size-padding-md);--tds-local-icon-button-icon-size:var(--tds-component-icon-size-sm)}.tds-icon-button,.tds-icon-button *,.tds-icon-button :after,.tds-icon-button :before{box-sizing:border-box}.tds-icon-button>*{font-size:var(--tds-local-icon-button-icon-size);height:var(--tds-local-icon-button-icon-size);width:var(--tds-local-icon-button-icon-size)}.tds-icon-button .tds-icon{--tds-local-icon-size:var(--tds-local-icon-button-icon-size);--tds-local-icon-color-text:inherit}.tds-icon-button:focus-visible{outline:solid var(--tds-size-border-medium) var(--tds-color-border-focus);outline-offset:var(--tds-size-spacing-025)}.tds-icon-button>*{color:var(--tds-component-icon-button-color-foreground)}.tds-icon-button:hover:not(:disabled):not(:active){background:var(--tds-component-icon-button-color-background-hover)}.tds-icon-button:active:not(:disabled){background:var(--tds-component-icon-button-color-background-active)}.tds-icon-button:disabled{cursor:not-allowed;opacity:var(--tds-opacity-disabled)}.tds-icon-button--sm{--tds-local-icon-button-size:var(--tds-component-icon-button-size-sm);--tds-local-icon-button-padding:var(--tds-component-icon-button-size-padding-sm);--tds-local-icon-button-icon-size:var(--tds-component-icon-size-sm);--tds-local-icon-button-icon-size:var(--tds-component-icon-size-xs)}.tds-icon-button--sm>*{font-size:var(--tds-local-icon-button-icon-size);height:var(--tds-local-icon-button-icon-size);width:var(--tds-local-icon-button-icon-size)}.tds-icon-button--sm .tds-icon{--tds-local-icon-size:var(--tds-local-icon-button-icon-size);--tds-local-icon-color-text:inherit}.tds-icon-button--md{--tds-local-icon-button-size:var(--tds-component-icon-button-size-md);--tds-local-icon-button-padding:var(--tds-component-icon-button-size-padding-md);--tds-local-icon-button-icon-size:var(--tds-component-icon-size-sm)}.tds-icon-button--md>*{font-size:var(--tds-local-icon-button-icon-size);height:var(--tds-local-icon-button-icon-size);width:var(--tds-local-icon-button-icon-size)}.tds-icon-button--md .tds-icon{--tds-local-icon-size:var(--tds-local-icon-button-icon-size);--tds-local-icon-color-text:inherit}.tds-icon-button--lg{--tds-local-icon-button-size:var(--tds-component-icon-button-size-lg);--tds-local-icon-button-padding:var(--tds-component-icon-button-size-padding-lg);--tds-local-icon-button-icon-size:var(--tds-component-icon-size-sm);--tds-local-icon-button-icon-size:var(--tds-component-icon-size-md)}.tds-icon-button--lg>*{font-size:var(--tds-local-icon-button-icon-size);height:var(--tds-local-icon-button-icon-size);width:var(--tds-local-icon-button-icon-size)}.tds-icon-button--lg .tds-icon{--tds-local-icon-size:var(--tds-local-icon-button-icon-size);--tds-local-icon-color-text:inherit}\n"],
    encapsulation: 2,
    changeDetection: 0
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(IconButtonComponent, [{
    type: Component,
    args: [{
      selector: 'button[tds-icon-button]',
      standalone: true,
      imports: [SrOnlyComponent],
      host: {
        '[class]': 'classes()',
        '[title]': 'label()'
      },
      changeDetection: ChangeDetectionStrategy.OnPush,
      encapsulation: ViewEncapsulation.None,
      template: "<span tds-sr-only>{{ label() }}</span>\n<ng-content></ng-content>\n",
      styles: [".tds-icon-button{all:unset;align-items:center;background:var(--tds-component-icon-button-color-background-default);border-radius:var(--tds-component-icon-button-size-radius);color:var(--tds-component-icon-button-color-foreground);cursor:pointer;display:inline-flex;justify-content:center;min-height:var(--tds-local-icon-button-size);min-width:var(--tds-local-icon-button-size);padding:var(--tds-local-icon-button-padding);--tds-local-icon-button-size:var(--tds-component-icon-button-size-md);--tds-local-icon-button-padding:var(--tds-component-icon-button-size-padding-md);--tds-local-icon-button-icon-size:var(--tds-component-icon-size-sm)}.tds-icon-button,.tds-icon-button *,.tds-icon-button :after,.tds-icon-button :before{box-sizing:border-box}.tds-icon-button>*{font-size:var(--tds-local-icon-button-icon-size);height:var(--tds-local-icon-button-icon-size);width:var(--tds-local-icon-button-icon-size)}.tds-icon-button .tds-icon{--tds-local-icon-size:var(--tds-local-icon-button-icon-size);--tds-local-icon-color-text:inherit}.tds-icon-button:focus-visible{outline:solid var(--tds-size-border-medium) var(--tds-color-border-focus);outline-offset:var(--tds-size-spacing-025)}.tds-icon-button>*{color:var(--tds-component-icon-button-color-foreground)}.tds-icon-button:hover:not(:disabled):not(:active){background:var(--tds-component-icon-button-color-background-hover)}.tds-icon-button:active:not(:disabled){background:var(--tds-component-icon-button-color-background-active)}.tds-icon-button:disabled{cursor:not-allowed;opacity:var(--tds-opacity-disabled)}.tds-icon-button--sm{--tds-local-icon-button-size:var(--tds-component-icon-button-size-sm);--tds-local-icon-button-padding:var(--tds-component-icon-button-size-padding-sm);--tds-local-icon-button-icon-size:var(--tds-component-icon-size-sm);--tds-local-icon-button-icon-size:var(--tds-component-icon-size-xs)}.tds-icon-button--sm>*{font-size:var(--tds-local-icon-button-icon-size);height:var(--tds-local-icon-button-icon-size);width:var(--tds-local-icon-button-icon-size)}.tds-icon-button--sm .tds-icon{--tds-local-icon-size:var(--tds-local-icon-button-icon-size);--tds-local-icon-color-text:inherit}.tds-icon-button--md{--tds-local-icon-button-size:var(--tds-component-icon-button-size-md);--tds-local-icon-button-padding:var(--tds-component-icon-button-size-padding-md);--tds-local-icon-button-icon-size:var(--tds-component-icon-size-sm)}.tds-icon-button--md>*{font-size:var(--tds-local-icon-button-icon-size);height:var(--tds-local-icon-button-icon-size);width:var(--tds-local-icon-button-icon-size)}.tds-icon-button--md .tds-icon{--tds-local-icon-size:var(--tds-local-icon-button-icon-size);--tds-local-icon-color-text:inherit}.tds-icon-button--lg{--tds-local-icon-button-size:var(--tds-component-icon-button-size-lg);--tds-local-icon-button-padding:var(--tds-component-icon-button-size-padding-lg);--tds-local-icon-button-icon-size:var(--tds-component-icon-size-sm);--tds-local-icon-button-icon-size:var(--tds-component-icon-size-md)}.tds-icon-button--lg>*{font-size:var(--tds-local-icon-button-icon-size);height:var(--tds-local-icon-button-icon-size);width:var(--tds-local-icon-button-icon-size)}.tds-icon-button--lg .tds-icon{--tds-local-icon-size:var(--tds-local-icon-button-icon-size);--tds-local-icon-color-text:inherit}\n"]
    }]
  }], null, null);
})();

/**
 * ICON_BUTTON_SIZES is an array of all possible icon button sizes. Used to define `IconButtonSize` union type. Useful for looping through all possible icon button sizes.
 */
const ICON_BUTTON_SIZES = ['sm', 'md', 'lg'];
class SearchComponent {
  defaultClass = 'tds-search';
  inputValue = signal(undefined);
  inputDirective = contentChild(SearchInputDirective);
  /**
   * The label for the clear icon.
   * The icon is displayed when the input has a value and when hovered a tooltip with this label appears.
   * @default 'Clear'
   */
  clearIconLabel = input('Clear');
  /**
   * Emits when the clear icon is clicked and the search input is cleared.
   */
  clear = output();
  isClearable = computed(() => {
    return !this.inputDirective()?._disabledInternal() && this.inputDirective()?.value() !== null && this.inputDirective()?.value() !== undefined && this.inputDirective()?.value() !== '';
  });
  focusInput() {
    this.inputDirective()?.focus();
  }
  clearInput() {
    this.inputDirective()?.clear();
    this.clear.emit();
  }
  static ɵfac = function SearchComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || SearchComponent)();
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: SearchComponent,
    selectors: [["tds-search"]],
    contentQueries: function SearchComponent_ContentQueries(rf, ctx, dirIndex) {
      if (rf & 1) {
        i0.ɵɵcontentQuerySignal(dirIndex, ctx.inputDirective, SearchInputDirective, 5);
      }
      if (rf & 2) {
        i0.ɵɵqueryAdvance();
      }
    },
    hostVars: 2,
    hostBindings: function SearchComponent_HostBindings(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵlistener("click", function SearchComponent_click_HostBindingHandler() {
          return ctx.focusInput();
        });
      }
      if (rf & 2) {
        i0.ɵɵclassMap(ctx.defaultClass);
      }
    },
    inputs: {
      clearIconLabel: [1, "clearIconLabel"]
    },
    outputs: {
      clear: "clear"
    },
    standalone: true,
    features: [i0.ɵɵStandaloneFeature],
    ngContentSelectors: _c8,
    decls: 3,
    vars: 1,
    consts: [["name", "search", "size", "sm", "variant", "inherit"], ["tds-icon-button", "", "size", "sm", 3, "label"], ["tds-icon-button", "", "size", "sm", 3, "click", "label"], ["name", "close"]],
    template: function SearchComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵprojectionDef(_c21);
        i0.ɵɵelement(0, "tds-icon", 0);
        i0.ɵɵprojection(1);
        i0.ɵɵtemplate(2, SearchComponent_Conditional_2_Template, 2, 1, "button", 1);
      }
      if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵconditional(ctx.isClearable() ? 2 : -1);
      }
    },
    dependencies: [IconComponent, IconButtonComponent],
    styles: [".tds-search{all:unset;align-items:center;display:inline-grid;grid-template-columns:40px 1fr 40px;height:100%;justify-items:center;width:100%}.tds-search,.tds-search *,.tds-search :after,.tds-search :before{box-sizing:border-box}.tds-search input[type=search]{all:unset;-webkit-appearance:none;appearance:none;height:100%;width:100%}.tds-search input[type=search]::-webkit-search-cancel-button,.tds-search input[type=search]::-webkit-search-decoration,.tds-search input[type=search]::-webkit-search-results-button,.tds-search input[type=search]::-webkit-search-results-decoration{-webkit-appearance:none;appearance:none}\n"],
    encapsulation: 2,
    changeDetection: 0
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SearchComponent, [{
    type: Component,
    args: [{
      selector: 'tds-search',
      standalone: true,
      imports: [IconComponent, IconButtonComponent, FormFieldSuffixDirective],
      host: {
        '[class]': 'defaultClass',
        '(click)': 'focusInput()'
      },
      changeDetection: ChangeDetectionStrategy.OnPush,
      encapsulation: ViewEncapsulation.None,
      template: "<tds-icon\n  name=\"search\"\n  size=\"sm\"\n  variant=\"inherit\"></tds-icon>\n<ng-content select=\"input\"></ng-content>\n\n@if (isClearable()) {\n  <button\n    tds-icon-button\n    size=\"sm\"\n    [label]=\"clearIconLabel()\"\n    (click)=\"clearInput()\">\n    <tds-icon name=\"close\"></tds-icon>\n  </button>\n}\n",
      styles: [".tds-search{all:unset;align-items:center;display:inline-grid;grid-template-columns:40px 1fr 40px;height:100%;justify-items:center;width:100%}.tds-search,.tds-search *,.tds-search :after,.tds-search :before{box-sizing:border-box}.tds-search input[type=search]{all:unset;-webkit-appearance:none;appearance:none;height:100%;width:100%}.tds-search input[type=search]::-webkit-search-cancel-button,.tds-search input[type=search]::-webkit-search-decoration,.tds-search input[type=search]::-webkit-search-results-button,.tds-search input[type=search]::-webkit-search-results-decoration{-webkit-appearance:none;appearance:none}\n"]
    }]
  }], null, null);
})();
class TagComponent {
  defaultAccent = 'blue';
  defaultVariant = 'subtle';
  defaultClass = 'tds-tag';
  defaultCloseIconButtonLabel = 'Close';
  el = inject(ElementRef);
  renderer = inject(Renderer2);
  /**
   * Accent of the tag.
   * @default 'blue'
   */
  accent = input(this.defaultAccent);
  /**
   * Variant of the tag.
   * @default 'subtle'
   */
  variant = input(this.defaultVariant);
  /**
   * If set to true a close icon is displayed.
   * @default false
   */
  isClosable = input(false, {
    transform: booleanAttribute
  });
  /**
   * The label for the close icon button.
   * The icon is displayed on closable tags and when hovered a tooltip with this label appears.
   * It is also used for assistive technologies.
   * @default 'Close'
   */
  closeIconButtonLabel = input(this.defaultCloseIconButtonLabel, {
    transform: value => value ?? this.defaultCloseIconButtonLabel
  });
  /**
   * If set to true the tag will be removed from the DOM when the close icon is clicked.
   * @default false
   */
  shouldAutoDestroyOnClose = input(false, {
    transform: booleanAttribute
  });
  /**
   * Emits an `Event` when the close icon button is clicked.
   */
  close = output();
  onClose(event) {
    this.close.emit(event);
    if (this.shouldAutoDestroyOnClose()) {
      this.renderer.removeChild(this.el.nativeElement, this.el.nativeElement, true);
    }
  }
  classes = computed(() => {
    const accent = this.accent() && this.accent() !== this.defaultAccent ? `${this.defaultClass}--${this.accent()}` : '';
    const variant = this.variant() && this.variant() !== this.defaultVariant ? `${this.defaultClass}--${this.variant()}` : '';
    return `${this.defaultClass} ${accent} ${variant}`;
  });
  static ɵfac = function TagComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || TagComponent)();
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: TagComponent,
    selectors: [["tds-tag"]],
    hostVars: 2,
    hostBindings: function TagComponent_HostBindings(rf, ctx) {
      if (rf & 2) {
        i0.ɵɵclassMap(ctx.classes());
      }
    },
    inputs: {
      accent: [1, "accent"],
      variant: [1, "variant"],
      isClosable: [1, "isClosable"],
      closeIconButtonLabel: [1, "closeIconButtonLabel"],
      shouldAutoDestroyOnClose: [1, "shouldAutoDestroyOnClose"]
    },
    outputs: {
      close: "close"
    },
    standalone: true,
    features: [i0.ɵɵStandaloneFeature],
    ngContentSelectors: _c4,
    decls: 2,
    vars: 1,
    consts: [["tds-icon-button", "", "type", "button", "size", "sm", 1, "tds-tag__icon-btn", 3, "label"], ["tds-icon-button", "", "type", "button", "size", "sm", 1, "tds-tag__icon-btn", 3, "click", "label"], ["name", "close"]],
    template: function TagComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵprojection(0);
        i0.ɵɵtemplate(1, TagComponent_Conditional_1_Template, 2, 1, "button", 0);
      }
      if (rf & 2) {
        i0.ɵɵadvance();
        i0.ɵɵconditional(ctx.isClosable() ? 1 : -1);
      }
    },
    dependencies: [IconButtonComponent, IconComponent],
    styles: [".tds-tag{align-items:center;background-color:var(--tds-local-tag-background-color);border-radius:var(--tds-size-radius-rounded);color:var(--tds-local-tag-text-color);display:inline-flex;font-family:var(--tds-font-family-sans);font-size:var(--tds-font-size-helper-text);font-weight:var(--tds-font-weight-500);line-height:var(--tds-font-line-height-caption);padding:var(--tds-size-spacing-050) var(--tds-size-spacing-100)}.tds-tag,.tds-tag *,.tds-tag :after,.tds-tag :before{box-sizing:border-box}.tds-tag:has(.tds-tag__icon-btn){gap:var(--tds-size-spacing-025);padding:0 0 0 var(--tds-size-spacing-100)}.tds-tag__icon-btn.tds-icon-button{--tds-component-icon-button-color-foreground:currentColor}.tds-tag__icon-btn.tds-icon-button:focus-visible{outline:solid var(--tds-size-border-medium) var(--tds-color-border-focus);outline-offset:calc(var(--tds-size-spacing-025) * -1)}.tds-tag--high-emphasis .tds-tag__icon-btn.tds-icon-button{--tds-component-icon-button-color-background-hover:var(--tds-color-background-transparent-on-color-hover);--tds-component-icon-button-color-background-active:var(--tds-color-background-transparent-on-color-active)}.tds-tag--high-emphasis .tds-tag__icon-btn.tds-icon-button:focus-visible{outline:solid var(--tds-size-border-medium) var(--tds-color-border-focus-on-color);outline-offset:calc(var(--tds-size-spacing-025) * -1)}.tds-tag.tds-tag--red{--tds-local-tag-text-color:var(--tds-color-foreground-accent-red);--tds-local-tag-background-color:var(--tds-color-background-accent-red-subtle-default)}.tds-tag.tds-tag--red:not(.tds-tag--high-emphasis){border:var(--tds-size-border-thin) solid var(--tds-color-border-accent-red)}.tds-tag.tds-tag--red.tds-tag--high-emphasis{--tds-local-tag-text-color:var(--tds-color-foreground-inverse);--tds-local-tag-background-color:var(--tds-color-background-accent-red-strong-default)}.tds-tag.tds-tag--green{--tds-local-tag-text-color:var(--tds-color-foreground-accent-green);--tds-local-tag-background-color:var(--tds-color-background-accent-green-subtle-default)}.tds-tag.tds-tag--green:not(.tds-tag--high-emphasis){border:var(--tds-size-border-thin) solid var(--tds-color-border-accent-green)}.tds-tag.tds-tag--green.tds-tag--high-emphasis{--tds-local-tag-text-color:var(--tds-color-foreground-inverse);--tds-local-tag-background-color:var(--tds-color-background-accent-green-strong-default)}.tds-tag,.tds-tag.tds-tag--blue{--tds-local-tag-text-color:var(--tds-color-foreground-accent-blue);--tds-local-tag-background-color:var(--tds-color-background-accent-blue-subtle-default)}.tds-tag.tds-tag--blue:not(.tds-tag--high-emphasis),.tds-tag:not(.tds-tag--high-emphasis){border:var(--tds-size-border-thin) solid var(--tds-color-border-accent-blue)}.tds-tag.tds-tag--blue.tds-tag--high-emphasis,.tds-tag.tds-tag--high-emphasis{--tds-local-tag-text-color:var(--tds-color-foreground-inverse);--tds-local-tag-background-color:var(--tds-color-background-accent-blue-strong-default)}.tds-tag.tds-tag--yellow{--tds-local-tag-text-color:var(--tds-color-foreground-accent-yellow);--tds-local-tag-background-color:var(--tds-color-background-accent-yellow-subtle-default)}.tds-tag.tds-tag--yellow:not(.tds-tag--high-emphasis){border:var(--tds-size-border-thin) solid var(--tds-color-border-accent-yellow)}.tds-tag.tds-tag--yellow.tds-tag--high-emphasis{--tds-local-tag-text-color:var(--tds-color-foreground-inverse);--tds-local-tag-background-color:var(--tds-color-background-accent-yellow-strong-default)}.tds-tag.tds-tag--grey{--tds-local-tag-text-color:var(--tds-color-foreground-accent-grey);--tds-local-tag-background-color:var(--tds-color-background-accent-grey-subtle-default)}.tds-tag.tds-tag--grey:not(.tds-tag--high-emphasis){border:var(--tds-size-border-thin) solid var(--tds-color-border-accent-grey)}.tds-tag.tds-tag--grey.tds-tag--high-emphasis{--tds-local-tag-text-color:var(--tds-color-foreground-inverse);--tds-local-tag-background-color:var(--tds-color-background-accent-grey-strong-default)}.tds-tag.tds-tag--orange{--tds-local-tag-text-color:var(--tds-color-foreground-accent-orange);--tds-local-tag-background-color:var(--tds-color-background-accent-orange-subtle-default)}.tds-tag.tds-tag--orange:not(.tds-tag--high-emphasis){border:var(--tds-size-border-thin) solid var(--tds-color-border-accent-orange)}.tds-tag.tds-tag--orange.tds-tag--high-emphasis{--tds-local-tag-text-color:var(--tds-color-foreground-inverse);--tds-local-tag-background-color:var(--tds-color-background-accent-orange-strong-default)}.tds-tag.tds-tag--teal{--tds-local-tag-text-color:var(--tds-color-foreground-accent-teal);--tds-local-tag-background-color:var(--tds-color-background-accent-teal-subtle-default)}.tds-tag.tds-tag--teal:not(.tds-tag--high-emphasis){border:var(--tds-size-border-thin) solid var(--tds-color-border-accent-teal)}.tds-tag.tds-tag--teal.tds-tag--high-emphasis{--tds-local-tag-text-color:var(--tds-color-foreground-inverse);--tds-local-tag-background-color:var(--tds-color-background-accent-teal-strong-default)}.tds-tag.tds-tag--purple{--tds-local-tag-text-color:var(--tds-color-foreground-accent-purple);--tds-local-tag-background-color:var(--tds-color-background-accent-purple-subtle-default)}.tds-tag.tds-tag--purple:not(.tds-tag--high-emphasis){border:var(--tds-size-border-thin) solid var(--tds-color-border-accent-purple)}.tds-tag.tds-tag--purple.tds-tag--high-emphasis{--tds-local-tag-text-color:var(--tds-color-foreground-inverse);--tds-local-tag-background-color:var(--tds-color-background-accent-purple-strong-default)}.tds-tag.tds-tag--pink{--tds-local-tag-text-color:var(--tds-color-foreground-accent-pink);--tds-local-tag-background-color:var(--tds-color-background-accent-pink-subtle-default)}.tds-tag.tds-tag--pink:not(.tds-tag--high-emphasis){border:var(--tds-size-border-thin) solid var(--tds-color-border-accent-pink)}.tds-tag.tds-tag--pink.tds-tag--high-emphasis{--tds-local-tag-text-color:var(--tds-color-foreground-inverse);--tds-local-tag-background-color:var(--tds-color-background-accent-pink-strong-default)}\n"],
    encapsulation: 2,
    changeDetection: 0
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TagComponent, [{
    type: Component,
    args: [{
      selector: 'tds-tag',
      standalone: true,
      imports: [IconButtonComponent, IconComponent],
      host: {
        '[class]': 'classes()'
      },
      changeDetection: ChangeDetectionStrategy.OnPush,
      encapsulation: ViewEncapsulation.None,
      template: "<ng-content></ng-content>\n@if (isClosable()) {\n  <button\n    tds-icon-button\n    class=\"tds-tag__icon-btn\"\n    type=\"button\"\n    size=\"sm\"\n    [label]=\"closeIconButtonLabel()\"\n    (click)=\"onClose($event)\">\n    <tds-icon name=\"close\"></tds-icon>\n  </button>\n}\n",
      styles: [".tds-tag{align-items:center;background-color:var(--tds-local-tag-background-color);border-radius:var(--tds-size-radius-rounded);color:var(--tds-local-tag-text-color);display:inline-flex;font-family:var(--tds-font-family-sans);font-size:var(--tds-font-size-helper-text);font-weight:var(--tds-font-weight-500);line-height:var(--tds-font-line-height-caption);padding:var(--tds-size-spacing-050) var(--tds-size-spacing-100)}.tds-tag,.tds-tag *,.tds-tag :after,.tds-tag :before{box-sizing:border-box}.tds-tag:has(.tds-tag__icon-btn){gap:var(--tds-size-spacing-025);padding:0 0 0 var(--tds-size-spacing-100)}.tds-tag__icon-btn.tds-icon-button{--tds-component-icon-button-color-foreground:currentColor}.tds-tag__icon-btn.tds-icon-button:focus-visible{outline:solid var(--tds-size-border-medium) var(--tds-color-border-focus);outline-offset:calc(var(--tds-size-spacing-025) * -1)}.tds-tag--high-emphasis .tds-tag__icon-btn.tds-icon-button{--tds-component-icon-button-color-background-hover:var(--tds-color-background-transparent-on-color-hover);--tds-component-icon-button-color-background-active:var(--tds-color-background-transparent-on-color-active)}.tds-tag--high-emphasis .tds-tag__icon-btn.tds-icon-button:focus-visible{outline:solid var(--tds-size-border-medium) var(--tds-color-border-focus-on-color);outline-offset:calc(var(--tds-size-spacing-025) * -1)}.tds-tag.tds-tag--red{--tds-local-tag-text-color:var(--tds-color-foreground-accent-red);--tds-local-tag-background-color:var(--tds-color-background-accent-red-subtle-default)}.tds-tag.tds-tag--red:not(.tds-tag--high-emphasis){border:var(--tds-size-border-thin) solid var(--tds-color-border-accent-red)}.tds-tag.tds-tag--red.tds-tag--high-emphasis{--tds-local-tag-text-color:var(--tds-color-foreground-inverse);--tds-local-tag-background-color:var(--tds-color-background-accent-red-strong-default)}.tds-tag.tds-tag--green{--tds-local-tag-text-color:var(--tds-color-foreground-accent-green);--tds-local-tag-background-color:var(--tds-color-background-accent-green-subtle-default)}.tds-tag.tds-tag--green:not(.tds-tag--high-emphasis){border:var(--tds-size-border-thin) solid var(--tds-color-border-accent-green)}.tds-tag.tds-tag--green.tds-tag--high-emphasis{--tds-local-tag-text-color:var(--tds-color-foreground-inverse);--tds-local-tag-background-color:var(--tds-color-background-accent-green-strong-default)}.tds-tag,.tds-tag.tds-tag--blue{--tds-local-tag-text-color:var(--tds-color-foreground-accent-blue);--tds-local-tag-background-color:var(--tds-color-background-accent-blue-subtle-default)}.tds-tag.tds-tag--blue:not(.tds-tag--high-emphasis),.tds-tag:not(.tds-tag--high-emphasis){border:var(--tds-size-border-thin) solid var(--tds-color-border-accent-blue)}.tds-tag.tds-tag--blue.tds-tag--high-emphasis,.tds-tag.tds-tag--high-emphasis{--tds-local-tag-text-color:var(--tds-color-foreground-inverse);--tds-local-tag-background-color:var(--tds-color-background-accent-blue-strong-default)}.tds-tag.tds-tag--yellow{--tds-local-tag-text-color:var(--tds-color-foreground-accent-yellow);--tds-local-tag-background-color:var(--tds-color-background-accent-yellow-subtle-default)}.tds-tag.tds-tag--yellow:not(.tds-tag--high-emphasis){border:var(--tds-size-border-thin) solid var(--tds-color-border-accent-yellow)}.tds-tag.tds-tag--yellow.tds-tag--high-emphasis{--tds-local-tag-text-color:var(--tds-color-foreground-inverse);--tds-local-tag-background-color:var(--tds-color-background-accent-yellow-strong-default)}.tds-tag.tds-tag--grey{--tds-local-tag-text-color:var(--tds-color-foreground-accent-grey);--tds-local-tag-background-color:var(--tds-color-background-accent-grey-subtle-default)}.tds-tag.tds-tag--grey:not(.tds-tag--high-emphasis){border:var(--tds-size-border-thin) solid var(--tds-color-border-accent-grey)}.tds-tag.tds-tag--grey.tds-tag--high-emphasis{--tds-local-tag-text-color:var(--tds-color-foreground-inverse);--tds-local-tag-background-color:var(--tds-color-background-accent-grey-strong-default)}.tds-tag.tds-tag--orange{--tds-local-tag-text-color:var(--tds-color-foreground-accent-orange);--tds-local-tag-background-color:var(--tds-color-background-accent-orange-subtle-default)}.tds-tag.tds-tag--orange:not(.tds-tag--high-emphasis){border:var(--tds-size-border-thin) solid var(--tds-color-border-accent-orange)}.tds-tag.tds-tag--orange.tds-tag--high-emphasis{--tds-local-tag-text-color:var(--tds-color-foreground-inverse);--tds-local-tag-background-color:var(--tds-color-background-accent-orange-strong-default)}.tds-tag.tds-tag--teal{--tds-local-tag-text-color:var(--tds-color-foreground-accent-teal);--tds-local-tag-background-color:var(--tds-color-background-accent-teal-subtle-default)}.tds-tag.tds-tag--teal:not(.tds-tag--high-emphasis){border:var(--tds-size-border-thin) solid var(--tds-color-border-accent-teal)}.tds-tag.tds-tag--teal.tds-tag--high-emphasis{--tds-local-tag-text-color:var(--tds-color-foreground-inverse);--tds-local-tag-background-color:var(--tds-color-background-accent-teal-strong-default)}.tds-tag.tds-tag--purple{--tds-local-tag-text-color:var(--tds-color-foreground-accent-purple);--tds-local-tag-background-color:var(--tds-color-background-accent-purple-subtle-default)}.tds-tag.tds-tag--purple:not(.tds-tag--high-emphasis){border:var(--tds-size-border-thin) solid var(--tds-color-border-accent-purple)}.tds-tag.tds-tag--purple.tds-tag--high-emphasis{--tds-local-tag-text-color:var(--tds-color-foreground-inverse);--tds-local-tag-background-color:var(--tds-color-background-accent-purple-strong-default)}.tds-tag.tds-tag--pink{--tds-local-tag-text-color:var(--tds-color-foreground-accent-pink);--tds-local-tag-background-color:var(--tds-color-background-accent-pink-subtle-default)}.tds-tag.tds-tag--pink:not(.tds-tag--high-emphasis){border:var(--tds-size-border-thin) solid var(--tds-color-border-accent-pink)}.tds-tag.tds-tag--pink.tds-tag--high-emphasis{--tds-local-tag-text-color:var(--tds-color-foreground-inverse);--tds-local-tag-background-color:var(--tds-color-background-accent-pink-strong-default)}\n"]
    }]
  }], null, null);
})();

/**
 * TAG_VARIANTS is an array of all possible tag variants. Used to define `TagVariant` union type. Useful for looping through all possible tag variants.
 */
const TAG_VARIANTS = ['subtle', 'high-emphasis'];
class HeaderNavigationLinkComponent {
  defaultClass = 'tds-header-navigation-link';
  /**
   * Whether the link should be active or not
   * ignored if routerLink and routerLinkActive is used
   * @default false
   */
  isActive = input(false, {
    transform: booleanAttribute
  });
  routerLinkActive = inject(RouterLinkActive, {
    optional: true
  });
  routerLinkActiveChanges;
  constructor() {
    if (this.routerLinkActive) {
      if (!this.routerLinkActive.ariaCurrentWhenActive) {
        this.routerLinkActive.ariaCurrentWhenActive = 'page';
      }
      this.routerLinkActiveChanges = toSignal(this.routerLinkActive.isActiveChange);
    }
  }
  isActiveComp = computed(() => this.routerLinkActiveChanges ? this.routerLinkActiveChanges() : this.isActive());
  classes = computed(() => {
    const isActive = this.isActiveComp() ? `${this.defaultClass}--active` : '';
    return `${this.defaultClass} ${isActive}`;
  });
  static ɵfac = function HeaderNavigationLinkComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || HeaderNavigationLinkComponent)();
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: HeaderNavigationLinkComponent,
    selectors: [["a", "tds-header-navigation-link", ""]],
    hostVars: 2,
    hostBindings: function HeaderNavigationLinkComponent_HostBindings(rf, ctx) {
      if (rf & 2) {
        i0.ɵɵclassMap(ctx.classes());
      }
    },
    inputs: {
      isActive: [1, "isActive"]
    },
    standalone: true,
    features: [i0.ɵɵStandaloneFeature],
    attrs: _c22,
    ngContentSelectors: _c4,
    decls: 1,
    vars: 0,
    template: function HeaderNavigationLinkComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵprojection(0);
      }
    },
    styles: [".tds-header-navigation-link{--tds-local-header-navigation-link-color-foreground:var(--tds-color-foreground-secondary);--tds-local-header-navigation-size-padding-side:var(--tds-size-spacing-200);all:unset;align-items:center;border-radius:var(--tds-size-radius-rounded);box-sizing:border-box;color:var(--tds-local-header-navigation-link-color-foreground);cursor:pointer;display:inline-flex;flex-shrink:0;font:var(--tds-font-heading-6);justify-content:center;max-width:-moz-fit-content;max-width:fit-content;min-height:32px;padding:0 var(--tds-local-header-navigation-size-padding-side);position:relative;text-decoration:none;-webkit-font-smoothing:antialiased}.tds-header-navigation-link *,.tds-header-navigation-link :after,.tds-header-navigation-link :before{box-sizing:border-box}.tds-header-navigation-link:focus-visible{outline:solid var(--tds-size-border-medium) var(--tds-color-border-focus);outline-offset:var(--tds-size-spacing-025)}.tds-header-navigation-link--active{--tds-local-header-navigation-link-color-foreground:var(--tds-color-foreground-brand)}.tds-header-navigation-link--active:after{background-color:var(--tds-color-border-brand);border-radius:var(--tds-size-radius-100);bottom:0;box-sizing:border-box;content:\"\";height:var(--tds-size-border-medium);position:absolute;width:calc(100% - var(--tds-local-header-navigation-size-padding-side) * 2)}.tds-header-navigation-link--active:after *,.tds-header-navigation-link--active:after :after,.tds-header-navigation-link--active:after :before{box-sizing:border-box}.tds-header-navigation-link:hover:not(.tds-header-navigation-link--active){--tds-local-header-navigation-link-color-foreground:var(--tds-color-foreground-brand);background:var(--tds-color-background-transparent-hover)}\n"],
    encapsulation: 2,
    changeDetection: 0
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HeaderNavigationLinkComponent, [{
    type: Component,
    args: [{
      selector: 'a[tds-header-navigation-link]',
      standalone: true,
      imports: [],
      host: {
        '[class]': 'classes()'
      },
      changeDetection: ChangeDetectionStrategy.OnPush,
      encapsulation: ViewEncapsulation.None,
      template: "<ng-content></ng-content>\n",
      styles: [".tds-header-navigation-link{--tds-local-header-navigation-link-color-foreground:var(--tds-color-foreground-secondary);--tds-local-header-navigation-size-padding-side:var(--tds-size-spacing-200);all:unset;align-items:center;border-radius:var(--tds-size-radius-rounded);box-sizing:border-box;color:var(--tds-local-header-navigation-link-color-foreground);cursor:pointer;display:inline-flex;flex-shrink:0;font:var(--tds-font-heading-6);justify-content:center;max-width:-moz-fit-content;max-width:fit-content;min-height:32px;padding:0 var(--tds-local-header-navigation-size-padding-side);position:relative;text-decoration:none;-webkit-font-smoothing:antialiased}.tds-header-navigation-link *,.tds-header-navigation-link :after,.tds-header-navigation-link :before{box-sizing:border-box}.tds-header-navigation-link:focus-visible{outline:solid var(--tds-size-border-medium) var(--tds-color-border-focus);outline-offset:var(--tds-size-spacing-025)}.tds-header-navigation-link--active{--tds-local-header-navigation-link-color-foreground:var(--tds-color-foreground-brand)}.tds-header-navigation-link--active:after{background-color:var(--tds-color-border-brand);border-radius:var(--tds-size-radius-100);bottom:0;box-sizing:border-box;content:\"\";height:var(--tds-size-border-medium);position:absolute;width:calc(100% - var(--tds-local-header-navigation-size-padding-side) * 2)}.tds-header-navigation-link--active:after *,.tds-header-navigation-link--active:after :after,.tds-header-navigation-link--active:after :before{box-sizing:border-box}.tds-header-navigation-link:hover:not(.tds-header-navigation-link--active){--tds-local-header-navigation-link-color-foreground:var(--tds-color-foreground-brand);background:var(--tds-color-background-transparent-hover)}\n"]
    }]
  }], () => [], null);
})();
class HeaderNavigationComponent {
  defaultClass = 'tds-header-navigation';
  static ɵfac = function HeaderNavigationComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || HeaderNavigationComponent)();
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: HeaderNavigationComponent,
    selectors: [["nav", "tds-header-navigation", ""]],
    hostAttrs: ["role", "navigation"],
    hostVars: 2,
    hostBindings: function HeaderNavigationComponent_HostBindings(rf, ctx) {
      if (rf & 2) {
        i0.ɵɵclassMap(ctx.defaultClass);
      }
    },
    standalone: true,
    features: [i0.ɵɵStandaloneFeature],
    attrs: _c23,
    ngContentSelectors: _c25,
    decls: 1,
    vars: 0,
    template: function HeaderNavigationComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵprojectionDef(_c24);
        i0.ɵɵprojection(0);
      }
    },
    styles: [".tds-header-navigation{align-items:center;display:inline-flex;gap:var(--tds-size-spacing-100);justify-content:center;-webkit-font-smoothing:antialiased}\n"],
    encapsulation: 2,
    changeDetection: 0
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HeaderNavigationComponent, [{
    type: Component,
    args: [{
      selector: 'nav[tds-header-navigation]',
      standalone: true,
      host: {
        '[class]': 'defaultClass',
        role: 'navigation'
      },
      changeDetection: ChangeDetectionStrategy.OnPush,
      encapsulation: ViewEncapsulation.None,
      template: "<ng-content select=\"[tds-header-navigation-link]\"></ng-content>\n",
      styles: [".tds-header-navigation{align-items:center;display:inline-flex;gap:var(--tds-size-spacing-100);justify-content:center;-webkit-font-smoothing:antialiased}\n"]
    }]
  }], null, null);
})();
class HeaderAppNameComponent {
  defaultClass = 'tds-header-app-name';
  /**
   * Name of the application
   * displayed in uppercase in the header
   */
  name = input.required();
  static ɵfac = function HeaderAppNameComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || HeaderAppNameComponent)();
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: HeaderAppNameComponent,
    selectors: [["", "tds-header-app-name", ""]],
    hostVars: 2,
    hostBindings: function HeaderAppNameComponent_HostBindings(rf, ctx) {
      if (rf & 2) {
        i0.ɵɵclassMap(ctx.defaultClass);
      }
    },
    inputs: {
      name: [1, "name"]
    },
    standalone: true,
    features: [i0.ɵɵStandaloneFeature],
    attrs: _c26,
    ngContentSelectors: _c28,
    decls: 3,
    vars: 1,
    consts: [[1, "tds-header-app-name__name"]],
    template: function HeaderAppNameComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵprojectionDef(_c27);
        i0.ɵɵprojection(0);
        i0.ɵɵelementStart(1, "span", 0);
        i0.ɵɵtext(2);
        i0.ɵɵelementEnd();
      }
      if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate(ctx.name());
      }
    },
    styles: [".tds-header-app-name{all:unset;align-items:center;display:flex;gap:var(--tds-size-spacing-200);justify-content:start;min-width:0}.tds-header-app-name,.tds-header-app-name *,.tds-header-app-name :after,.tds-header-app-name :before{box-sizing:border-box}.tds-header-app-name__name{color:var(--tds-color-foreground-primary);font-family:var(--tds-font-family-display);font-size:var(--tds-primitive-font-size-16);font-weight:var(--tds-font-weight-700);letter-spacing:.02rem;line-height:var(--tds-primitive-font-size-20);overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.tds-header-app-name .tds-header-app-logo{flex-shrink:0;height:40px;width:40px}\n"],
    encapsulation: 2,
    changeDetection: 0
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HeaderAppNameComponent, [{
    type: Component,
    args: [{
      selector: '[tds-header-app-name]',
      standalone: true,
      imports: [],
      host: {
        '[class]': 'defaultClass'
      },
      changeDetection: ChangeDetectionStrategy.OnPush,
      encapsulation: ViewEncapsulation.None,
      template: "<ng-content select=\"[tds-header-app-logo]\" />\n<span class=\"tds-header-app-name__name\">{{ name() }}</span>\n",
      styles: [".tds-header-app-name{all:unset;align-items:center;display:flex;gap:var(--tds-size-spacing-200);justify-content:start;min-width:0}.tds-header-app-name,.tds-header-app-name *,.tds-header-app-name :after,.tds-header-app-name :before{box-sizing:border-box}.tds-header-app-name__name{color:var(--tds-color-foreground-primary);font-family:var(--tds-font-family-display);font-size:var(--tds-primitive-font-size-16);font-weight:var(--tds-font-weight-700);letter-spacing:.02rem;line-height:var(--tds-primitive-font-size-20);overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.tds-header-app-name .tds-header-app-logo{flex-shrink:0;height:40px;width:40px}\n"]
    }]
  }], null, null);
})();
class HeaderMobileMenuComponent {
  defaultClass = 'tds-header-mobile-menu';
  headerNavigationLinks = contentChildren(HeaderNavigationLinkComponent, {
    descendants: true,
    read: ElementRef
  });
  /**
   * Emits when the menu is closed
   */
  onClose = output();
  constructor() {
    effect(() => {
      this.headerNavigationLinks().forEach(item => {
        item.nativeElement.addEventListener('click', () => {
          this.closeMenu();
        });
      });
    });
  }
  ngOnDestroy() {
    this.headerNavigationLinks().forEach(item => {
      item.nativeElement.removeEventListener('click', () => {
        this.closeMenu();
      });
    });
  }
  /**
   * @ignore
   */
  closeMenu() {
    this.onClose.emit();
  }
  static ɵfac = function HeaderMobileMenuComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || HeaderMobileMenuComponent)();
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: HeaderMobileMenuComponent,
    selectors: [["tds-header-mobile-menu"]],
    contentQueries: function HeaderMobileMenuComponent_ContentQueries(rf, ctx, dirIndex) {
      if (rf & 1) {
        i0.ɵɵcontentQuerySignal(dirIndex, ctx.headerNavigationLinks, HeaderNavigationLinkComponent, 5, ElementRef);
      }
      if (rf & 2) {
        i0.ɵɵqueryAdvance();
      }
    },
    outputs: {
      onClose: "onClose"
    },
    standalone: true,
    features: [i0.ɵɵStandaloneFeature],
    ngContentSelectors: _c30,
    decls: 3,
    vars: 2,
    consts: [["tds-layer", "", "variant", "100"]],
    template: function HeaderMobileMenuComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵprojectionDef(_c29);
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵprojection(1);
        i0.ɵɵprojection(2, 1);
        i0.ɵɵelementEnd();
      }
      if (rf & 2) {
        i0.ɵɵclassMap(ctx.defaultClass);
      }
    },
    dependencies: [LayerComponent],
    styles: [".tds-header-mobile-menu{align-items:stretch;box-sizing:border-box;display:flex;flex-direction:column;height:100%;justify-content:space-between;width:100%}.tds-header-mobile-menu *,.tds-header-mobile-menu :after,.tds-header-mobile-menu :before{box-sizing:border-box}.tds-header-mobile-menu__end,.tds-header-mobile-menu__start{display:flex;flex-direction:column}.tds-header-mobile-menu__start{overflow:auto;padding:var(--tds-size-spacing-200) 0}.tds-header-mobile-menu__end{border-top:var(--tds-size-border-thin) solid var(--tds-color-border-subtle);justify-content:flex-end}.tds-header-mobile-menu:not(:has(.tds-header-mobile-menu__start)){justify-content:flex-end}.tds-header-mobile-menu nav.tds-header-navigation{align-items:flex-start;display:flex;flex-direction:column;gap:0}.tds-header-mobile-menu a.tds-header-navigation-link{align-items:center;align-self:stretch;border-radius:0;display:flex;justify-content:flex-start;max-width:none;padding:var(--tds-size-spacing-150) var(--tds-size-spacing-200)}.tds-header-mobile-menu a.tds-header-navigation-link:focus-visible{outline:solid var(--tds-size-border-medium) var(--tds-color-border-focus);outline-offset:calc(var(--tds-size-spacing-025) * -1)}.tds-header-mobile-menu a.tds-header-navigation-link:after{display:none}.tds-header-mobile-menu a.tds-header-navigation-link--active{--tds-local-header-navigation-link-color-foreground:var(--tds-color-foreground-primary);background:var(--tds-color-background-selected)}.tds-header-mobile-menu a.tds-header-navigation-link:hover:not(a.tds-header-navigation-link--active){--tds-local-header-navigation-link-color-foreground:var(--tds-color-foreground-primary);background:var(--tds-color-background-transparent-hover)}.tds-header-mobile-menu a.tds-header-navigation-link:active:not(a.tds-header-navigation-link--active){--tds-local-header-navigation-link-color-foreground:var(--tds-color-foreground-primary);background:var(--tds-color-background-transparent-active)}.tds-header-mobile-menu .tds-form-field{margin:var(--tds-size-spacing-200)}\n"],
    encapsulation: 2,
    changeDetection: 0
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HeaderMobileMenuComponent, [{
    type: Component,
    args: [{
      selector: 'tds-header-mobile-menu',
      standalone: true,
      imports: [LayerComponent],
      changeDetection: ChangeDetectionStrategy.OnPush,
      encapsulation: ViewEncapsulation.None,
      template: "<div\n  tds-layer\n  variant=\"100\"\n  [class]=\"defaultClass\">\n  <ng-content select=\"tds-header-mobile-menu-start\" />\n  <ng-content select=\"tds-header-mobile-menu-end\" />\n</div>\n",
      styles: [".tds-header-mobile-menu{align-items:stretch;box-sizing:border-box;display:flex;flex-direction:column;height:100%;justify-content:space-between;width:100%}.tds-header-mobile-menu *,.tds-header-mobile-menu :after,.tds-header-mobile-menu :before{box-sizing:border-box}.tds-header-mobile-menu__end,.tds-header-mobile-menu__start{display:flex;flex-direction:column}.tds-header-mobile-menu__start{overflow:auto;padding:var(--tds-size-spacing-200) 0}.tds-header-mobile-menu__end{border-top:var(--tds-size-border-thin) solid var(--tds-color-border-subtle);justify-content:flex-end}.tds-header-mobile-menu:not(:has(.tds-header-mobile-menu__start)){justify-content:flex-end}.tds-header-mobile-menu nav.tds-header-navigation{align-items:flex-start;display:flex;flex-direction:column;gap:0}.tds-header-mobile-menu a.tds-header-navigation-link{align-items:center;align-self:stretch;border-radius:0;display:flex;justify-content:flex-start;max-width:none;padding:var(--tds-size-spacing-150) var(--tds-size-spacing-200)}.tds-header-mobile-menu a.tds-header-navigation-link:focus-visible{outline:solid var(--tds-size-border-medium) var(--tds-color-border-focus);outline-offset:calc(var(--tds-size-spacing-025) * -1)}.tds-header-mobile-menu a.tds-header-navigation-link:after{display:none}.tds-header-mobile-menu a.tds-header-navigation-link--active{--tds-local-header-navigation-link-color-foreground:var(--tds-color-foreground-primary);background:var(--tds-color-background-selected)}.tds-header-mobile-menu a.tds-header-navigation-link:hover:not(a.tds-header-navigation-link--active){--tds-local-header-navigation-link-color-foreground:var(--tds-color-foreground-primary);background:var(--tds-color-background-transparent-hover)}.tds-header-mobile-menu a.tds-header-navigation-link:active:not(a.tds-header-navigation-link--active){--tds-local-header-navigation-link-color-foreground:var(--tds-color-foreground-primary);background:var(--tds-color-background-transparent-active)}.tds-header-mobile-menu .tds-form-field{margin:var(--tds-size-spacing-200)}\n"]
    }]
  }], () => [], null);
})();
class HeaderComponent {
  defaultClass = 'tds-header';
  hostClass = 'tds-header-container';
  /**
   * The navigation menu toggle button label
   */
  navigationMenuLabel = input('Navigation menu');
  _menuOpened = signal(false);
  mobileMenu = contentChild(HeaderMobileMenuComponent);
  zone = inject(NgZone);
  element = inject(ElementRef);
  resizeObserver;
  HEADER_MOBILE_BREAKPOINT = 576;
  constructor() {
    effect(() => {
      if (this._menuOpened()) {
        this.resizeObserver.observe(this.element.nativeElement);
      } else {
        this.resizeObserver.unobserve(this.element.nativeElement);
      }
    });
    effect(() => {
      this.mobileMenu()?.onClose.subscribe(() => {
        this._closeMenu();
      });
    });
    this.resizeObserver = new ResizeObserver(entries => {
      const width = entries[0].contentRect.width;
      if (width > this.HEADER_MOBILE_BREAKPOINT) {
        this.zone.run(() => {
          this._closeMenu();
        });
      }
    });
  }
  ngOnDestroy() {
    this.resizeObserver.unobserve(this.element.nativeElement);
  }
  _toggleMenu() {
    this._menuOpened.update(menuOpened => !menuOpened);
  }
  _closeMenu() {
    this._menuOpened.set(false);
  }
  classes = computed(() => {
    const hasMenuClass = this.mobileMenu() ? `${this.defaultClass}--with-menu` : '';
    const openedClass = this._menuOpened() ? `${this.defaultClass}--menu-opened` : '';
    return `${this.defaultClass} ${openedClass} ${hasMenuClass}`;
  });
  static ɵfac = function HeaderComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || HeaderComponent)();
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: HeaderComponent,
    selectors: [["header", "tds-header", ""]],
    contentQueries: function HeaderComponent_ContentQueries(rf, ctx, dirIndex) {
      if (rf & 1) {
        i0.ɵɵcontentQuerySignal(dirIndex, ctx.mobileMenu, HeaderMobileMenuComponent, 5);
      }
      if (rf & 2) {
        i0.ɵɵqueryAdvance();
      }
    },
    hostVars: 2,
    hostBindings: function HeaderComponent_HostBindings(rf, ctx) {
      if (rf & 2) {
        i0.ɵɵclassMap(ctx.hostClass);
      }
    },
    inputs: {
      navigationMenuLabel: [1, "navigationMenuLabel"]
    },
    standalone: true,
    features: [i0.ɵɵStandaloneFeature],
    attrs: _c31,
    ngContentSelectors: _c33,
    decls: 9,
    vars: 4,
    consts: [["tds-layer", "", "variant", "100"], [1, "tds-header__start"], ["tds-icon-button", "", "size", "lg", 1, "mobile-menu-toggle", 3, "click", "label"], [3, "name"]],
    template: function HeaderComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵprojectionDef(_c32);
        i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "button", 2);
        i0.ɵɵlistener("click", function HeaderComponent_Template_button_click_2_listener() {
          return ctx._toggleMenu();
        });
        i0.ɵɵelement(3, "tds-icon", 3);
        i0.ɵɵelementEnd();
        i0.ɵɵprojection(4);
        i0.ɵɵelementEnd();
        i0.ɵɵprojection(5, 1);
        i0.ɵɵprojection(6, 2);
        i0.ɵɵelement(7, "tds-company-logo");
        i0.ɵɵelementEnd();
        i0.ɵɵprojection(8, 3);
      }
      if (rf & 2) {
        i0.ɵɵclassMap(ctx.classes());
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("label", ctx.navigationMenuLabel());
        i0.ɵɵadvance();
        i0.ɵɵproperty("name", ctx._menuOpened() ? "close" : "menu");
      }
    },
    dependencies: [LayerComponent, CompanyLogoComponent, IconButtonComponent, IconComponent],
    styles: [".tds-header-container{--tds-local-header-height:var(--tds-component-header-size-height);container-name:header;container-type:inline-size;display:grid;grid-template-areas:\"header\";grid-template-rows:var(--tds-local-header-height);height:100%;width:100%}.tds-header-container:has(.tds-header--menu-opened){grid-template-areas:\"header\" \"menu\";grid-template-rows:var(--tds-local-header-height) calc(100% - var(--tds-local-header-height))}.tds-header{align-items:center;border-bottom:var(--tds-size-border-thin) solid var(--tds-color-border-subtle);display:flex;grid-area:header;justify-content:space-between;min-height:var(--tds-local-header-height);min-width:300px;padding:0 var(--tds-size-spacing-200);width:100%}.tds-header,.tds-header *,.tds-header :after,.tds-header :before{box-sizing:border-box}.tds-header__start{gap:var(--tds-size-spacing-100);min-width:0;padding-right:var(--tds-size-spacing-300)}.tds-header__center,.tds-header__start{align-items:center;display:flex;justify-content:start}.tds-header__center{flex:1;padding:0 var(--tds-size-spacing-100)}.tds-header__end{align-items:center;display:flex;gap:var(--tds-size-spacing-100);justify-content:end}.tds-header:not(:has(.tds-header__center)) .tds-header__end{flex:1}.tds-header .mobile-menu-toggle{display:none}.tds-header .tds-company-logo{flex-shrink:0;height:var(--tds-component-company-logo-size-height);margin-left:var(--tds-size-spacing-100);width:var(--tds-component-company-logo-size-width)}tds-header-mobile-menu{display:none;grid-area:menu}.tds-header--menu-opened+tds-header-mobile-menu{display:flex;height:inherit}@container header (width < 576px){.tds-header__center,.tds-header__end{display:none}.tds-header--with-menu .mobile-menu-toggle{display:inline-flex}}\n"],
    encapsulation: 2,
    changeDetection: 0
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HeaderComponent, [{
    type: Component,
    args: [{
      selector: 'header[tds-header]',
      standalone: true,
      imports: [LayerComponent, CompanyLogoComponent, IconButtonComponent, IconComponent, HeaderMobileMenuComponent],
      host: {
        '[class]': 'hostClass'
      },
      changeDetection: ChangeDetectionStrategy.OnPush,
      encapsulation: ViewEncapsulation.None,
      template: "<div\n  tds-layer\n  variant=\"100\"\n  [class]=\"classes()\">\n  <div class=\"tds-header__start\">\n    <button\n      tds-icon-button\n      class=\"mobile-menu-toggle\"\n      size=\"lg\"\n      [label]=\"navigationMenuLabel()\"\n      (click)=\"_toggleMenu()\">\n      <tds-icon [name]=\"_menuOpened() ? 'close' : 'menu'\"></tds-icon>\n    </button>\n    <ng-content select=\"[tds-header-app-name]\" />\n  </div>\n  <ng-content select=\"tds-header-center\" />\n  <ng-content select=\"tds-header-end\" />\n  <tds-company-logo></tds-company-logo>\n</div>\n\n<ng-content select=\"tds-header-mobile-menu\" />\n",
      styles: [".tds-header-container{--tds-local-header-height:var(--tds-component-header-size-height);container-name:header;container-type:inline-size;display:grid;grid-template-areas:\"header\";grid-template-rows:var(--tds-local-header-height);height:100%;width:100%}.tds-header-container:has(.tds-header--menu-opened){grid-template-areas:\"header\" \"menu\";grid-template-rows:var(--tds-local-header-height) calc(100% - var(--tds-local-header-height))}.tds-header{align-items:center;border-bottom:var(--tds-size-border-thin) solid var(--tds-color-border-subtle);display:flex;grid-area:header;justify-content:space-between;min-height:var(--tds-local-header-height);min-width:300px;padding:0 var(--tds-size-spacing-200);width:100%}.tds-header,.tds-header *,.tds-header :after,.tds-header :before{box-sizing:border-box}.tds-header__start{gap:var(--tds-size-spacing-100);min-width:0;padding-right:var(--tds-size-spacing-300)}.tds-header__center,.tds-header__start{align-items:center;display:flex;justify-content:start}.tds-header__center{flex:1;padding:0 var(--tds-size-spacing-100)}.tds-header__end{align-items:center;display:flex;gap:var(--tds-size-spacing-100);justify-content:end}.tds-header:not(:has(.tds-header__center)) .tds-header__end{flex:1}.tds-header .mobile-menu-toggle{display:none}.tds-header .tds-company-logo{flex-shrink:0;height:var(--tds-component-company-logo-size-height);margin-left:var(--tds-size-spacing-100);width:var(--tds-component-company-logo-size-width)}tds-header-mobile-menu{display:none;grid-area:menu}.tds-header--menu-opened+tds-header-mobile-menu{display:flex;height:inherit}@container header (width < 576px){.tds-header__center,.tds-header__end{display:none}.tds-header--with-menu .mobile-menu-toggle{display:inline-flex}}\n"]
    }]
  }], () => [], null);
})();
class HeaderMobileMenuActionComponent {
  defaultClass = 'tds-header-mobile-menu-action';
  parentMenu = inject(HeaderMobileMenuComponent, {
    optional: true
  });
  /**
   * If set to true the HeaderMobileMenuComponent will be closed when the action is clicked.
   * @default false
   */
  shouldCloseMenuOnClick = input(false, {
    transform: booleanAttribute
  });
  /**
   * @ignore
   */
  closeMenu() {
    if (this.shouldCloseMenuOnClick() && this.parentMenu) {
      this.parentMenu.closeMenu();
    }
  }
  static ɵfac = function HeaderMobileMenuActionComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || HeaderMobileMenuActionComponent)();
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: HeaderMobileMenuActionComponent,
    selectors: [["button", "tds-header-mobile-menu-action", ""]],
    hostVars: 2,
    hostBindings: function HeaderMobileMenuActionComponent_HostBindings(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵlistener("click", function HeaderMobileMenuActionComponent_click_HostBindingHandler() {
          return ctx.closeMenu();
        });
      }
      if (rf & 2) {
        i0.ɵɵclassMap(ctx.defaultClass);
      }
    },
    inputs: {
      shouldCloseMenuOnClick: [1, "shouldCloseMenuOnClick"]
    },
    standalone: true,
    features: [i0.ɵɵStandaloneFeature],
    attrs: _c34,
    ngContentSelectors: _c4,
    decls: 1,
    vars: 0,
    template: function HeaderMobileMenuActionComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵprojection(0);
      }
    },
    styles: [".tds-header-mobile-menu-action{--tds-local-header-mobile-menu-action-color-foreground:var(--tds-color-foreground-secondary);--tds-local-header-mobile-menu-action-padding-side:var(--tds-size-spacing-200);all:unset;align-items:center;align-self:stretch;box-sizing:border-box;color:var(--tds-local-header-mobile-menu-action-color-foreground);cursor:pointer;display:inline-flex;font:var(--tds-font-heading-6);gap:var(--tds-size-spacing-100);justify-content:flex-start;max-width:none;min-height:32px;padding:var(--tds-size-spacing-150) var(--tds-size-spacing-200);position:relative;text-decoration:none;-webkit-font-smoothing:antialiased}.tds-header-mobile-menu-action *,.tds-header-mobile-menu-action :after,.tds-header-mobile-menu-action :before{box-sizing:border-box}.tds-header-mobile-menu-action:focus-visible{outline:solid var(--tds-size-border-medium) var(--tds-color-border-focus);outline-offset:calc(var(--tds-size-spacing-025) * -1)}.tds-header-mobile-menu-action:hover:not(:disabled){--tds-local-header-mobile-menu-action-color-foreground:var(--tds-color-foreground-primary);background:var(--tds-color-background-transparent-hover)}.tds-header-mobile-menu-action:active:not(:disabled){--tds-local-header-mobile-menu-action-color-foreground:var(--tds-color-foreground-primary);background:var(--tds-color-background-transparent-active)}.tds-header-mobile-menu-action:disabled{cursor:not-allowed;opacity:var(--tds-opacity-disabled)}\n"],
    encapsulation: 2,
    changeDetection: 0
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HeaderMobileMenuActionComponent, [{
    type: Component,
    args: [{
      selector: 'button[tds-header-mobile-menu-action]',
      standalone: true,
      imports: [],
      host: {
        '[class]': 'defaultClass',
        '(click)': 'closeMenu()'
      },
      changeDetection: ChangeDetectionStrategy.OnPush,
      encapsulation: ViewEncapsulation.None,
      template: "<ng-content></ng-content>\n",
      styles: [".tds-header-mobile-menu-action{--tds-local-header-mobile-menu-action-color-foreground:var(--tds-color-foreground-secondary);--tds-local-header-mobile-menu-action-padding-side:var(--tds-size-spacing-200);all:unset;align-items:center;align-self:stretch;box-sizing:border-box;color:var(--tds-local-header-mobile-menu-action-color-foreground);cursor:pointer;display:inline-flex;font:var(--tds-font-heading-6);gap:var(--tds-size-spacing-100);justify-content:flex-start;max-width:none;min-height:32px;padding:var(--tds-size-spacing-150) var(--tds-size-spacing-200);position:relative;text-decoration:none;-webkit-font-smoothing:antialiased}.tds-header-mobile-menu-action *,.tds-header-mobile-menu-action :after,.tds-header-mobile-menu-action :before{box-sizing:border-box}.tds-header-mobile-menu-action:focus-visible{outline:solid var(--tds-size-border-medium) var(--tds-color-border-focus);outline-offset:calc(var(--tds-size-spacing-025) * -1)}.tds-header-mobile-menu-action:hover:not(:disabled){--tds-local-header-mobile-menu-action-color-foreground:var(--tds-color-foreground-primary);background:var(--tds-color-background-transparent-hover)}.tds-header-mobile-menu-action:active:not(:disabled){--tds-local-header-mobile-menu-action-color-foreground:var(--tds-color-foreground-primary);background:var(--tds-color-background-transparent-active)}.tds-header-mobile-menu-action:disabled{cursor:not-allowed;opacity:var(--tds-opacity-disabled)}\n"]
    }]
  }], null, null);
})();
const EXPORTS$1 = [HeaderComponent, HeaderCenterDirective, HeaderEndDirective, HeaderAppNameComponent, HeaderAppLogoDirective, HeaderNavigationComponent, HeaderNavigationLinkComponent, HeaderMobileMenuComponent, HeaderMobileMenuStartDirective, HeaderMobileMenuEndDirective, HeaderMobileMenuActionComponent];
class HeaderModule {
  static ɵfac = function HeaderModule_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || HeaderModule)();
  };
  static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: HeaderModule
  });
  static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HeaderModule, [{
    type: NgModule,
    args: [{
      declarations: [],
      imports: [...EXPORTS$1],
      exports: EXPORTS$1
    }]
  }], null, null);
})();
class AppShellComponent {
  defaultClass = 'tds-app-shell';
  static ɵfac = function AppShellComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || AppShellComponent)();
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: AppShellComponent,
    selectors: [["tds-app-shell"]],
    hostVars: 2,
    hostBindings: function AppShellComponent_HostBindings(rf, ctx) {
      if (rf & 2) {
        i0.ɵɵclassMap(ctx.defaultClass);
      }
    },
    standalone: true,
    features: [i0.ɵɵStandaloneFeature],
    ngContentSelectors: _c36,
    decls: 4,
    vars: 0,
    consts: [[1, "tds-app-shell__header"], [1, "tds-app-shell__content"]],
    template: function AppShellComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵprojectionDef(_c35);
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵprojection(1);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(2, "div", 1);
        i0.ɵɵprojection(3, 1);
        i0.ɵɵelementEnd();
      }
    },
    styles: [".tds-app-shell{display:grid;grid-template-areas:\"header\" \"content\";grid-template-rows:var(--tds-component-header-size-height) calc(100dvh - var(--tds-component-header-size-height));width:100%}.tds-app-shell__header{grid-area:header;width:100%}.tds-app-shell__content{background:var(--tds-color-background-page);grid-area:content;overflow:auto;width:100%}.tds-app-shell:has(.tds-header--menu-opened){grid-template-areas:\"header\";grid-template-rows:100dvh}.tds-app-shell:has(.tds-header--menu-opened) .tds-app-shell__content{display:none}body:has(.tds-app-shell){margin:unset;overflow:hidden;padding:unset}\n"],
    encapsulation: 2,
    changeDetection: 0
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AppShellComponent, [{
    type: Component,
    args: [{
      selector: 'tds-app-shell',
      standalone: true,
      imports: [],
      host: {
        '[class]': 'defaultClass'
      },
      changeDetection: ChangeDetectionStrategy.OnPush,
      encapsulation: ViewEncapsulation.None,
      template: "<div class=\"tds-app-shell__header\">\n  <ng-content select=\"[tds-header]\"></ng-content>\n</div>\n<div class=\"tds-app-shell__content\">\n  <ng-content></ng-content>\n</div>\n",
      styles: [".tds-app-shell{display:grid;grid-template-areas:\"header\" \"content\";grid-template-rows:var(--tds-component-header-size-height) calc(100dvh - var(--tds-component-header-size-height));width:100%}.tds-app-shell__header{grid-area:header;width:100%}.tds-app-shell__content{background:var(--tds-color-background-page);grid-area:content;overflow:auto;width:100%}.tds-app-shell:has(.tds-header--menu-opened){grid-template-areas:\"header\";grid-template-rows:100dvh}.tds-app-shell:has(.tds-header--menu-opened) .tds-app-shell__content{display:none}body:has(.tds-app-shell){margin:unset;overflow:hidden;padding:unset}\n"]
    }]
  }], null, null);
})();
class TileComponent extends LayerComponent {
  defaultTileClass = 'tds-tile';
  static ɵfac = /* @__PURE__ */(() => {
    let ɵTileComponent_BaseFactory;
    return function TileComponent_Factory(__ngFactoryType__) {
      return (ɵTileComponent_BaseFactory || (ɵTileComponent_BaseFactory = i0.ɵɵgetInheritedFactory(TileComponent)))(__ngFactoryType__ || TileComponent);
    };
  })();
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: TileComponent,
    selectors: [["", "tds-tile", ""]],
    hostVars: 2,
    hostBindings: function TileComponent_HostBindings(rf, ctx) {
      if (rf & 2) {
        i0.ɵɵclassMap(ctx.defaultTileClass);
      }
    },
    standalone: true,
    features: [i0.ɵɵInheritDefinitionFeature, i0.ɵɵStandaloneFeature],
    attrs: _c37,
    ngContentSelectors: _c39,
    decls: 5,
    vars: 0,
    consts: [[1, "tds-tile__content"]],
    template: function TileComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵprojectionDef(_c38);
        i0.ɵɵprojection(0);
        i0.ɵɵelementStart(1, "div", 0);
        i0.ɵɵprojection(2, 1);
        i0.ɵɵelementStart(3, "div");
        i0.ɵɵprojection(4, 2);
        i0.ɵɵelementEnd()();
      }
    },
    styles: [".tds-tile{--tds-local-tile-image-aspect-ratio:auto;border:var(--tds-size-border-thin) solid var(--tds-color-border-subtle);border-radius:var(--tds-size-radius-100);color:var(--tds-color-foreground-primary);display:flex;flex-direction:column;font:var(--tds-font-body-2)}.tds-tile,.tds-tile *,.tds-tile :after,.tds-tile :before{box-sizing:border-box}.tds-tile__image{aspect-ratio:var(--tds-local-tile-image-aspect-ratio);border-radius:var(--tds-size-radius-100) var(--tds-size-radius-100) 0 0;height:auto;max-width:100%;-o-object-fit:cover;object-fit:cover}.tds-tile__content{padding:var(--tds-size-spacing-200)}.tds-tile__title{display:inline-block;font:var(--tds-font-heading-4);margin-bottom:var(--tds-size-spacing-200)}.tds-tile.tds-layer--clickable:focus-visible{outline:solid var(--tds-size-border-medium) var(--tds-color-border-focus);outline-offset:calc(var(--tds-size-spacing-025) * -1)}.tds-tile .tds-tile__image--aspect-ratio-auto{--tds-local-tile-image-aspect-ratio:auto}.tds-tile .tds-tile__image--aspect-ratio-1-1{--tds-local-tile-image-aspect-ratio:1/1}.tds-tile .tds-tile__image--aspect-ratio-1-2{--tds-local-tile-image-aspect-ratio:1/2}.tds-tile .tds-tile__image--aspect-ratio-2-1{--tds-local-tile-image-aspect-ratio:2/1}.tds-tile .tds-tile__image--aspect-ratio-2-3{--tds-local-tile-image-aspect-ratio:2/3}.tds-tile .tds-tile__image--aspect-ratio-3-1{--tds-local-tile-image-aspect-ratio:3/1}.tds-tile .tds-tile__image--aspect-ratio-3-2{--tds-local-tile-image-aspect-ratio:3/2}.tds-tile .tds-tile__image--aspect-ratio-3-4{--tds-local-tile-image-aspect-ratio:3/4}.tds-tile .tds-tile__image--aspect-ratio-4-1{--tds-local-tile-image-aspect-ratio:4/1}.tds-tile .tds-tile__image--aspect-ratio-4-3{--tds-local-tile-image-aspect-ratio:4/3}.tds-tile .tds-tile__image--aspect-ratio-4-5{--tds-local-tile-image-aspect-ratio:4/5}.tds-tile .tds-tile__image--aspect-ratio-5-2{--tds-local-tile-image-aspect-ratio:5/2}.tds-tile .tds-tile__image--aspect-ratio-5-4{--tds-local-tile-image-aspect-ratio:5/4}.tds-tile .tds-tile__image--aspect-ratio-6-7{--tds-local-tile-image-aspect-ratio:6/7}.tds-tile .tds-tile__image--aspect-ratio-8-3{--tds-local-tile-image-aspect-ratio:8/3}.tds-tile .tds-tile__image--aspect-ratio-8-5{--tds-local-tile-image-aspect-ratio:8/5}.tds-tile .tds-tile__image--aspect-ratio-9-8{--tds-local-tile-image-aspect-ratio:9/8}.tds-tile .tds-tile__image--aspect-ratio-9-16{--tds-local-tile-image-aspect-ratio:9/16}.tds-tile .tds-tile__image--aspect-ratio-9-21{--tds-local-tile-image-aspect-ratio:9/21}.tds-tile .tds-tile__image--aspect-ratio-10-16{--tds-local-tile-image-aspect-ratio:10/16}.tds-tile .tds-tile__image--aspect-ratio-14-3{--tds-local-tile-image-aspect-ratio:14/3}.tds-tile .tds-tile__image--aspect-ratio-16-5{--tds-local-tile-image-aspect-ratio:16/5}.tds-tile .tds-tile__image--aspect-ratio-16-9{--tds-local-tile-image-aspect-ratio:16/9}.tds-tile .tds-tile__image--aspect-ratio-16-10{--tds-local-tile-image-aspect-ratio:16/10}.tds-tile .tds-tile__image--aspect-ratio-21-9{--tds-local-tile-image-aspect-ratio:21/9}.tds-tile .tds-tile__image--aspect-ratio-golden-ratio-landscape{--tds-local-tile-image-aspect-ratio:1/1.618}.tds-tile .tds-tile__image--aspect-ratio-golden-ratio-portrait{--tds-local-tile-image-aspect-ratio:1.618/1}.tds-tile .tds-tile__image--aspect-ratio-A4-landscape{--tds-local-tile-image-aspect-ratio:1.414/1}.tds-tile .tds-tile__image--aspect-ratio-A4-portrait{--tds-local-tile-image-aspect-ratio:1/1.414}.tds-layer{background:var(--tds-component-layer-color-background-default);color:var(--tds-color-foreground-primary);font-family:var(--tds-font-family-sans)}.tds-layer .tds-layer:not(.tds-layer--100):not(.tds-layer--200){--tds-color-background-field:var(--tds-private-color-field-300);--tds-component-segmented-control-color-background:var(--tds-private-color-segmented-control-300);--tds-component-layer-color-background-default:var(--tds-private-color-layer-200-default);--tds-component-layer-color-background-hover:var(--tds-private-color-layer-200-hover);--tds-component-layer-color-background-active:var(--tds-private-color-layer-200-active)}.tds-layer--clickable{cursor:pointer}.tds-layer--clickable:focus-visible{outline:solid var(--tds-size-border-medium) var(--tds-color-border-focus);outline-offset:0}.tds-layer--clickable:hover{background:var(--tds-component-layer-color-background-hover)}.tds-layer--clickable:active{background:var(--tds-component-layer-color-background-active)}.tds-layer,.tds-layer--100,.tds-layer--auto{--tds-color-background-field:var(--tds-private-color-field-200);--tds-component-segmented-control-color-background:var(--tds-private-color-segmented-control-200);--tds-component-layer-color-background-default:var(--tds-private-color-layer-100-default);--tds-component-layer-color-background-hover:var(--tds-private-color-layer-100-hover);--tds-component-layer-color-background-active:var(--tds-private-color-layer-100-active)}.tds-layer--200{--tds-color-background-field:var(--tds-private-color-field-300);--tds-component-segmented-control-color-background:var(--tds-private-color-segmented-control-300);--tds-component-layer-color-background-default:var(--tds-private-color-layer-200-default);--tds-component-layer-color-background-hover:var(--tds-private-color-layer-200-hover);--tds-component-layer-color-background-active:var(--tds-private-color-layer-200-active)}\n"],
    encapsulation: 2,
    changeDetection: 0
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TileComponent, [{
    type: Component,
    args: [{
      selector: '[tds-tile]',
      standalone: true,
      imports: [LayerComponent],
      host: {
        '[class]': 'defaultTileClass'
      },
      changeDetection: ChangeDetectionStrategy.OnPush,
      encapsulation: ViewEncapsulation.None,
      template: "<ng-content select=\"[tds-tile-image]\" />\n<div class=\"tds-tile__content\">\n  <ng-content select=\"tds-tile-title\" />\n  <div>\n    <ng-content />\n  </div>\n</div>\n",
      styles: [".tds-tile{--tds-local-tile-image-aspect-ratio:auto;border:var(--tds-size-border-thin) solid var(--tds-color-border-subtle);border-radius:var(--tds-size-radius-100);color:var(--tds-color-foreground-primary);display:flex;flex-direction:column;font:var(--tds-font-body-2)}.tds-tile,.tds-tile *,.tds-tile :after,.tds-tile :before{box-sizing:border-box}.tds-tile__image{aspect-ratio:var(--tds-local-tile-image-aspect-ratio);border-radius:var(--tds-size-radius-100) var(--tds-size-radius-100) 0 0;height:auto;max-width:100%;-o-object-fit:cover;object-fit:cover}.tds-tile__content{padding:var(--tds-size-spacing-200)}.tds-tile__title{display:inline-block;font:var(--tds-font-heading-4);margin-bottom:var(--tds-size-spacing-200)}.tds-tile.tds-layer--clickable:focus-visible{outline:solid var(--tds-size-border-medium) var(--tds-color-border-focus);outline-offset:calc(var(--tds-size-spacing-025) * -1)}.tds-tile .tds-tile__image--aspect-ratio-auto{--tds-local-tile-image-aspect-ratio:auto}.tds-tile .tds-tile__image--aspect-ratio-1-1{--tds-local-tile-image-aspect-ratio:1/1}.tds-tile .tds-tile__image--aspect-ratio-1-2{--tds-local-tile-image-aspect-ratio:1/2}.tds-tile .tds-tile__image--aspect-ratio-2-1{--tds-local-tile-image-aspect-ratio:2/1}.tds-tile .tds-tile__image--aspect-ratio-2-3{--tds-local-tile-image-aspect-ratio:2/3}.tds-tile .tds-tile__image--aspect-ratio-3-1{--tds-local-tile-image-aspect-ratio:3/1}.tds-tile .tds-tile__image--aspect-ratio-3-2{--tds-local-tile-image-aspect-ratio:3/2}.tds-tile .tds-tile__image--aspect-ratio-3-4{--tds-local-tile-image-aspect-ratio:3/4}.tds-tile .tds-tile__image--aspect-ratio-4-1{--tds-local-tile-image-aspect-ratio:4/1}.tds-tile .tds-tile__image--aspect-ratio-4-3{--tds-local-tile-image-aspect-ratio:4/3}.tds-tile .tds-tile__image--aspect-ratio-4-5{--tds-local-tile-image-aspect-ratio:4/5}.tds-tile .tds-tile__image--aspect-ratio-5-2{--tds-local-tile-image-aspect-ratio:5/2}.tds-tile .tds-tile__image--aspect-ratio-5-4{--tds-local-tile-image-aspect-ratio:5/4}.tds-tile .tds-tile__image--aspect-ratio-6-7{--tds-local-tile-image-aspect-ratio:6/7}.tds-tile .tds-tile__image--aspect-ratio-8-3{--tds-local-tile-image-aspect-ratio:8/3}.tds-tile .tds-tile__image--aspect-ratio-8-5{--tds-local-tile-image-aspect-ratio:8/5}.tds-tile .tds-tile__image--aspect-ratio-9-8{--tds-local-tile-image-aspect-ratio:9/8}.tds-tile .tds-tile__image--aspect-ratio-9-16{--tds-local-tile-image-aspect-ratio:9/16}.tds-tile .tds-tile__image--aspect-ratio-9-21{--tds-local-tile-image-aspect-ratio:9/21}.tds-tile .tds-tile__image--aspect-ratio-10-16{--tds-local-tile-image-aspect-ratio:10/16}.tds-tile .tds-tile__image--aspect-ratio-14-3{--tds-local-tile-image-aspect-ratio:14/3}.tds-tile .tds-tile__image--aspect-ratio-16-5{--tds-local-tile-image-aspect-ratio:16/5}.tds-tile .tds-tile__image--aspect-ratio-16-9{--tds-local-tile-image-aspect-ratio:16/9}.tds-tile .tds-tile__image--aspect-ratio-16-10{--tds-local-tile-image-aspect-ratio:16/10}.tds-tile .tds-tile__image--aspect-ratio-21-9{--tds-local-tile-image-aspect-ratio:21/9}.tds-tile .tds-tile__image--aspect-ratio-golden-ratio-landscape{--tds-local-tile-image-aspect-ratio:1/1.618}.tds-tile .tds-tile__image--aspect-ratio-golden-ratio-portrait{--tds-local-tile-image-aspect-ratio:1.618/1}.tds-tile .tds-tile__image--aspect-ratio-A4-landscape{--tds-local-tile-image-aspect-ratio:1.414/1}.tds-tile .tds-tile__image--aspect-ratio-A4-portrait{--tds-local-tile-image-aspect-ratio:1/1.414}.tds-layer{background:var(--tds-component-layer-color-background-default);color:var(--tds-color-foreground-primary);font-family:var(--tds-font-family-sans)}.tds-layer .tds-layer:not(.tds-layer--100):not(.tds-layer--200){--tds-color-background-field:var(--tds-private-color-field-300);--tds-component-segmented-control-color-background:var(--tds-private-color-segmented-control-300);--tds-component-layer-color-background-default:var(--tds-private-color-layer-200-default);--tds-component-layer-color-background-hover:var(--tds-private-color-layer-200-hover);--tds-component-layer-color-background-active:var(--tds-private-color-layer-200-active)}.tds-layer--clickable{cursor:pointer}.tds-layer--clickable:focus-visible{outline:solid var(--tds-size-border-medium) var(--tds-color-border-focus);outline-offset:0}.tds-layer--clickable:hover{background:var(--tds-component-layer-color-background-hover)}.tds-layer--clickable:active{background:var(--tds-component-layer-color-background-active)}.tds-layer,.tds-layer--100,.tds-layer--auto{--tds-color-background-field:var(--tds-private-color-field-200);--tds-component-segmented-control-color-background:var(--tds-private-color-segmented-control-200);--tds-component-layer-color-background-default:var(--tds-private-color-layer-100-default);--tds-component-layer-color-background-hover:var(--tds-private-color-layer-100-hover);--tds-component-layer-color-background-active:var(--tds-private-color-layer-100-active)}.tds-layer--200{--tds-color-background-field:var(--tds-private-color-field-300);--tds-component-segmented-control-color-background:var(--tds-private-color-segmented-control-300);--tds-component-layer-color-background-default:var(--tds-private-color-layer-200-default);--tds-component-layer-color-background-hover:var(--tds-private-color-layer-200-hover);--tds-component-layer-color-background-active:var(--tds-private-color-layer-200-active)}\n"]
    }]
  }], null, null);
})();
const EXPORTS = [TileComponent, TileTitleDirective, TileImageDirective];
class TileModule {
  static ɵfac = function TileModule_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || TileModule)();
  };
  static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: TileModule
  });
  static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TileModule, [{
    type: NgModule,
    args: [{
      declarations: [],
      imports: [...EXPORTS],
      exports: EXPORTS
    }]
  }], null, null);
})();
class NotificationComponent {
  defaultCloseIconButtonLabel = 'Close';
  defaultStatus = 'info';
  defaultClass = 'tds-notification';
  renderer = inject(Renderer2);
  el = inject(ElementRef);
  /**
   * Status of the notification.
   * @default 'info'
   */
  status = input(this.defaultStatus);
  /**
   * If set to true a close icon is displayed.
   * @default true
   */
  isClosable = input(true, {
    transform: booleanAttribute
  });
  /**
   * The label for the close icon button.
   * The icon is displayed on closable notifications and when hovered a tooltip with this label appears.
   * It is also used for assistive technologies.
   * @default 'Close'
   */
  closeIconButtonLabel = input(this.defaultCloseIconButtonLabel, {
    transform: value => value ?? this.defaultCloseIconButtonLabel
  });
  /**
   * Is the notification inline or a toast.
   * @default true
   */
  isInline = input(true, {
    transform: booleanAttribute
  });
  /**
   * If set to true the notification will be removed from the DOM when the close icon is clicked.
   * @default true
   */
  shouldAutoDestroyOnClose = input(true, {
    transform: booleanAttribute
  });
  /**
   * Emits an `Event` when the close icon button is clicked.
   */
  close = output();
  iconName = computed(() => {
    switch (this.status()) {
      case 'info':
        return 'info';
      case 'success':
        return 'check_circle';
      case 'warning':
        return 'warning';
      case 'danger':
        return 'error';
      default:
        return 'info';
    }
  });
  onClose(event) {
    this.close.emit(event);
    if (this.shouldAutoDestroyOnClose()) {
      this.renderer.removeChild(this.el.nativeElement, this.el.nativeElement, true);
    }
  }
  classes = computed(() => {
    const statusClass = this.status() && this.status() !== this.defaultStatus ? `${this.defaultClass}--${this.status()}` : '';
    const toastClass = !this.isInline() ? `${this.defaultClass}--toast` : '';
    return `${this.defaultClass} ${statusClass} ${toastClass}`;
  });
  static ɵfac = function NotificationComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || NotificationComponent)();
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: NotificationComponent,
    selectors: [["tds-notification"]],
    hostVars: 2,
    hostBindings: function NotificationComponent_HostBindings(rf, ctx) {
      if (rf & 2) {
        i0.ɵɵclassMap(ctx.classes());
      }
    },
    inputs: {
      status: [1, "status"],
      isClosable: [1, "isClosable"],
      closeIconButtonLabel: [1, "closeIconButtonLabel"],
      isInline: [1, "isInline"],
      shouldAutoDestroyOnClose: [1, "shouldAutoDestroyOnClose"]
    },
    outputs: {
      close: "close"
    },
    standalone: true,
    features: [i0.ɵɵStandaloneFeature],
    ngContentSelectors: _c41,
    decls: 6,
    vars: 2,
    consts: [["isFilled", "", "size", "sm", 1, "tds-notification__icon", 3, "name"], [1, "tds-notification__body"], [1, "tds-notification__content"], ["tds-icon-button", "", 1, "tds-notification__close-icon", 3, "label"], ["tds-icon-button", "", 1, "tds-notification__close-icon", 3, "click", "label"], ["name", "close", "size", "sm"]],
    template: function NotificationComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵprojectionDef(_c40);
        i0.ɵɵelement(0, "tds-icon", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵprojection(2);
        i0.ɵɵelementStart(3, "div", 2);
        i0.ɵɵprojection(4, 1);
        i0.ɵɵelementEnd()();
        i0.ɵɵtemplate(5, NotificationComponent_Conditional_5_Template, 2, 1, "button", 3);
      }
      if (rf & 2) {
        i0.ɵɵproperty("name", ctx.iconName());
        i0.ɵɵadvance(5);
        i0.ɵɵconditional(ctx.isClosable() ? 5 : -1);
      }
    },
    dependencies: [IconButtonComponent, IconComponent],
    styles: [".tds-notification{align-items:flex-start;background-color:var(--tds-local-notification-background-color);border:solid var(--tds-size-border-thin) var(--tds-local-notification-border-color);border-radius:var(--tds-size-radius-050);color:var(--tds-local-notification-foreground-color);display:flex;font:var(--tds-font-body-2);gap:var(--tds-size-spacing-200);padding:var(--tds-size-spacing-200);width:100%}.tds-notification,.tds-notification *,.tds-notification :after,.tds-notification :before{box-sizing:border-box}.tds-notification:has(.tds-notification__title:empty),.tds-notification:not(:has(.tds-notification__title)){align-items:center;padding:var(--tds-size-spacing-125) var(--tds-size-spacing-125) var(--tds-size-spacing-125) var(--tds-size-spacing-200)}.tds-notification:has(.tds-notification__title:empty) .tds-notification__close-icon,.tds-notification:not(:has(.tds-notification__title)) .tds-notification__close-icon{margin-right:0;margin-top:0}.tds-notification--toast{box-shadow:0 8px 12px #222b2d1a}.tds-notification__icon{grid-area:icon}.tds-notification__title{font:var(--tds-font-heading-6);grid-area:title}.tds-notification__title:empty{display:none}.tds-notification__body{display:flex;flex-direction:column;flex-grow:1;gap:var(--tds-size-spacing-100)}.tds-notification__content{grid-area:content}.tds-notification__content:empty{display:none}.tds-notification__close-icon.tds-icon-button{--tds-component-icon-button-color-foreground:currentColor;grid-area:close-icon;margin-right:calc(var(--tds-size-spacing-100) * -1);margin-top:calc(var(--tds-size-spacing-100) * -1)}.tds-notification,.tds-notification.tds-notification--info{--tds-local-notification-foreground-color:var(--tds-color-foreground-status-info);--tds-local-notification-background-color:var(--tds-color-background-status-info);--tds-local-notification-border-color:var(--tds-color-border-status-info)}.tds-notification.tds-notification--success{--tds-local-notification-foreground-color:var(--tds-color-foreground-status-success);--tds-local-notification-background-color:var(--tds-color-background-status-success);--tds-local-notification-border-color:var(--tds-color-border-status-success)}.tds-notification.tds-notification--danger{--tds-local-notification-foreground-color:var(--tds-color-foreground-status-danger);--tds-local-notification-background-color:var(--tds-color-background-status-danger);--tds-local-notification-border-color:var(--tds-color-border-status-danger)}.tds-notification.tds-notification--warning{--tds-local-notification-foreground-color:var(--tds-color-foreground-status-warning);--tds-local-notification-background-color:var(--tds-color-background-status-warning);--tds-local-notification-border-color:var(--tds-color-border-status-warning)}\n"],
    encapsulation: 2,
    changeDetection: 0
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NotificationComponent, [{
    type: Component,
    args: [{
      selector: 'tds-notification',
      standalone: true,
      imports: [IconButtonComponent, IconComponent],
      host: {
        '[class]': 'classes()'
      },
      changeDetection: ChangeDetectionStrategy.OnPush,
      encapsulation: ViewEncapsulation.None,
      template: "<tds-icon\n  class=\"tds-notification__icon\"\n  isFilled\n  size=\"sm\"\n  [name]=\"iconName()\" />\n<div class=\"tds-notification__body\">\n  <ng-content select=\"tds-notification-title\" />\n  <div class=\"tds-notification__content\">\n    <ng-content />\n  </div>\n</div>\n@if (isClosable()) {\n  <button\n    tds-icon-button\n    class=\"tds-notification__close-icon\"\n    [label]=\"closeIconButtonLabel()\"\n    (click)=\"onClose($event)\">\n    <tds-icon\n      name=\"close\"\n      size=\"sm\" />\n  </button>\n}\n",
      styles: [".tds-notification{align-items:flex-start;background-color:var(--tds-local-notification-background-color);border:solid var(--tds-size-border-thin) var(--tds-local-notification-border-color);border-radius:var(--tds-size-radius-050);color:var(--tds-local-notification-foreground-color);display:flex;font:var(--tds-font-body-2);gap:var(--tds-size-spacing-200);padding:var(--tds-size-spacing-200);width:100%}.tds-notification,.tds-notification *,.tds-notification :after,.tds-notification :before{box-sizing:border-box}.tds-notification:has(.tds-notification__title:empty),.tds-notification:not(:has(.tds-notification__title)){align-items:center;padding:var(--tds-size-spacing-125) var(--tds-size-spacing-125) var(--tds-size-spacing-125) var(--tds-size-spacing-200)}.tds-notification:has(.tds-notification__title:empty) .tds-notification__close-icon,.tds-notification:not(:has(.tds-notification__title)) .tds-notification__close-icon{margin-right:0;margin-top:0}.tds-notification--toast{box-shadow:0 8px 12px #222b2d1a}.tds-notification__icon{grid-area:icon}.tds-notification__title{font:var(--tds-font-heading-6);grid-area:title}.tds-notification__title:empty{display:none}.tds-notification__body{display:flex;flex-direction:column;flex-grow:1;gap:var(--tds-size-spacing-100)}.tds-notification__content{grid-area:content}.tds-notification__content:empty{display:none}.tds-notification__close-icon.tds-icon-button{--tds-component-icon-button-color-foreground:currentColor;grid-area:close-icon;margin-right:calc(var(--tds-size-spacing-100) * -1);margin-top:calc(var(--tds-size-spacing-100) * -1)}.tds-notification,.tds-notification.tds-notification--info{--tds-local-notification-foreground-color:var(--tds-color-foreground-status-info);--tds-local-notification-background-color:var(--tds-color-background-status-info);--tds-local-notification-border-color:var(--tds-color-border-status-info)}.tds-notification.tds-notification--success{--tds-local-notification-foreground-color:var(--tds-color-foreground-status-success);--tds-local-notification-background-color:var(--tds-color-background-status-success);--tds-local-notification-border-color:var(--tds-color-border-status-success)}.tds-notification.tds-notification--danger{--tds-local-notification-foreground-color:var(--tds-color-foreground-status-danger);--tds-local-notification-background-color:var(--tds-color-background-status-danger);--tds-local-notification-border-color:var(--tds-color-border-status-danger)}.tds-notification.tds-notification--warning{--tds-local-notification-foreground-color:var(--tds-color-foreground-status-warning);--tds-local-notification-background-color:var(--tds-color-background-status-warning);--tds-local-notification-border-color:var(--tds-color-border-status-warning)}\n"]
    }]
  }], null, null);
})();

/**
 * NOTIFICATION_STATUSES is an array of all possible notification statuses. Used to define `NotificationStatus` union type. Useful for looping through all possible notification statuses.
 */
const NOTIFICATION_STATUSES = [...STATUS_VARIANTS];
class DatatableTemplateCellRendererComponent {
  params;
  template;
  agInit(templateCellRendererParams) {
    const {
      template,
      ...params
    } = templateCellRendererParams;
    this.template = template;
    this.params = params;
  }
  refresh(templateCellRendererParams) {
    const {
      template,
      ...params
    } = templateCellRendererParams;
    this.template = template;
    this.params = params;
    return true;
  }
  static ɵfac = function DatatableTemplateCellRendererComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || DatatableTemplateCellRendererComponent)();
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: DatatableTemplateCellRendererComponent,
    selectors: [["tds-datatable-template-cell-renderer"]],
    standalone: true,
    features: [i0.ɵɵStandaloneFeature],
    decls: 1,
    vars: 4,
    consts: [[3, "ngTemplateOutlet", "ngTemplateOutletContext"]],
    template: function DatatableTemplateCellRendererComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵelementContainer(0, 0);
      }
      if (rf & 2) {
        i0.ɵɵproperty("ngTemplateOutlet", ctx.template)("ngTemplateOutletContext", i0.ɵɵpureFunction1(2, _c42, ctx.params));
      }
    },
    dependencies: [NgTemplateOutlet],
    styles: ["[_nghost-%COMP%]{width:100%;height:100%;display:inline-flex;align-items:center;line-height:normal}"]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DatatableTemplateCellRendererComponent, [{
    type: Component,
    args: [{
      selector: 'tds-datatable-template-cell-renderer',
      standalone: true,
      imports: [NgTemplateOutlet],
      template: "<ng-container\n  [ngTemplateOutlet]=\"template\"\n  [ngTemplateOutletContext]=\"{$implicit: params}\" />\n",
      styles: [":host{width:100%;height:100%;display:inline-flex;align-items:center;line-height:normal}\n"]
    }]
  }], null, null);
})();

/**
 * Injection token to provide the options for the Theme Service.
 */
const TDS_THEME_SERVICE_OPTIONS = new InjectionToken('TDS_THEME_SERVICE_OPTIONS');
class ThemeService {
  renderer = inject(RendererFactory2)?.createRenderer(null, null);
  document = inject(DOCUMENT);
  body = this.document?.body;
  window = this.document?.defaultView;
  options = inject(TDS_THEME_SERVICE_OPTIONS, {
    optional: true
  });
  /**
   * Signal to manage if the theme should be persisted to the local storage.
   */
  shouldPersistTheme = signal(this.options?.shouldPersistToLocalStorage ?? true);
  /**
   * Signal to manage the theme of the application.
   * Default value is `TDS_THEME_SERVICE_OPTIONS.defaultTheme` Injection Token or `light` if no injection token is found.
   */
  theme = signal(this.options?.defaultTheme ?? 'light');
  constructor() {
    if (this.shouldPersistTheme()) {
      const theme = localStorage.getItem('tds-theme');
      if (theme) {
        this.theme.set(theme);
      }
    }
    effect(() => {
      if (!this.renderer || !this.body || !this.window) {
        return;
      }
      if (this.computedTheme() === 'dark') {
        this.renderer.addClass(this.body, 'dark');
      } else {
        this.renderer.removeClass(this.body, 'dark');
      }
    });
    effect(() => {
      if (this.shouldPersistTheme()) {
        localStorage.setItem('tds-theme', this.theme());
      }
    });
  }
  /**
   * Returns the applied theme.
   * If the theme is set to `system`, it will return `dark` or `light` based on the system preference.
   * Else, it will return the theme that is set.
   */
  computedTheme = computed(() => {
    if (this.theme() === 'system') {
      return this.window?.matchMedia?.('(prefers-color-scheme: dark)')?.matches ? 'dark' : 'light';
    } else {
      return this.theme();
    }
  });
  /**
   * Toggle the theme between light and dark.
   */
  toggleTheme() {
    this.theme.update(_ => this.computedTheme() === 'light' ? 'dark' : 'light');
  }
  /**
   * Set the theme to the specific value.
   * @param theme
   */
  setTheme(theme) {
    if (!theme) {
      return;
    }
    this.theme.set(theme);
  }
  static ɵfac = function ThemeService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || ThemeService)();
  };
  static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: ThemeService,
    factory: ThemeService.ɵfac,
    providedIn: 'root'
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ThemeService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [], null);
})();

/**
 * Default duration for notifications in `ms`
 */
const DEFAULT_NOTIFICATION_DURATION = 3000;
class NotificationService {
  idPrefix = 'tds-notification';
  timeouts = {};
  bodyPortal;
  containerPortal;
  overlay = inject(Overlay);
  /**
   * Signal that stores all opened notifications
   */
  notifications = signal([]);
  /**
   * Open a notification
   * Opens a notification container if not exists
   * @param notification
   */
  openNotification(notification) {
    if (!this.bodyPortal?.hasAttached()) {
      this.injectContainerComponentToDom();
    }
    const id = genRandomId(this.idPrefix);
    const duration = notification.duration ?? DEFAULT_NOTIFICATION_DURATION;
    const completeNotification = {
      id,
      duration,
      ...notification
    };
    this.notifications.update(notifications => [completeNotification, ...notifications]);
    this.timeouts[id] = setTimeout(() => this.closeNotification(completeNotification), completeNotification.duration);
    return id;
  }
  /**
   * Close notification
   * @param notification
   */
  closeNotification(notification) {
    this.notifications.update(notifications => notifications.filter(n => n.id !== notification.id));
    notification?.onClose?.(notification);
    clearTimeout(this.timeouts[notification.id]);
    delete this.timeouts[notification.id];
  }
  /**
   * Clear all notifications
   */
  clearAllNotifications(options) {
    if (options?.emitCloseEvent !== false) {
      for (const notification of this.notifications()) {
        notification?.onClose?.(notification);
      }
    }
    this.notifications.set([]);
    Object.values(this.timeouts).forEach(timeout => clearTimeout(timeout));
    this.timeouts = {};
  }
  /**
   * Portal NotificationContainerComponent to body to avoid z-index and overflow issues
   * @private
   */
  injectContainerComponentToDom() {
    this.bodyPortal = this.overlay.create();
    this.containerPortal = new ComponentPortal(NotificationContainerComponent);
    this.bodyPortal.attach(this.containerPortal);
  }
  static ɵfac = function NotificationService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || NotificationService)();
  };
  static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: NotificationService,
    factory: NotificationService.ɵfac,
    providedIn: 'root'
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NotificationService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], null, null);
})();

// TODO: use tokens for animation timings and easing when available in JS
const notificationContainerAnimations = {
  notificationAnim: trigger('notification', [transition('void => desktop', [style({
    translate: '110% 0',
    height: 0,
    marginBottom: 0
  }), sequence([animate('150ms cubic-bezier(0.2, 0.0, 0, 1.0)', style({
    height: '*',
    marginBottom: 'var(--tds-size-spacing-200)'
  })), animate('300ms cubic-bezier(0.2, 0.0, 0, 1.0)', style({
    translate: 0
  }))])]), transition('desktop => void, mobile => void', [style({
    translate: '0',
    height: '*'
  }), sequence([animate('300ms cubic-bezier(0, 0, 0, 1)', style({
    translate: '110% 0'
  })), animate('200ms cubic-bezier(0, 0, 0, 1)', style({
    height: '0',
    padding: 0,
    margin: 0
  }))])]), transition('void => mobile', [style({
    translate: '0 110%',
    height: 0,
    marginTop: 0
  }), group([animate('300ms cubic-bezier(0.2, 0.0, 0, 1.0)', style({
    translate: 0,
    marginTop: 'var(--tds-size-spacing-200)'
  })), animate('200ms cubic-bezier(0.2, 0.0, 0, 1.0)', style({
    height: '*'
  }))])])])
};
class NotificationContainerComponent {
  defaultClass = 'tds-notification-container';
  breakpointObserver = inject(BreakpointObserver);
  mobileBreakpoint = toSignal(this.breakpointObserver.observe([CUSTOM_CDK_BREAKPOINTS.mobile]));
  notificationService = inject(NotificationService);
  isMobile = computed(() => {
    return this.mobileBreakpoint()?.matches;
  });
  animationName = computed(() => {
    return this.isMobile() ? 'mobile' : 'desktop';
  });
  closeNotification(notification) {
    this.notificationService.closeNotification(notification);
  }
  static ɵfac = function NotificationContainerComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || NotificationContainerComponent)();
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: NotificationContainerComponent,
    selectors: [["tds-notification-container"]],
    hostVars: 2,
    hostBindings: function NotificationContainerComponent_HostBindings(rf, ctx) {
      if (rf & 2) {
        i0.ɵɵclassMap(ctx.defaultClass);
      }
    },
    standalone: true,
    features: [i0.ɵɵStandaloneFeature],
    decls: 5,
    vars: 0,
    consts: [["content", ""], [3, "closeIconButtonLabel", "isInline", "shouldAutoDestroyOnClose", "status"], [3, "close", "closeIconButtonLabel", "isInline", "shouldAutoDestroyOnClose", "status"], [3, "ngTemplateOutlet", "ngTemplateOutletContext"], [3, "ngComponentOutlet", "ngComponentOutletInputs"]],
    template: function NotificationContainerComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵdeclareLet(0);
        i0.ɵɵrepeaterCreate(1, NotificationContainerComponent_For_2_Template, 3, 13, "tds-notification", 1, _forTrack0);
        i0.ɵɵtemplate(3, NotificationContainerComponent_ng_template_3_Template, 3, 1, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
      }
      if (rf & 2) {
        const notifications_r8 = ctx.notificationService == null ? null : ctx.notificationService.notifications();
        i0.ɵɵadvance();
        i0.ɵɵrepeater(notifications_r8);
      }
    },
    dependencies: [NotificationComponent, NotificationTitleDirective, NgTemplateOutlet, NgComponentOutlet],
    styles: [".tds-notification{align-items:flex-start;background-color:var(--tds-local-notification-background-color);border:solid var(--tds-size-border-thin) var(--tds-local-notification-border-color);border-radius:var(--tds-size-radius-050);color:var(--tds-local-notification-foreground-color);display:flex;font:var(--tds-font-body-2);gap:var(--tds-size-spacing-200);padding:var(--tds-size-spacing-200);width:100%}.tds-notification,.tds-notification *,.tds-notification :after,.tds-notification :before{box-sizing:border-box}.tds-notification:has(.tds-notification__title:empty),.tds-notification:not(:has(.tds-notification__title)){align-items:center;padding:var(--tds-size-spacing-125) var(--tds-size-spacing-125) var(--tds-size-spacing-125) var(--tds-size-spacing-200)}.tds-notification:has(.tds-notification__title:empty) .tds-notification__close-icon,.tds-notification:not(:has(.tds-notification__title)) .tds-notification__close-icon{margin-right:0;margin-top:0}.tds-notification--toast{box-shadow:0 8px 12px #222b2d1a}.tds-notification__icon{grid-area:icon}.tds-notification__title{font:var(--tds-font-heading-6);grid-area:title}.tds-notification__title:empty{display:none}.tds-notification__body{display:flex;flex-direction:column;flex-grow:1;gap:var(--tds-size-spacing-100)}.tds-notification__content{grid-area:content}.tds-notification__content:empty{display:none}.tds-notification__close-icon.tds-icon-button{--tds-component-icon-button-color-foreground:currentColor;grid-area:close-icon;margin-right:calc(var(--tds-size-spacing-100) * -1);margin-top:calc(var(--tds-size-spacing-100) * -1)}.tds-notification,.tds-notification.tds-notification--info{--tds-local-notification-foreground-color:var(--tds-color-foreground-status-info);--tds-local-notification-background-color:var(--tds-color-background-status-info);--tds-local-notification-border-color:var(--tds-color-border-status-info)}.tds-notification.tds-notification--success{--tds-local-notification-foreground-color:var(--tds-color-foreground-status-success);--tds-local-notification-background-color:var(--tds-color-background-status-success);--tds-local-notification-border-color:var(--tds-color-border-status-success)}.tds-notification.tds-notification--danger{--tds-local-notification-foreground-color:var(--tds-color-foreground-status-danger);--tds-local-notification-background-color:var(--tds-color-background-status-danger);--tds-local-notification-border-color:var(--tds-color-border-status-danger)}.tds-notification.tds-notification--warning{--tds-local-notification-foreground-color:var(--tds-color-foreground-status-warning);--tds-local-notification-background-color:var(--tds-color-background-status-warning);--tds-local-notification-border-color:var(--tds-color-border-status-warning)}.tds-notification-container{align-items:flex-end;box-sizing:border-box;display:flex;flex-direction:column;height:calc(100dvh - var(--tds-component-header-size-height));left:0;overflow:hidden;padding:var(--tds-size-spacing-200);pointer-events:none;position:fixed;top:var(--tds-component-header-size-height);width:100%;z-index:10}.tds-notification-container *,.tds-notification-container :after,.tds-notification-container :before{box-sizing:border-box}.tds-notification-container:empty{display:none}.tds-notification-container .tds-notification{flex-shrink:0;max-width:100%;overflow:hidden;pointer-events:auto;width:440px}.tds-notification-container .tds-notification:not(:last-of-type){margin-bottom:var(--tds-size-spacing-200)}@media (width < 576px){.tds-notification-container{flex-direction:column-reverse}.tds-notification-container .tds-notification{width:100%}.tds-notification-container .tds-notification:not(:last-of-type){margin-bottom:0;margin-top:var(--tds-size-spacing-200)}}\n"],
    encapsulation: 2,
    data: {
      animation: [notificationContainerAnimations.notificationAnim]
    },
    changeDetection: 0
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NotificationContainerComponent, [{
    type: Component,
    args: [{
      selector: 'tds-notification-container',
      standalone: true,
      imports: [NotificationComponent, NotificationTitleDirective, NgTemplateOutlet, NgComponentOutlet],
      host: {
        '[class]': 'defaultClass'
      },
      animations: [notificationContainerAnimations.notificationAnim],
      changeDetection: ChangeDetectionStrategy.OnPush,
      encapsulation: ViewEncapsulation.None,
      template: "@let notifications = notificationService?.notifications();\n\n@for (notification of notifications; track notification.id) {\n  <tds-notification\n    [closeIconButtonLabel]=\"notification.closeIconButtonLabel\"\n    [isInline]=\"false\"\n    [shouldAutoDestroyOnClose]=\"false\"\n    [status]=\"notification?.status\"\n    [@notification]=\"{value: animationName()}\"\n    (close)=\"closeNotification(notification)\">\n    @if (notification?.title; as title) {\n      <tds-notification-title>\n        <ng-container\n          [ngTemplateOutlet]=\"content\"\n          [ngTemplateOutletContext]=\"{\n            $implicit: notification.title,\n            projected: notification.title,\n          }\" />\n      </tds-notification-title>\n    }\n    <ng-container\n      [ngTemplateOutlet]=\"content\"\n      [ngTemplateOutletContext]=\"{\n        $implicit: notification,\n        projected: notification.content,\n      }\" />\n  </tds-notification>\n}\n\n<ng-template\n  #content\n  let-notification\n  let-projected=\"projected\">\n  @if (projected.template) {\n    <ng-container\n      [ngTemplateOutlet]=\"projected?.template\"\n      [ngTemplateOutletContext]=\"{\n        $implicit: notification,\n        extra: projected?.extra,\n      }\"></ng-container>\n  } @else if (projected.component) {\n    <ng-container\n      [ngComponentOutlet]=\"projected?.component\"\n      [ngComponentOutletInputs]=\"projected?.inputs\"></ng-container>\n  } @else {\n    {{ projected }}\n  }\n</ng-template>\n",
      styles: [".tds-notification{align-items:flex-start;background-color:var(--tds-local-notification-background-color);border:solid var(--tds-size-border-thin) var(--tds-local-notification-border-color);border-radius:var(--tds-size-radius-050);color:var(--tds-local-notification-foreground-color);display:flex;font:var(--tds-font-body-2);gap:var(--tds-size-spacing-200);padding:var(--tds-size-spacing-200);width:100%}.tds-notification,.tds-notification *,.tds-notification :after,.tds-notification :before{box-sizing:border-box}.tds-notification:has(.tds-notification__title:empty),.tds-notification:not(:has(.tds-notification__title)){align-items:center;padding:var(--tds-size-spacing-125) var(--tds-size-spacing-125) var(--tds-size-spacing-125) var(--tds-size-spacing-200)}.tds-notification:has(.tds-notification__title:empty) .tds-notification__close-icon,.tds-notification:not(:has(.tds-notification__title)) .tds-notification__close-icon{margin-right:0;margin-top:0}.tds-notification--toast{box-shadow:0 8px 12px #222b2d1a}.tds-notification__icon{grid-area:icon}.tds-notification__title{font:var(--tds-font-heading-6);grid-area:title}.tds-notification__title:empty{display:none}.tds-notification__body{display:flex;flex-direction:column;flex-grow:1;gap:var(--tds-size-spacing-100)}.tds-notification__content{grid-area:content}.tds-notification__content:empty{display:none}.tds-notification__close-icon.tds-icon-button{--tds-component-icon-button-color-foreground:currentColor;grid-area:close-icon;margin-right:calc(var(--tds-size-spacing-100) * -1);margin-top:calc(var(--tds-size-spacing-100) * -1)}.tds-notification,.tds-notification.tds-notification--info{--tds-local-notification-foreground-color:var(--tds-color-foreground-status-info);--tds-local-notification-background-color:var(--tds-color-background-status-info);--tds-local-notification-border-color:var(--tds-color-border-status-info)}.tds-notification.tds-notification--success{--tds-local-notification-foreground-color:var(--tds-color-foreground-status-success);--tds-local-notification-background-color:var(--tds-color-background-status-success);--tds-local-notification-border-color:var(--tds-color-border-status-success)}.tds-notification.tds-notification--danger{--tds-local-notification-foreground-color:var(--tds-color-foreground-status-danger);--tds-local-notification-background-color:var(--tds-color-background-status-danger);--tds-local-notification-border-color:var(--tds-color-border-status-danger)}.tds-notification.tds-notification--warning{--tds-local-notification-foreground-color:var(--tds-color-foreground-status-warning);--tds-local-notification-background-color:var(--tds-color-background-status-warning);--tds-local-notification-border-color:var(--tds-color-border-status-warning)}.tds-notification-container{align-items:flex-end;box-sizing:border-box;display:flex;flex-direction:column;height:calc(100dvh - var(--tds-component-header-size-height));left:0;overflow:hidden;padding:var(--tds-size-spacing-200);pointer-events:none;position:fixed;top:var(--tds-component-header-size-height);width:100%;z-index:10}.tds-notification-container *,.tds-notification-container :after,.tds-notification-container :before{box-sizing:border-box}.tds-notification-container:empty{display:none}.tds-notification-container .tds-notification{flex-shrink:0;max-width:100%;overflow:hidden;pointer-events:auto;width:440px}.tds-notification-container .tds-notification:not(:last-of-type){margin-bottom:var(--tds-size-spacing-200)}@media (width < 576px){.tds-notification-container{flex-direction:column-reverse}.tds-notification-container .tds-notification{width:100%}.tds-notification-container .tds-notification:not(:last-of-type){margin-bottom:0;margin-top:var(--tds-size-spacing-200)}}\n"]
    }]
  }], null, null);
})();
const TOGGLE_VALUE_ACCESSOR = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => ToggleComponent),
  multi: true
};
class ToggleComponent {
  defaultClass = 'tds-toggle';
  defaultHostClass = `${this.defaultClass}-host`;
  cdr = inject(ChangeDetectorRef);
  _controlValueAccessorChangeFn = () => {};
  _onTouched = () => {};
  _validatorChangeFn = () => {};
  /**
   * Toggle size
   */
  size = input();
  /**
   * Toggle id, this is required for accessibility.
   * If not set a random id constructed like this `tds-toggle-{RANDOM}` will be generated
   */
  toggleId = input();
  /**
   * Whether the toggle is checked
   * @default false
   */
  checked = model(false);
  /**
   * Whether the toggle is disabled
   * @default false
   */
  disabled = model(false);
  /**
   * Toggle name
   */
  name = input();
  /**
   * Toggle value
   */
  value = input();
  /**
   * Whether the toggle is required
   */
  required = input(false, {
    transform: booleanAttribute
  });
  /**
   * Toggle `tabindex`, is set to `-1` if toggle is disabled
   */
  tabIndex = input(undefined, {
    transform: tabIndexTransform
  });
  /**
   * If you want to display a toggle without a label,
   * it is mandatory to set an aria-label, aria-labelledby or aria-describedby
   */
  a11YAriaLabel = input();
  /**
   * If you want to display a toggle without a label,
   * it is mandatory to set an aria-label, aria-labelledby or aria-describedby
   */
  a11YAriaLabelledBy = input();
  /**
   * If you want to display a toggle without a label,
   * it is mandatory to set an aria-label, aria-labelledby or aria-describedby
   */
  a11YAriaDescribedBy = input();
  inputEl = viewChild('input');
  _id = computed(() => {
    return this.toggleId() ?? genRandomId(this.defaultClass);
  });
  _tabIndex = computed(() => {
    return this.disabled() ? -1 : this.tabIndex();
  });
  _checked = computed(() => {
    return this.checked();
  });
  _onInputClick(event) {
    event.stopPropagation();
    this.checked.update(value => !value);
    this._syncNativeInput();
    this.cdr.markForCheck();
    this._controlValueAccessorChangeFn(this.checked());
  }
  _onChangeEvent(event) {
    event.stopPropagation();
  }
  _syncNativeInput() {
    const nativeEl = this.inputEl()?.nativeElement;
    if (!nativeEl) {
      return;
    }
    // Sync the native input element
    nativeEl.checked = this._checked();
  }
  _onBlur() {
    this._onTouched();
  }
  classes = computed(() => {
    const sizeClass = this.size() && this.size() !== DEFAULT_SIZE_VALUE ? `${this.defaultClass}--${this.size()}` : '';
    return `${this.defaultClass} ${sizeClass}`;
  });
  /**
   * Implemented as part of ControlValueAccessor.
   * @ignore
   */
  registerOnChange(fn) {
    this._controlValueAccessorChangeFn = fn;
  }
  /**
   * Implemented as part of ControlValueAccessor.
   * @ignore
   */
  registerOnTouched(fn) {
    this._onTouched = fn;
  }
  /**
   * Implemented as part of ControlValueAccessor.
   * @ignore
   */
  registerOnValidatorChange(fn) {
    this._validatorChangeFn = fn;
  }
  /**
   * Implemented as part of ControlValueAccessor.
   * @ignore
   */
  setDisabledState(disabled) {
    this.disabled.set(disabled);
  }
  /**
   * Implemented as part of ControlValueAccessor.
   * @ignore
   */
  writeValue(val) {
    this.checked.set(booleanAttribute(val));
    this._syncNativeInput();
    this.cdr.markForCheck();
  }
  /**
   * Implemented as part of ControlValueAccessor.
   * @ignore
   */
  validate(control) {
    return this.required() && !control.value ? {
      required: true
    } : null;
  }
  static ɵfac = function ToggleComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || ToggleComponent)();
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: ToggleComponent,
    selectors: [["tds-toggle"]],
    viewQuery: function ToggleComponent_Query(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵviewQuerySignal(ctx.inputEl, _c8, 5);
      }
      if (rf & 2) {
        i0.ɵɵqueryAdvance();
      }
    },
    hostVars: 2,
    hostBindings: function ToggleComponent_HostBindings(rf, ctx) {
      if (rf & 2) {
        i0.ɵɵclassMap(ctx.defaultHostClass);
      }
    },
    inputs: {
      size: [1, "size"],
      toggleId: [1, "toggleId"],
      checked: [1, "checked"],
      disabled: [1, "disabled"],
      name: [1, "name"],
      value: [1, "value"],
      required: [1, "required"],
      tabIndex: [1, "tabIndex"],
      a11YAriaLabel: [1, "a11YAriaLabel"],
      a11YAriaLabelledBy: [1, "a11YAriaLabelledBy"],
      a11YAriaDescribedBy: [1, "a11YAriaDescribedBy"]
    },
    outputs: {
      checked: "checkedChange",
      disabled: "disabledChange"
    },
    standalone: true,
    features: [i0.ɵɵProvidersFeature([TOGGLE_VALUE_ACCESSOR, {
      provide: NG_VALIDATORS,
      useExisting: ToggleComponent,
      multi: true
    }]), i0.ɵɵStandaloneFeature],
    ngContentSelectors: _c4,
    decls: 7,
    vars: 14,
    consts: [["input", ""], [1, "tds-toggle__track"], [1, "tds-toggle__handle"], ["type", "checkbox", 1, "tds-toggle__input", 3, "blur", "change", "click", "checked", "disabled", "indeterminate", "required", "tabIndex"], [1, "tds-toggle__label"]],
    template: function ToggleComponent_Template(rf, ctx) {
      if (rf & 1) {
        const _r1 = i0.ɵɵgetCurrentView();
        i0.ɵɵprojectionDef();
        i0.ɵɵelementStart(0, "label")(1, "div", 1);
        i0.ɵɵelement(2, "div", 2);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(3, "input", 3, 0);
        i0.ɵɵlistener("blur", function ToggleComponent_Template_input_blur_3_listener() {
          i0.ɵɵrestoreView(_r1);
          return i0.ɵɵresetView(ctx._onBlur());
        })("change", function ToggleComponent_Template_input_change_3_listener($event) {
          i0.ɵɵrestoreView(_r1);
          return i0.ɵɵresetView(ctx._onChangeEvent($event));
        })("click", function ToggleComponent_Template_input_click_3_listener($event) {
          i0.ɵɵrestoreView(_r1);
          return i0.ɵɵresetView(ctx._onInputClick($event));
        });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(5, "div", 4);
        i0.ɵɵprojection(6);
        i0.ɵɵelementEnd()();
      }
      if (rf & 2) {
        i0.ɵɵclassMap(ctx.classes());
        i0.ɵɵattribute("for", ctx._id());
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("checked", ctx._checked())("disabled", ctx.disabled())("indeterminate", false)("required", ctx.required())("tabIndex", ctx._tabIndex());
        i0.ɵɵattribute("aria-describedby", ctx.a11YAriaDescribedBy())("aria-label", ctx.a11YAriaLabel())("aria-labelledby", ctx.a11YAriaLabelledBy())("id", ctx._id())("name", ctx.name())("value", ctx.value());
      }
    },
    styles: [".tds-toggle{--tds-local-toggle-track-bg:var(--tds-component-toggle-track-color-background-off-default);--tds-local-toggle-handle-bg:var(--tds-component-toggle-handle-color-background-default);--tds-local-toggle-handle-size-margin:calc((var(--tds-local-toggle-track-height) - var(--tds-local-toggle-handle-size))/2);--tds-local-toggle-cursor:pointer;all:unset;align-items:flex-start;color:var(--tds-color-foreground-primary);cursor:var(--tds-local-toggle-cursor);display:inline-flex;gap:var(--tds-size-spacing-100);position:relative}.tds-toggle,.tds-toggle *,.tds-toggle :after,.tds-toggle :before{box-sizing:border-box}.tds-toggle,.tds-toggle--md{--tds-local-toggle-track-width:var(--tds-component-toggle-track-size-width-default);--tds-local-toggle-track-height:var(--tds-component-toggle-track-size-height-default);--tds-local-toggle-handle-size:var(--tds-component-toggle-handle-size-default)}.tds-toggle--sm{--tds-local-toggle-track-width:var(--tds-component-toggle-track-size-width-small);--tds-local-toggle-track-height:var(--tds-component-toggle-track-size-height-small);--tds-local-toggle-handle-size:var(--tds-component-toggle-handle-size-small)}.tds-toggle__label{-webkit-font-smoothing:antialiased;cursor:var(--tds-local-toggle-cursor);font:var(--tds-font-body-2);white-space:pre-line}.tds-toggle__label:empty{display:none}.tds-toggle__input{height:0;left:0;margin:0;opacity:0;overflow:hidden;pointer-events:none;position:absolute;width:0;z-index:-1}.tds-toggle__track{align-items:center;background-color:var(--tds-local-toggle-track-bg);cursor:var(--tds-local-toggle-cursor);display:inline-flex;flex-grow:0;flex-shrink:0;height:var(--tds-local-toggle-track-height);justify-content:center;position:relative;top:calc((var(--tds-font-line-height-body-2) - var(--tds-local-toggle-track-height)) / 2);transition:background-color var(--tds-motion-duration-200) var(--tds-motion-easing-standard);width:var(--tds-local-toggle-track-width)}.tds-toggle__handle,.tds-toggle__track{border-radius:var(--tds-size-radius-rounded)}.tds-toggle__handle{background-color:var(--tds-local-toggle-handle-bg);height:var(--tds-local-toggle-handle-size);left:var(--tds-local-toggle-handle-size-margin);position:absolute;top:var(--tds-local-toggle-handle-size-margin);transition:left var(--tds-motion-duration-300) var(--tds-motion-easing-standard);width:var(--tds-local-toggle-handle-size)}.tds-toggle:hover:not(:has(input[type=checkbox]:disabled)){--tds-local-toggle-track-bg:var(--tds-component-toggle-track-color-background-off-hover)}.tds-toggle:active:not(:has(input[type=checkbox]:disabled)){--tds-local-toggle-track-bg:var(--tds-component-toggle-track-color-background-off-active)}.tds-toggle:has(input[type=checkbox]:checked){--tds-local-toggle-track-bg:var(--tds-component-toggle-track-color-background-on-default)}.tds-toggle:has(input[type=checkbox]:checked) .tds-toggle__handle{left:calc(100% - var(--tds-local-toggle-handle-size) - var(--tds-local-toggle-handle-size-margin))}.tds-toggle:has(input[type=checkbox]:checked):hover:not(:has(input[type=checkbox]:disabled)){--tds-local-toggle-track-bg:var(--tds-component-toggle-track-color-background-on-hover)}.tds-toggle:has(input[type=checkbox]:checked):active:not(:has(input[type=checkbox]:disabled)){--tds-local-toggle-track-bg:var(--tds-component-toggle-track-color-background-on-active)}.tds-toggle:has(input[type=checkbox]:focus-visible) .tds-toggle__track{outline:solid var(--tds-size-border-medium) var(--tds-color-border-focus);outline-offset:var(--tds-size-spacing-025)}.tds-toggle:has(input[type=checkbox]:disabled){--tds-local-toggle-cursor:not-allowed;opacity:var(--tds-opacity-disabled)}.tds-toggle-host{display:inline-flex}\n"],
    encapsulation: 2,
    changeDetection: 0
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ToggleComponent, [{
    type: Component,
    args: [{
      selector: 'tds-toggle',
      standalone: true,
      providers: [TOGGLE_VALUE_ACCESSOR, {
        provide: NG_VALIDATORS,
        useExisting: ToggleComponent,
        multi: true
      }],
      host: {
        '[class]': 'defaultHostClass'
      },
      changeDetection: ChangeDetectionStrategy.OnPush,
      encapsulation: ViewEncapsulation.None,
      template: "<label\n  [attr.for]=\"_id()\"\n  [class]=\"classes()\">\n  <div class=\"tds-toggle__track\">\n    <div class=\"tds-toggle__handle\"></div>\n  </div>\n  <input\n    #input\n    class=\"tds-toggle__input\"\n    type=\"checkbox\"\n    [attr.aria-describedby]=\"a11YAriaDescribedBy()\"\n    [attr.aria-label]=\"a11YAriaLabel()\"\n    [attr.aria-labelledby]=\"a11YAriaLabelledBy()\"\n    [attr.id]=\"_id()\"\n    [attr.name]=\"name()\"\n    [attr.value]=\"value()\"\n    [checked]=\"_checked()\"\n    [disabled]=\"disabled()\"\n    [indeterminate]=\"false\"\n    [required]=\"required()\"\n    [tabIndex]=\"_tabIndex()\"\n    (blur)=\"_onBlur()\"\n    (change)=\"_onChangeEvent($event)\"\n    (click)=\"_onInputClick($event)\" />\n  <div class=\"tds-toggle__label\">\n    <ng-content></ng-content>\n  </div>\n</label>\n",
      styles: [".tds-toggle{--tds-local-toggle-track-bg:var(--tds-component-toggle-track-color-background-off-default);--tds-local-toggle-handle-bg:var(--tds-component-toggle-handle-color-background-default);--tds-local-toggle-handle-size-margin:calc((var(--tds-local-toggle-track-height) - var(--tds-local-toggle-handle-size))/2);--tds-local-toggle-cursor:pointer;all:unset;align-items:flex-start;color:var(--tds-color-foreground-primary);cursor:var(--tds-local-toggle-cursor);display:inline-flex;gap:var(--tds-size-spacing-100);position:relative}.tds-toggle,.tds-toggle *,.tds-toggle :after,.tds-toggle :before{box-sizing:border-box}.tds-toggle,.tds-toggle--md{--tds-local-toggle-track-width:var(--tds-component-toggle-track-size-width-default);--tds-local-toggle-track-height:var(--tds-component-toggle-track-size-height-default);--tds-local-toggle-handle-size:var(--tds-component-toggle-handle-size-default)}.tds-toggle--sm{--tds-local-toggle-track-width:var(--tds-component-toggle-track-size-width-small);--tds-local-toggle-track-height:var(--tds-component-toggle-track-size-height-small);--tds-local-toggle-handle-size:var(--tds-component-toggle-handle-size-small)}.tds-toggle__label{-webkit-font-smoothing:antialiased;cursor:var(--tds-local-toggle-cursor);font:var(--tds-font-body-2);white-space:pre-line}.tds-toggle__label:empty{display:none}.tds-toggle__input{height:0;left:0;margin:0;opacity:0;overflow:hidden;pointer-events:none;position:absolute;width:0;z-index:-1}.tds-toggle__track{align-items:center;background-color:var(--tds-local-toggle-track-bg);cursor:var(--tds-local-toggle-cursor);display:inline-flex;flex-grow:0;flex-shrink:0;height:var(--tds-local-toggle-track-height);justify-content:center;position:relative;top:calc((var(--tds-font-line-height-body-2) - var(--tds-local-toggle-track-height)) / 2);transition:background-color var(--tds-motion-duration-200) var(--tds-motion-easing-standard);width:var(--tds-local-toggle-track-width)}.tds-toggle__handle,.tds-toggle__track{border-radius:var(--tds-size-radius-rounded)}.tds-toggle__handle{background-color:var(--tds-local-toggle-handle-bg);height:var(--tds-local-toggle-handle-size);left:var(--tds-local-toggle-handle-size-margin);position:absolute;top:var(--tds-local-toggle-handle-size-margin);transition:left var(--tds-motion-duration-300) var(--tds-motion-easing-standard);width:var(--tds-local-toggle-handle-size)}.tds-toggle:hover:not(:has(input[type=checkbox]:disabled)){--tds-local-toggle-track-bg:var(--tds-component-toggle-track-color-background-off-hover)}.tds-toggle:active:not(:has(input[type=checkbox]:disabled)){--tds-local-toggle-track-bg:var(--tds-component-toggle-track-color-background-off-active)}.tds-toggle:has(input[type=checkbox]:checked){--tds-local-toggle-track-bg:var(--tds-component-toggle-track-color-background-on-default)}.tds-toggle:has(input[type=checkbox]:checked) .tds-toggle__handle{left:calc(100% - var(--tds-local-toggle-handle-size) - var(--tds-local-toggle-handle-size-margin))}.tds-toggle:has(input[type=checkbox]:checked):hover:not(:has(input[type=checkbox]:disabled)){--tds-local-toggle-track-bg:var(--tds-component-toggle-track-color-background-on-hover)}.tds-toggle:has(input[type=checkbox]:checked):active:not(:has(input[type=checkbox]:disabled)){--tds-local-toggle-track-bg:var(--tds-component-toggle-track-color-background-on-active)}.tds-toggle:has(input[type=checkbox]:focus-visible) .tds-toggle__track{outline:solid var(--tds-size-border-medium) var(--tds-color-border-focus);outline-offset:var(--tds-size-spacing-025)}.tds-toggle:has(input[type=checkbox]:disabled){--tds-local-toggle-cursor:not-allowed;opacity:var(--tds-opacity-disabled)}.tds-toggle-host{display:inline-flex}\n"]
    }]
  }], null, null);
})();

/**
 * TOGGLE_SIZES is an array of all the toggle sizes available. Used to define `ToggleSize` union type. Useful for looping through all possible sizes.
 */
const TOGGLE_SIZES = ['sm', 'md'];
class SegmentedControlOptionComponent {
  defaultClass = 'tds-segmented-control-option';
  segmentedControlComponent = inject(SegmentedControlComponent, {
    optional: true
  });
  /**
   * Whether the option is currently selected in the segmented control.
   */
  isSelected() {
    return this.segmentedControlComponent?.selectedOption() === this;
  }
  setSelected() {
    this.segmentedControlComponent?.updateSelectedOption(this);
  }
  classes = computed(() => {
    const isSelectedClass = this.isSelected() ? `${this.defaultClass}--selected` : '';
    return `${this.defaultClass} ${isSelectedClass}`;
  });
  static ɵfac = function SegmentedControlOptionComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || SegmentedControlOptionComponent)();
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: SegmentedControlOptionComponent,
    selectors: [["button", "tds-segmented-control-option", ""]],
    hostVars: 2,
    hostBindings: function SegmentedControlOptionComponent_HostBindings(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵlistener("click", function SegmentedControlOptionComponent_click_HostBindingHandler() {
          return ctx.setSelected();
        });
      }
      if (rf & 2) {
        i0.ɵɵclassMap(ctx.classes());
      }
    },
    standalone: true,
    features: [i0.ɵɵStandaloneFeature],
    attrs: _c46,
    ngContentSelectors: _c2,
    decls: 2,
    vars: 0,
    template: function SegmentedControlOptionComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵprojectionDef(_c1);
        i0.ɵɵprojection(0);
        i0.ɵɵprojection(1, 1);
      }
    },
    styles: [".tds-segmented-control-option{all:unset;align-items:center;border-radius:var(--tds-size-radius-025);box-sizing:border-box;color:var(--tds-color-foreground-secondary);cursor:pointer;display:inline-flex;flex:1;font:var(--tds-font-body-2);font-weight:var(--tds-font-weight-600);justify-content:center;min-height:32px;padding:var(--tds-size-spacing-050) var(--tds-size-spacing-200)}.tds-segmented-control-option *,.tds-segmented-control-option :after,.tds-segmented-control-option :before{box-sizing:border-box}.tds-segmented-control-option:focus-visible{outline:solid var(--tds-size-border-medium) var(--tds-color-border-focus);outline-offset:0}.tds-segmented-control-option:has(.tds-icon){gap:var(--tds-size-spacing-050)}.tds-segmented-control-option:not(.tds-segmented-control-option--selected):not(:disabled):hover{background:var(--tds-component-segmented-control-option-color-background-hover)}.tds-segmented-control-option--selected{background:var(--tds-component-segmented-control-option-color-background-selected);color:var(--tds-color-foreground-primary)}.tds-segmented-control-option .tds-icon{--tds-local-icon-size:var(--tds-component-icon-size-sm);--tds-local-icon-color-text:inherit}.tds-segmented-control-option:disabled{cursor:not-allowed;opacity:var(--tds-opacity-disabled)}\n"],
    encapsulation: 2,
    changeDetection: 0
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SegmentedControlOptionComponent, [{
    type: Component,
    args: [{
      selector: 'button[tds-segmented-control-option]',
      standalone: true,
      host: {
        '[class]': 'classes()',
        '(click)': 'setSelected()'
      },
      changeDetection: ChangeDetectionStrategy.OnPush,
      encapsulation: ViewEncapsulation.None,
      template: "<ng-content select=\"tds-icon\" />\n<ng-content />\n",
      styles: [".tds-segmented-control-option{all:unset;align-items:center;border-radius:var(--tds-size-radius-025);box-sizing:border-box;color:var(--tds-color-foreground-secondary);cursor:pointer;display:inline-flex;flex:1;font:var(--tds-font-body-2);font-weight:var(--tds-font-weight-600);justify-content:center;min-height:32px;padding:var(--tds-size-spacing-050) var(--tds-size-spacing-200)}.tds-segmented-control-option *,.tds-segmented-control-option :after,.tds-segmented-control-option :before{box-sizing:border-box}.tds-segmented-control-option:focus-visible{outline:solid var(--tds-size-border-medium) var(--tds-color-border-focus);outline-offset:0}.tds-segmented-control-option:has(.tds-icon){gap:var(--tds-size-spacing-050)}.tds-segmented-control-option:not(.tds-segmented-control-option--selected):not(:disabled):hover{background:var(--tds-component-segmented-control-option-color-background-hover)}.tds-segmented-control-option--selected{background:var(--tds-component-segmented-control-option-color-background-selected);color:var(--tds-color-foreground-primary)}.tds-segmented-control-option .tds-icon{--tds-local-icon-size:var(--tds-component-icon-size-sm);--tds-local-icon-color-text:inherit}.tds-segmented-control-option:disabled{cursor:not-allowed;opacity:var(--tds-opacity-disabled)}\n"]
    }]
  }], null, null);
})();
class SegmentedControlComponent {
  defaultClass = 'tds-segmented-control';
  // We need to use forwardRef here because SegmentedControlOptionComponent is defined after SegmentedControlComponent
  options = contentChildren(forwardRef(() => SegmentedControlOptionComponent), {
    descendants: true
  });
  /**
   * @ignore
   */
  selectedOption = signal(undefined);
  /**
   * Index of selected option, when set it will select the option at the given index without triggering the valueChange event.
   * @default 0 - First option is selected by default.
   */
  selectedIndex = model(0);
  /**
   * Output event emitted when selected option changes.
   * Emits the index of the newly selected option.
   */
  selectedIndexChange = output();
  constructor() {
    effect(() => {
      const selectedIndex = this.selectedIndex() ?? 0;
      this.selectedOption.set(this.options()?.[selectedIndex]);
    }, {
      allowSignalWrites: true
    });
  }
  /**
   * @ignore
   */
  updateSelectedOption(option) {
    if (this.selectedOption() === option) {
      return;
    }
    this.selectedOption.set(option);
    const index = this.options()?.findIndex(opt => opt === option);
    if (index <= -1) {
      return;
    }
    this.selectedIndexChange.emit(index);
  }
  static ɵfac = function SegmentedControlComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || SegmentedControlComponent)();
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: SegmentedControlComponent,
    selectors: [["tds-segmented-control"]],
    contentQueries: function SegmentedControlComponent_ContentQueries(rf, ctx, dirIndex) {
      if (rf & 1) {
        i0.ɵɵcontentQuerySignal(dirIndex, ctx.options, SegmentedControlOptionComponent, 5);
      }
      if (rf & 2) {
        i0.ɵɵqueryAdvance();
      }
    },
    hostVars: 2,
    hostBindings: function SegmentedControlComponent_HostBindings(rf, ctx) {
      if (rf & 2) {
        i0.ɵɵclassMap(ctx.defaultClass);
      }
    },
    inputs: {
      selectedIndex: [1, "selectedIndex"]
    },
    outputs: {
      selectedIndex: "selectedIndexChange",
      selectedIndexChange: "selectedIndexChange"
    },
    standalone: true,
    features: [i0.ɵɵStandaloneFeature],
    ngContentSelectors: _c4,
    decls: 1,
    vars: 0,
    template: function SegmentedControlComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵprojection(0);
      }
    },
    styles: [".tds-layer .tds-segmented-control,.tds-layer--100 .tds-segmented-control,.tds-layer--auto .tds-segmented-control{--tds-component-segmented-control-color-background:var(--tds-private-color-segmented-control-200)}.tds-layer .tds-layer:not(.tds-layer--100):not(.tds-layer--200) .tds-segmented-control,.tds-layer--200 .tds-segmented-control{--tds-component-segmented-control-color-background:var(--tds-private-color-segmented-control-300)}.tds-segmented-control{all:unset;box-sizing:border-box;--tds-component-segmented-control-color-background:var(--tds-private-color-segmented-control-100);align-items:center;background:var(--tds-component-segmented-control-color-background);border-radius:var(--tds-size-radius-050);display:inline-flex;gap:var(--tds-size-spacing-050);padding:var(--tds-size-spacing-050);width:100%}.tds-segmented-control *,.tds-segmented-control :after,.tds-segmented-control :before{box-sizing:border-box}\n"],
    encapsulation: 2,
    changeDetection: 0
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SegmentedControlComponent, [{
    type: Component,
    args: [{
      selector: 'tds-segmented-control',
      standalone: true,
      host: {
        '[class]': 'defaultClass'
      },
      changeDetection: ChangeDetectionStrategy.OnPush,
      encapsulation: ViewEncapsulation.None,
      template: "<ng-content />\n",
      styles: [".tds-layer .tds-segmented-control,.tds-layer--100 .tds-segmented-control,.tds-layer--auto .tds-segmented-control{--tds-component-segmented-control-color-background:var(--tds-private-color-segmented-control-200)}.tds-layer .tds-layer:not(.tds-layer--100):not(.tds-layer--200) .tds-segmented-control,.tds-layer--200 .tds-segmented-control{--tds-component-segmented-control-color-background:var(--tds-private-color-segmented-control-300)}.tds-segmented-control{all:unset;box-sizing:border-box;--tds-component-segmented-control-color-background:var(--tds-private-color-segmented-control-100);align-items:center;background:var(--tds-component-segmented-control-color-background);border-radius:var(--tds-size-radius-050);display:inline-flex;gap:var(--tds-size-spacing-050);padding:var(--tds-size-spacing-050);width:100%}.tds-segmented-control *,.tds-segmented-control :after,.tds-segmented-control :before{box-sizing:border-box}\n"]
    }]
  }], () => [], null);
})();

/*
 * Public API Surface of @totalenergiescode/tds-angular
 */

/**
 * Generated bundle index. Do not edit.
 */

export { ACCENT_VARIANTS, ASPECT_RATIOS, AppShellComponent, BUTTON_HOST, BUTTON_SIZES, BUTTON_VARIANTS, ButtonComponent, CHECKBOX_VALUE_ACCESSOR, CUSTOM_CDK_BREAKPOINTS, CheckboxComponent, DEFAULT_NOTIFICATION_DURATION, DatatableTemplateCellRendererComponent, DatatableThemeDirective, FieldErrorDirective, FieldHintDirective, FieldsetComponent, FieldsetLabelDirective, FieldsetModule, FormFieldComponent, FormFieldItemDirective, FormFieldLabelDirective, FormFieldModule, FormFieldSuffixDirective, HeaderAppLogoDirective, HeaderAppNameComponent, HeaderCenterDirective, HeaderComponent, HeaderEndDirective, HeaderMobileMenuActionComponent, HeaderMobileMenuComponent, HeaderMobileMenuEndDirective, HeaderMobileMenuStartDirective, HeaderModule, HeaderNavigationComponent, HeaderNavigationLinkComponent, ICON_BUTTON_SIZES, ICON_SIZES, ICON_VARIANTS, IconButtonComponent, IconComponent, LAYER_HOST, LAYER_VARIANTS, LINK_HOST, LINK_SIZES, LayerComponent, LinkComponent, NOTIFICATION_STATUSES, NotificationComponent, NotificationContainerComponent, NotificationService, NotificationTitleDirective, ORIENTATIONS, RadioComponent, RadioInputDirective, RadioLabelDirective, RadioModule, SIZES, STATUS_VARIANTS, SearchComponent, SearchInputDirective, SegmentedControlComponent, SegmentedControlOptionComponent, TAG_VARIANTS, TDS_BREAKPOINTS, TDS_THEME_SERVICE_OPTIONS, THEMES, TOGGLE_SIZES, TOGGLE_VALUE_ACCESSOR, TYPOGRAPHY_VARIANTS, TYPO_HOST, TagComponent, ThemeService, TileComponent, TileImageDirective, TileModule, TileTitleDirective, ToggleComponent, TypographyComponent, VARIANTS };
